(() => {
  const DESIGN_PREVIEW_PROPERTY = 'Tasarım Önizleme';
  const DESIGN_FILE_PROPERTY = 'Tasarım Dosyası';
  const EXPORT_DPI = 300;
  const COLLAGE_EXPORT_DPI = 600;
  const NAMEPLATE_EXPORT_DPI = 600;
  const EXPORT_SCALE = 3;
  const MAP_EXPORT_SCALE = 8;
  const JPEG_QUALITY = 0.98;
  const HTML2CANVAS_FILE = 'html2canvas.min.js';
  const DEFAULT_UPLOAD_ENDPOINT = 'https://renao-design-files.renaogift.workers.dev/api/design-files';

  const MAP_PRINT_SIZES_CM = {
    ymap: { width: 13.2, height: 18.2, fit: 'cover' },
    mapplaket: { width: 18.2, height: 6.2, fit: 'cover' },
    bmap: { width: 10.2, height: 15.2, fit: 'cover' },
    maptablo: { width: 29.7, height: 42, fit: 'cover' },
  };

  const NAMEPLATE_PRINT_SIZE_CM = { width: 18.2, height: 6.2, fit: 'cover' };
  const COLLAGE_PRINT_SIZES_CM = {
    'bizim-olayimiz': { width: 10.3, height: 15.3, fit: 'contain' },
    'yan-yana-magazin': { width: 10.3, height: 15.3, fit: 'contain' },
    'arkadas': { width: 13, height: 18, fit: 'contain' },
    'arkadas2': { width: 10, height: 15, fit: 'contain' },
    'ark2': { width: 10.3, height: 15.3, fit: 'contain' },
    'ark3': { width: 10.3, height: 15.3, fit: 'contain' },
    'suc': { width: 10.3, height: 15.3, fit: 'contain' },
    'arkadas3': { width: 10.3, height: 15.3, fit: 'contain' },
    'zarif-arkadas3': { width: 13.3, height: 18.3, fit: 'contain' },
    'zarif-bizim-olayimiz': { width: 13.3, height: 18.3, fit: 'contain' },
    'zarif-yan-yana-magazin': { width: 13.3, height: 18.3, fit: 'contain' },
    'zarif-ark3': { width: 13.3, height: 18.3, fit: 'contain' },
    'zarif-ark2': { width: 13.3, height: 18.3, fit: 'contain' },
    'zarif-suc': { width: 13.3, height: 18.3, fit: 'contain' },
    'zarif-dikey-6': { width: 13.3, height: 18.3, fit: 'contain' },
    'babazarif': { width: 13.3, height: 18.3, fit: 'contain' },
    'zarif-dikey-3': { width: 13.3, height: 18.3, fit: 'contain' },
    'en-guzel-uc-animiz-zarif-model': { width: 13.3, height: 18.3, fit: 'contain' },
    'zarif-yatay-3': { width: 18.3, height: 13.3, fit: 'contain' },
    'premium-yatay-3': { width: 18.3, height: 13.3, fit: 'contain' },
    'birlikte-biriktirdiklerimiz-6-li-kolaj': { width: 10.3, height: 15.3, fit: 'contain' },
    'babapremium6': { width: 10.3, height: 15.3, fit: 'contain' },
    'zrfk': { width: 10.3, height: 15.3, fit: 'contain' },
    'annelergunuzarif2': { width: 13.2, height: 18.2, fit: 'contain' },
    'bebe4': { width: 10, height: 15, fit: 'contain' },
    'bebe3': { width: 10, height: 15, fit: 'contain' },
    'bebe2': { width: 10, height: 15, fit: 'contain' },
    'bebe': { width: 15, height: 10, fit: 'contain' },
  };

  const PERSONALIZER_SELECTOR = [
    '[data-renao-personalizer]',
    '[data-renao-music-personalizer]',
    '[data-renao-collage-personalizer]',
    '[data-renao-netflix-personalizer]',
    '[data-renao-nameplate-personalizer]',
    '[data-renao-iyiki-personalizer]',
    '[data-renao-qr-personalizer]',
    '[data-renao-heart-photo-personalizer]',
  ].join(',');

  const PREVIEW_SELECTOR = [
    '[data-renao-preview-stage]',
    '[data-renao-music-preview]',
    '[data-renao-collage-preview]',
    '[data-renao-netflix-preview]',
    '[data-renao-nameplate-preview]',
    '[data-renao-iyiki-preview]',
    '[data-renao-qr-preview]',
    '[data-renao-heart-photo-preview]',
  ].join(',');

  const PRINT_TARGET_SELECTOR = [
    '.renao-map-poster',
    '.renao-nameplate',
    '.renao-music-poster',
    '.renao-collage-plaque',
    '.renao-zrfk-poster',
    '.renao-iyiki-poster',
    '[data-renao-netflix-poster]',
    '.renao-qr-poster',
    '.renao-heart-photo-card',
  ].join(',');

  const PROOF_OPEN_SELECTOR = [
    '[data-renao-focus-preview]',
    '[data-renao-proof-open]',
    '[data-renao-nameplate-proof-open]',
    '[data-renao-music-proof-open]',
    '[data-renao-collage-proof-open]',
    '[data-renao-netflix-proof-open]',
    '[data-renao-iyiki-proof-open]',
    '[data-renao-qr-proof-open]',
    '[data-renao-heart-proof-open]',
  ].join(',');

  const PROOF_MODAL_SELECTOR = [
    '[data-renao-proof-modal]',
    '[data-renao-nameplate-proof-modal]',
    '[data-renao-music-proof-modal]',
    '[data-renao-collage-proof-modal]',
    '[data-renao-netflix-proof-modal]',
    '[data-renao-iyiki-proof-modal]',
    '[data-renao-qr-proof-modal]',
    '[data-renao-heart-proof-modal]',
  ].join(',');

  const PROOF_CLOSE_SELECTOR = [
    '[data-renao-proof-close]',
    '[data-renao-nameplate-proof-close]',
    '[data-renao-music-proof-close]',
    '[data-renao-collage-proof-close]',
    '[data-renao-netflix-proof-close]',
    '[data-renao-iyiki-proof-close]',
    '[data-renao-qr-proof-close]',
    '[data-renao-heart-proof-close]',
  ].join(',');

  let html2canvasPromise;
  let exportStyleElement;
  let proofScrollLock = null;
  let proofAspectFrame = 0;
  let proofResizeObserver = null;
  let pdfWorker = null;
  let pdfWorkerSequence = 0;
  const pdfWorkerPending = new Map();
  const preparationStates = new WeakMap();
  let clientRendererFramePromise = null;

  const normalizeWhitespace = (value) => String(value ?? '').replace(/\s+/g, ' ').trim();

  const isMobileProofViewport = () => window.matchMedia('(max-width: 749px)').matches;

  const hasOpenProofModal = () => (
    document.documentElement.classList.contains('renao-proof-modal-open')
    || document.documentElement.classList.contains('renao-modal-open')
  );

  const releaseProofScrollLock = () => {
    if (!proofScrollLock) return;
    const { scrollY, styles } = proofScrollLock;
    proofScrollLock = null;
    document.body.style.position = styles.position;
    document.body.style.top = styles.top;
    document.body.style.left = styles.left;
    document.body.style.right = styles.right;
    document.body.style.width = styles.width;
    document.body.style.overflow = styles.overflow;
    window.scrollTo(0, scrollY);
  };

  const lockProofTargetAspect = (modal) => {
    if (!modal || modal.hidden) return false;
    const proofStage = modal.querySelector('.renao-proof-modal__stage');
    const target = proofStage?.querySelector(PRINT_TARGET_SELECTOR)
      || modal.querySelector(PRINT_TARGET_SELECTOR);
    if (!target) return false;

    proofResizeObserver?.observe(proofStage || modal);
    proofResizeObserver?.observe(target);

    const ratioValue = String(window.getComputedStyle(target).aspectRatio || '').trim();
    const ratioParts = ratioValue.split('/').map((value) => Number.parseFloat(value));
    const ratio = ratioParts.length === 2 && ratioParts.every((value) => Number.isFinite(value) && value > 0)
      ? ratioParts[0] / ratioParts[1]
      : Number.parseFloat(ratioValue);
    if (!Number.isFinite(ratio) || ratio <= 0) return false;

    const width = target.getBoundingClientRect().width;
    if (!Number.isFinite(width) || width <= 0) return false;
    const lockedHeight = width / ratio;
    if (Math.abs(target.getBoundingClientRect().height - lockedHeight) > 0.25) {
      target.style.setProperty('height', `${lockedHeight}px`, 'important');
    }
    target.style.setProperty('min-height', '0', 'important');
    target.dataset.renaoProofAspectLocked = 'true';
    return true;
  };

  const scheduleProofAspectLock = () => {
    if (proofAspectFrame) window.cancelAnimationFrame(proofAspectFrame);
    proofAspectFrame = window.requestAnimationFrame(() => {
      proofAspectFrame = window.requestAnimationFrame(() => {
        proofAspectFrame = 0;
        document.querySelectorAll(PROOF_MODAL_SELECTOR).forEach(lockProofTargetAspect);
      });
    });
  };

  const syncProofScrollLock = () => {
    scheduleProofAspectLock();
    if (!hasOpenProofModal() || !isMobileProofViewport()) {
      releaseProofScrollLock();
      return;
    }

    if (proofScrollLock) return;
    const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
    proofScrollLock = {
      scrollY,
      styles: {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        right: document.body.style.right,
        width: document.body.style.width,
        overflow: document.body.style.overflow,
      },
    };
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  };

  const initProofScrollLock = () => {
    if (typeof ResizeObserver !== 'undefined') {
      proofResizeObserver = new ResizeObserver(scheduleProofAspectLock);
    }
    const observer = new MutationObserver(syncProofScrollLock);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', () => window.requestAnimationFrame(syncProofScrollLock), { passive: true });
    window.addEventListener('orientationchange', () => window.requestAnimationFrame(syncProofScrollLock), { passive: true });
    syncProofScrollLock();
  };

  const slugify = (value) => normalizeWhitespace(value)
    .toLocaleLowerCase('tr-TR')
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ı/g, 'i')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 48) || 'tasarim';

  const getCurrentScript = () => (
    document.currentScript ||
    document.querySelector(
      'script[src*="/assets/renao-design-file.js"], script[src*="/assets/renao-design-file-transparent.js"]'
    )
  );

  const getAssetUrl = (fileName) => {
    const currentScript = getCurrentScript();
    return currentScript?.src ? new URL(fileName, currentScript.src).href : fileName;
  };

  const getPdfWorker = () => {
    if (pdfWorker) return pdfWorker;
    if (typeof Worker === 'undefined') return null;

    pdfWorker = new Worker(getAssetUrl('renao-pdf-worker-v4.js'), { name: 'renao-pdf' });
    pdfWorker.addEventListener('message', (event) => {
      const pending = pdfWorkerPending.get(event.data?.id);
      if (!pending) return;
      pdfWorkerPending.delete(event.data.id);
      if (event.data.ok) pending.resolve(event.data.result);
      else pending.reject(new Error(event.data.error || 'PDF worker failed.'));
    });
    pdfWorker.addEventListener('error', (event) => {
      const error = new Error(event.message || 'PDF worker could not be loaded.');
      pdfWorkerPending.forEach(({ reject }) => reject(error));
      pdfWorkerPending.clear();
      pdfWorker?.terminate();
      pdfWorker = null;
    });
    return pdfWorker;
  };

  const runPdfWorker = (type, payload, transfers = []) => {
    const worker = getPdfWorker();
    if (!worker) return Promise.reject(new Error('PDF worker is not supported.'));
    const id = ++pdfWorkerSequence;
    return new Promise((resolve, reject) => {
      pdfWorkerPending.set(id, { resolve, reject });
      worker.postMessage({ id, type, payload }, transfers);
    });
  };

  const getUploadEndpoint = () => {
    const currentScript = getCurrentScript();
    const endpoint = window.RenaoDesignFileUploadEndpoint || currentScript?.dataset?.renaoDesignFileUploadEndpoint || '';
    return String(endpoint || DEFAULT_UPLOAD_ENDPOINT).trim();
  };

  const getBrowserRenderEndpoint = () => {
    const uploadEndpoint = getUploadEndpoint();
    if (!uploadEndpoint) return '';
    const url = new URL(uploadEndpoint, window.location.href);
    url.pathname = url.pathname.replace(/\/api\/design-files\/?$/, '/api/render-design-pdf');
    return url.toString();
  };

  const getClientRendererUrl = () => {
    const endpoint = getBrowserRenderEndpoint();
    if (!endpoint) return '';
    const url = new URL(endpoint, window.location.href);
    url.pathname = '/client-renderer';
    url.search = '?v=4';
    return url.toString();
  };

  const getClientRendererFrame = () => {
    if (clientRendererFramePromise) return clientRendererFramePromise;
    const rendererUrl = getClientRendererUrl();
    if (!rendererUrl) return Promise.reject(new Error('Client renderer URL is not configured.'));
    clientRendererFramePromise = new Promise((resolve, reject) => {
      const frame = document.createElement('iframe');
      frame.title = '';
      frame.tabIndex = -1;
      frame.setAttribute('aria-hidden', 'true');
      frame.style.cssText = 'position:fixed;left:-10000px;top:0;width:1px;height:1px;border:0;opacity:0;pointer-events:none;z-index:-2147483647';
      const timeout = window.setTimeout(() => reject(new Error('Client renderer could not be loaded.')), 8000);
      frame.onload = () => {
        window.clearTimeout(timeout);
        resolve(frame);
      };
      frame.onerror = () => {
        window.clearTimeout(timeout);
        reject(new Error('Client renderer could not be loaded.'));
      };
      frame.src = rendererUrl;
      document.body.appendChild(frame);
    }).catch((error) => {
      clientRendererFramePromise = null;
      throw error;
    });
    return clientRendererFramePromise;
  };

  const renderJpegInClientFrame = async ({ html, width, height }) => {
    const frame = await getClientRendererFrame();
    frame.style.width = `${Math.ceil(width)}px`;
    frame.style.height = `${Math.ceil(height)}px`;
    const rendererUrl = new URL(getClientRendererUrl());
    const channel = new MessageChannel();
    const result = new Promise((resolve, reject) => {
      const timeout = window.setTimeout(() => reject(new Error('Client renderer timed out.')), 30000);
      channel.port1.onmessage = (event) => {
        if (event.data?.progress) {
          if (window.location.search.includes('renao_local_test=1')) console.debug('Renao client renderer:', event.data.progress);
          return;
        }
        window.clearTimeout(timeout);
        channel.port1.close();
        if (event.data?.ok) resolve(event.data.result);
        else reject(new Error(event.data?.error || 'Client renderer failed.'));
      };
    });
    frame.contentWindow.postMessage({
      type: 'renao-render-jpeg',
      payload: {
        html,
        width,
        height,
        html2canvasUrl: getAssetUrl(HTML2CANVAS_FILE),
        scale: EXPORT_SCALE,
        quality: JPEG_QUALITY,
      },
    }, rendererUrl.origin, [channel.port2]);
    return result;
  };

  const loadHtml2Canvas = () => {
    if (window.html2canvas) return Promise.resolve(window.html2canvas);
    if (html2canvasPromise) return html2canvasPromise;

    html2canvasPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = getAssetUrl(HTML2CANVAS_FILE);
      script.async = true;
      script.onload = () => window.html2canvas ? resolve(window.html2canvas) : reject(new Error('html2canvas yüklenemedi.'));
      script.onerror = () => reject(new Error('html2canvas dosyası yüklenemedi.'));
      document.head.appendChild(script);
    });

    return html2canvasPromise;
  };

  const ensureExportStyle = () => {
    if (exportStyleElement) return;
    exportStyleElement = document.createElement('style');
    exportStyleElement.textContent = [
      'html.renao-design-exporting .renao-proof-modal { opacity: 0 !important; pointer-events: none !important; }',
      'html.renao-design-exporting.renao-proof-modal-open { overflow: auto !important; }',
      '.renao-capture-shell--design .renao-design-print-target { box-shadow: none !important; outline: 0 !important; backdrop-filter: none !important; }',
      '.renao-capture-shell--design .renao-design-print-target::before, .renao-capture-shell--design .renao-design-print-target::after { box-shadow: none !important; }',
      '.renao-capture-shell--design .renao-music-poster.renao-design-print-target { background: transparent !important; border-color: transparent !important; box-shadow: none !important; }',
      '.renao-capture-shell .renao-map-poster.renao-design-print-target { background: transparent !important; border-color: transparent !important; box-shadow: none !important; }',
      '.renao-capture-shell[data-renao-product-handle="maptablo"] .renao-map-poster.renao-design-print-target { background: #ffffff !important; }',
      '.renao-capture-shell .renao-map-poster.renao-design-print-target::before, .renao-capture-shell .renao-map-poster.renao-design-print-target::after { content: none !important; box-shadow: none !important; }',
      '.renao-capture-shell[data-renao-product-handle="maptablo"][data-renao-shape="full"] .renao-map-poster__map { left: 0 !important; top: 0 !important; width: 100% !important; height: 66.1% !important; }',
      // Map PDFs must use one print layout on every device. The responsive
      // storefront rules otherwise make orders placed around tablet widths use
      // smaller type and different vertical spacing than the customer's proof.
      // Portrait map products need a fixed lower copy panel for device-invariant
      // exports. Mapplaket is a separate 182x62 landscape layout, so applying
      // these portrait rules to it pushes the city and coordinates off-canvas.
      '.renao-capture-shell:not([data-renao-product-handle="mapplaket"]):not([data-renao-product-handle="maptablo"]) .renao-map-poster__copy { top: 66.2% !important; bottom: 6.8% !important; background: transparent !important; }',
      '.renao-capture-shell:not([data-renao-product-handle="mapplaket"]) .renao-map-poster__copy > * { max-height: 8rem !important; }',
      '.renao-capture-shell:not([data-renao-product-handle="mapplaket"]) .renao-map-poster__date { padding-top: 0.12em !important; font-size: 1.95rem !important; line-height: 1.08 !important; }',
      '.renao-capture-shell:not([data-renao-product-handle="mapplaket"]) .renao-map-poster__title { margin-top: 2.3% !important; font-size: 2.78rem !important; line-height: 0.94 !important; }',
      '.renao-capture-shell:not([data-renao-product-handle="mapplaket"])[data-renao-title-font="decorative"] .renao-map-poster__title { font-size: 2.26rem !important; }',
      '.renao-capture-shell:not([data-renao-product-handle="mapplaket"]) .renao-map-poster__names { margin-top: 9.1% !important; font-size: 2.28rem !important; line-height: 1.18 !important; }',
      '.renao-capture-shell:not([data-renao-product-handle="mapplaket"])[data-renao-font="signature"] .renao-map-poster__names { margin-top: 7.15% !important; font-size: 2.28rem !important; line-height: 1.18 !important; }',
      '.renao-capture-shell:not([data-renao-product-handle="mapplaket"])[data-renao-font="bold"] .renao-map-poster__names { margin-top: 4.4% !important; font-size: 3.25rem !important; line-height: 1 !important; }',
      '.renao-capture-shell:not([data-renao-product-handle="mapplaket"])[data-renao-font="soft"] .renao-map-poster__names { margin-top: 4.4% !important; font-size: 4.7rem !important; line-height: 0.82 !important; }',
      '.renao-capture-shell:not([data-renao-product-handle="mapplaket"]) .renao-map-poster__city { margin-top: 4.9% !important; font-size: 2.16rem !important; line-height: 1 !important; }',
      '.renao-capture-shell:not([data-renao-product-handle="mapplaket"])[data-renao-font="signature"] .renao-map-poster__city { margin-top: 2.9% !important; }',
      '.renao-capture-shell:not([data-renao-product-handle="mapplaket"])[data-renao-font="bold"] .renao-map-poster__city, .renao-capture-shell:not([data-renao-product-handle="mapplaket"])[data-renao-font="soft"] .renao-map-poster__city { margin-top: 3.2% !important; }',
      '.renao-capture-shell:not([data-renao-product-handle="mapplaket"]) .renao-map-poster__coords { margin-top: 1.25% !important; font-size: 1.68rem !important; line-height: 1.08 !important; }',
      // The A3 poster is a borderless paper print. Keep its storefront proof and
      // both generated PDFs on the same compact white lower panel.
      '.renao-capture-shell[data-renao-product-handle="maptablo"] .renao-map-poster.renao-design-print-target { padding: 0 !important; border-radius: 0 !important; background: #ffffff !important; box-shadow: none !important; }',
      '.renao-capture-shell[data-renao-product-handle="maptablo"] .renao-map-poster__copy { left: 0 !important; right: 0 !important; top: 66% !important; bottom: 6.8% !important; z-index: 7 !important; display: flex !important; box-sizing: border-box !important; padding-inline: 6.4% !important; background: #ffffff !important; }',
      '.renao-capture-shell[data-renao-product-handle="maptablo"] .renao-map-poster__copy > * { position: static !important; left: auto !important; right: auto !important; }',
      '.renao-capture-shell[data-renao-product-handle="maptablo"] .renao-map-poster__date { padding-top: 0.08em !important; font-size: 1.45rem !important; line-height: 1.05 !important; }',
      '.renao-capture-shell[data-renao-product-handle="maptablo"] .renao-map-poster__title { margin-top: 2.1% !important; font-size: 2.25rem !important; line-height: 0.98 !important; }',
      '.renao-capture-shell[data-renao-product-handle="maptablo"][data-renao-title-font="decorative"] .renao-map-poster__title { font-size: 1.9rem !important; }',
      '.renao-capture-shell[data-renao-product-handle="maptablo"] .renao-map-poster__names, .renao-capture-shell[data-renao-product-handle="maptablo"][data-renao-font="signature"] .renao-map-poster__names { margin-top: 5.7% !important; font-size: 1.9rem !important; line-height: 1.1 !important; }',
      '.renao-capture-shell[data-renao-product-handle="maptablo"][data-renao-font="bold"] .renao-map-poster__names { margin-top: 3.5% !important; font-size: 2.65rem !important; line-height: 1 !important; }',
      '.renao-capture-shell[data-renao-product-handle="maptablo"][data-renao-font="soft"] .renao-map-poster__names { margin-top: 3.2% !important; font-size: 3.6rem !important; line-height: 0.82 !important; }',
      '.renao-capture-shell[data-renao-product-handle="maptablo"] .renao-map-poster__city, .renao-capture-shell[data-renao-product-handle="maptablo"][data-renao-font="signature"] .renao-map-poster__city, .renao-capture-shell[data-renao-product-handle="maptablo"][data-renao-font="bold"] .renao-map-poster__city, .renao-capture-shell[data-renao-product-handle="maptablo"][data-renao-font="soft"] .renao-map-poster__city { margin-top: 3.6% !important; font-size: 1.5rem !important; line-height: 1 !important; }',
      '.renao-capture-shell[data-renao-product-handle="maptablo"] .renao-map-poster__coords { margin-top: 1.15% !important; font-size: 1.25rem !important; line-height: 1.05 !important; }',
      '.renao-capture-shell--design .renao-collage-plaque { background: transparent !important; border-color: transparent !important; box-shadow: none !important; backdrop-filter: none !important; }',
      '.renao-capture-shell--design .renao-collage-plaque::before, .renao-capture-shell--design .renao-collage-plaque::after { content: none !important; }',
      '.renao-capture-shell--design .renao-collage-board { background: transparent !important; }',
      '.renao-capture-shell--design .renao-collage-frame { box-shadow: none !important; }',
      // html2canvas can paint composited 3D children twice when a rotated
      // Polaroid contains an overflow-clipped photo. Flatten only the capture
      // clone so the customer-facing preview keeps its GPU smoothing while the
      // PDF gets one strictly clipped photo layer per frame.
      '.renao-capture-shell .renao-collage-frame { transform-style: flat !important; backface-visibility: visible !important; }',
      '.renao-capture-shell .renao-collage-frame__photo { overflow: hidden !important; transform: none !important; transform-style: flat !important; backface-visibility: visible !important; contain: paint !important; }',
      '.renao-capture-shell .renao-collage-frame__photo img { transform-style: flat !important; backface-visibility: visible !important; }',
      '.renao-capture-shell--design .renao-collage-frame::after, .renao-capture-shell--design .renao-collage-frame__photo::after { content: none !important; }',
      '.renao-capture-shell--design .renao-collage-frame__photo { background: transparent !important; }',
      '.renao-capture-shell--design .renao-collage-frame__photo span { visibility: hidden !important; opacity: 0 !important; }',
      '.renao-capture-shell .renao-collage-plaque.renao-direct-jpeg-capture .renao-collage-board::before, .renao-capture-shell .renao-collage-plaque.renao-direct-jpeg-capture .renao-collage-board::after { content: none !important; display: none !important; background: none !important; background-image: none !important; box-shadow: none !important; opacity: 0 !important; }',
      '.renao-capture-shell .renao-collage-plaque.renao-direct-jpeg-capture [data-renao-stacked-frame-vector], .renao-capture-shell .renao-collage-plaque.renao-direct-jpeg-capture .renao-collage-frame { visibility: hidden !important; opacity: 0 !important; }',
      // html2canvas applies the centered artboard's translateX twice for the
      // classic Netflix poster. The same 4.71% gutters expressed without a CSS
      // transform preserve the live proof geometry in both PDF render paths.
      '.renao-capture-shell .renao-netflix-poster--maptablo .renao-netflix-poster__art { left: 4.71% !important; right: 4.71% !important; top: 2.4% !important; bottom: 2.4% !important; width: auto !important; height: auto !important; transform: none !important; aspect-ratio: auto !important; }',
      '.renao-capture-shell .renao-iyiki-poster.renao-design-print-target { background: transparent !important; border-color: transparent !important; box-shadow: none !important; }',
      '.renao-capture-shell .renao-iyiki-poster.renao-design-print-target .renao-iyiki-poster__photo { background: transparent !important; }',
      '.renao-capture-shell .renao-iyiki-poster.renao-design-print-target .renao-iyiki-poster__copy { background: transparent !important; }',
    ].join('\n');
    document.head.appendChild(exportStyleElement);
  };

  const forceTransparentCollageDesignBackground = (clone) => {
    if (!clone?.classList?.contains('renao-collage-plaque')) return;
    if (['bebe4', 'bebe3', 'bebe2', 'bebe'].includes(String(clone.dataset?.renaoProductHandle || '').trim().toLowerCase())) return;
    clone.style.setProperty('background', 'transparent', 'important');
    clone.style.setProperty('background-color', 'transparent', 'important');
    clone.style.setProperty('border-color', 'transparent', 'important');
    clone.style.setProperty('box-shadow', 'none', 'important');
    clone.style.setProperty('backdrop-filter', 'none', 'important');
    const board = clone.querySelector('.renao-collage-board');
    if (!board) return;
    board.style.setProperty('background', 'transparent', 'important');
    board.style.setProperty('background-color', 'transparent', 'important');
  };

  const prepareStackedLandscapeFramesForCapture = async (clone) => {
    if (!clone?.classList?.contains('renao-collage-plaque')) return false;
    const layoutHandle = String(clone.dataset.renaoProductHandle || '').trim().toLowerCase();
    const sourceHandle = String(clone.dataset.renaoSourceProductHandle || layoutHandle).trim().toLowerCase();
    if (layoutHandle !== 'zarif-yatay-3' || sourceHandle.includes('baba')) return false;
    const board = clone.querySelector('.renao-collage-board');
    if (!board || board.querySelector('[data-renao-stacked-frame-vector]')) return false;
    const response = await fetch(getAssetUrl('renao-zarif-yatay-3-frame-vector.svg'), { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Yatay kolaj vektör çerçevesi indirilemedi.');
    const sourceSvg = new DOMParser().parseFromString(await response.text(), 'image/svg+xml').documentElement;
    const viewBox = sourceSvg.getAttribute('viewBox') || '0 0 425.197 283.465';
    const paths = Array.from(sourceSvg.querySelectorAll('path[data-renao-pdf-frame]'));
    if (paths.length !== 3) throw new Error('Yatay kolaj katman sırası için üç vektör çerçeve bulunamadı.');

    // Illustrator source order is center, left, right. Give every frame the
    // same z-index as its photo and append it after that photo. Equal-z DOM
    // ordering produces center photo+frame below left/right photo+frames.
    [1, 2, 3].forEach((zIndex, index) => {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', viewBox);
      svg.setAttribute('preserveAspectRatio', 'none');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('data-renao-stacked-frame-vector', String(index + 1));
      svg.style.cssText = `position:absolute;inset:0;width:100%;height:100%;z-index:${zIndex};overflow:visible;pointer-events:none`;
      const path = paths[index].cloneNode(true);
      path.setAttribute('fill', '#fff');
      path.setAttribute('fill-rule', 'evenodd');
      svg.appendChild(path);
      board.appendChild(svg);
    });
    clone.classList.add('renao-capture-vector-frame');
    clone.dataset.renaoStackedFramesRasterized = 'true';
    return true;
  };

  const forceTransparentMusicDesignBackground = (clone) => {
    if (!clone?.classList?.contains('renao-music-poster')) return;
    clone.style.setProperty('background', 'transparent', 'important');
    clone.style.setProperty('background-color', 'transparent', 'important');
    clone.style.setProperty('border-color', 'transparent', 'important');
    clone.style.setProperty('box-shadow', 'none', 'important');
  };

  const ensureDesignFileInput = (form, propertyName, dataKey) => {
    let input = form.querySelector(`[${dataKey}]`);
    if (input) {
      input.accept = 'application/pdf,.pdf';
      input.name = `properties[${propertyName}]`;
      input.disabled = false;
      return input;
    }

    input = document.createElement('input');
    input.type = 'file';
    input.name = `properties[${propertyName}]`;
    input.accept = 'application/pdf,.pdf';
    input.tabIndex = -1;
    input.setAttribute(dataKey, '');
    input.style.display = 'none';
    form.appendChild(input);
    return input;
  };

  const ensureDesignFileInputs = (form) => ({
    previewInput: ensureDesignFileInput(form, DESIGN_PREVIEW_PROPERTY, 'data-renao-design-preview-input'),
    downloadInput: ensureDesignFileInput(form, DESIGN_FILE_PROPERTY, 'data-renao-design-file-input'),
  });

  const ensureDesignLinkInput = (form, propertyName, dataKey) => {
    let input = form.querySelector(`[${dataKey}]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.tabIndex = -1;
      input.setAttribute(dataKey, '');
      form.appendChild(input);
    }
    input.name = `properties[${propertyName}]`;
    return input;
  };

  const clearFileInput = (input) => {
    if (!input) return;
    input.__renaoPendingFile = null;
    input.disabled = true;
    input.removeAttribute('name');
    if (typeof DataTransfer !== 'undefined') input.files = new DataTransfer().files;
  };

  const assignFileToInput = (input, file) => {
    if (!input || !file) return false;
    input.__renaoPendingFile = file;
    if (typeof DataTransfer === 'undefined') return false;

    const transfer = new DataTransfer();
    transfer.items.add(file);
    input.files = transfer.files;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.__renaoPendingFile = null;
    return true;
  };

  const applyDesignLinkProperties = (form, links) => {
    const previewUrl = normalizeWhitespace(links?.previewUrl || links?.viewUrl || links?.inlineUrl || links?.url);
    const downloadUrl = normalizeWhitespace(links?.downloadUrl || links?.attachmentUrl || links?.url);
    if (!previewUrl || !downloadUrl) return false;

    const previewInput = ensureDesignLinkInput(form, DESIGN_PREVIEW_PROPERTY, 'data-renao-design-preview-link-input');
    const downloadInput = ensureDesignLinkInput(form, DESIGN_FILE_PROPERTY, 'data-renao-design-file-link-input');
    previewInput.value = previewUrl;
    downloadInput.value = downloadUrl;

    clearFileInput(form.querySelector('[data-renao-design-preview-input]'));
    clearFileInput(form.querySelector('[data-renao-design-file-input]'));
    return true;
  };

  const applySeparateDesignLinkProperties = (form, previewLinks, designLinks) => {
    const previewUrl = normalizeWhitespace(previewLinks?.previewUrl || previewLinks?.viewUrl || previewLinks?.inlineUrl || previewLinks?.url);
    const downloadUrl = normalizeWhitespace(designLinks?.downloadUrl || designLinks?.attachmentUrl || designLinks?.url);
    if (!previewUrl || !downloadUrl) return false;

    const previewInput = ensureDesignLinkInput(form, DESIGN_PREVIEW_PROPERTY, 'data-renao-design-preview-link-input');
    const downloadInput = ensureDesignLinkInput(form, DESIGN_FILE_PROPERTY, 'data-renao-design-file-link-input');
    previewInput.value = previewUrl;
    downloadInput.value = downloadUrl;

    clearFileInput(form.querySelector('[data-renao-design-preview-input]'));
    clearFileInput(form.querySelector('[data-renao-design-file-input]'));
    return true;
  };

  const uploadDesignPdf = async ({ pdf, fileName, productTitle, form }) => {
    const endpoint = getUploadEndpoint();
    if (!endpoint) return null;

    const url = new URL(endpoint, window.location.href);
    url.searchParams.set('fileName', fileName);
    url.searchParams.set('productTitle', productTitle);

    const response = await globalThis.RenaoCartProgress.request(url.toString(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/pdf',
      },
      body: pdf,
      credentials: 'omit',
    }, form, 'Tasarım dosyanız yükleniyor');
    if (!response.ok) throw new Error(await response.text() || 'Tasarım linki oluşturulamadı.');
    return response.json();
  };

  const requestBrowserRenderedPdf = async ({ html, width, height, fileName }) => {
    const endpoint = getBrowserRenderEndpoint();
    if (!endpoint) return null;
    const body = JSON.stringify({
      html,
      width,
      height,
      viewportWidth: Math.max(width, Math.min(4096, window.innerWidth || width)),
      viewportHeight: Math.max(height, Math.min(8192, window.innerHeight || height)),
      fileName,
    });

    let lastError = null;
    for (let attempt = 0; attempt < 3; attempt += 1) {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        credentials: 'omit',
      });
      if (response.ok) return response.json();

      lastError = new Error(await response.text() || 'Tasarım PDF olarak işlenemedi.');
      if (![429, 502, 503, 504].includes(response.status) || attempt === 2) throw lastError;
      const retryAfterSeconds = Number(response.headers.get('Retry-After'));
      const retryDelay = response.status === 429
        ? Math.max(10_500, Number.isFinite(retryAfterSeconds) ? retryAfterSeconds * 1000 : 0)
        : 900 * (attempt + 1);
      await new Promise((resolve) => setTimeout(resolve, retryDelay));
    }
    throw lastError || new Error('Tasarım PDF olarak işlenemedi.');
  };

  const findPrintTarget = (root) => {
    const preview = root.querySelector(PREVIEW_SELECTOR) || root;
    return preview.querySelector(PRINT_TARGET_SELECTOR) || preview.firstElementChild || root.querySelector(PRINT_TARGET_SELECTOR) || null;
  };

  const copyContextAttributes = (source, target) => {
    Array.from(source?.attributes || []).forEach((attribute) => {
      if (
        attribute.name === 'class' ||
        attribute.name === 'style' ||
        attribute.name.startsWith('data-renao') ||
        attribute.name.startsWith('aria-')
      ) {
        target.setAttribute(attribute.name, attribute.value);
      }
    });
  };

  const copyRenaoCustomProperties = (source, target) => {
    const style = source?.style;
    if (!style || !target?.style) return;
    for (let index = 0; index < style.length; index += 1) {
      const propertyName = style[index];
      if (!propertyName.startsWith('--rn-')) continue;
      target.style.setProperty(
        propertyName,
        style.getPropertyValue(propertyName),
        style.getPropertyPriority(propertyName),
      );
    }
  };

  const copyImageSources = (source, clone) => {
    const sourceImages = Array.from(source.querySelectorAll('img'));
    const cloneImages = Array.from(clone.querySelectorAll('img'));
    cloneImages.forEach((image, index) => {
      const sourceImage = sourceImages[index];
      const printSrc = sourceImage?.dataset?.renaoPrintSrc || '';
      const src = printSrc || sourceImage?.currentSrc || sourceImage?.src || image.getAttribute('src') || '';
      if (!src) return;
      image.setAttribute('src', src);
      image.removeAttribute('srcset');
      image.removeAttribute('loading');
      image.crossOrigin = 'anonymous';
      if (image.matches('[data-renao-map-image]') && sourceImage?.dataset?.renaoMapScene === '2') {
        image.dataset.renaoMapScene = '2';
        image.style.setProperty('inset', '0', 'important');
        image.style.setProperty('width', '100%', 'important');
        image.style.setProperty('height', '100%', 'important');
        image.style.setProperty('object-fit', 'fill', 'important');
      } else if (printSrc && image.matches('[data-renao-map-image]')) {
        // The print source is generated from the exact same viewport model as the
        // customer proof. Never retain the modal-capture `fill` mode here: it
        // changes the map's aspect ratio and visibly squeezes it left-to-right.
        image.removeAttribute('data-renao-captured-map');
        image.style.removeProperty('inset');
        image.style.removeProperty('width');
        image.style.removeProperty('height');
        image.style.removeProperty('object-fit');
      }
    });
  };

  const copyCanvasState = (source, clone) => {
    const sourceCanvases = Array.from(source.querySelectorAll('canvas'));
    const cloneCanvases = Array.from(clone.querySelectorAll('canvas'));
    cloneCanvases.forEach((cloneCanvas, index) => {
      const sourceCanvas = sourceCanvases[index];
      if (!sourceCanvas?.width || !sourceCanvas?.height) return;
      cloneCanvas.width = sourceCanvas.width;
      cloneCanvas.height = sourceCanvas.height;
      cloneCanvas.getContext('2d')?.drawImage(sourceCanvas, 0, 0);
    });
  };

  const normalizeObjectFitImagesForCapture = (source, clone) => {
    const sourceImages = Array.from(source.querySelectorAll('img'));
    const cloneImages = Array.from(clone.querySelectorAll('img'));
    const customerPhotoSelector = [
      '[data-renao-map-image]',
      '[data-renao-collage-preview-image]',
      '[data-renao-netflix-image-slot]',
      '[data-renao-music-photo-preview]',
      '[data-renao-iyiki-photo-preview]',
      '[data-renao-qr-photo-preview]',
      '[data-renao-heart-photo-preview]',
    ].join(',');

    cloneImages.forEach((cloneImage, index) => {
      const sourceImage = sourceImages[index];
      if (!sourceImage) return;
      if (!sourceImage.matches(customerPhotoSelector)) return;

      // The Iyiki proof already uses the browser's correct object-fit: cover
      // crop. Converting that image to a manually sized fill element squeezes
      // the photo horizontally in the PDF, so preserve the exact site geometry.
      if (sourceImage.matches('[data-renao-iyiki-photo-preview]')) return;

      const sourceStyle = window.getComputedStyle(sourceImage);
      const objectFit = sourceStyle.objectFit || '';
      if (!objectFit || objectFit === 'fill' || objectFit === 'none') return;

      const cloneParentRect = cloneImage.parentElement?.getBoundingClientRect();
      const sourceParentRect = sourceImage.parentElement?.getBoundingClientRect();
      // clientWidth/clientHeight exclude the rotated Polaroid transform. Using
      // getBoundingClientRect here measures the rotated bounding box and changes
      // the photo aspect ratio in the PDF clone.
      const frameWidth = cloneImage.parentElement?.clientWidth || sourceImage.parentElement?.clientWidth || cloneParentRect?.width || sourceParentRect?.width || cloneImage.clientWidth || sourceImage.clientWidth || 0;
      const frameHeight = cloneImage.parentElement?.clientHeight || sourceImage.parentElement?.clientHeight || cloneParentRect?.height || sourceParentRect?.height || cloneImage.clientHeight || sourceImage.clientHeight || 0;
      // The map clone may use data-renao-print-src while the visible proof still
      // points at an older/captured image. Measure the image that will actually
      // be printed; otherwise a square source can make the landscape print map
      // look valid here and then get stretched into the portrait map frame.
      const usesPrintSource = Boolean(sourceImage.dataset?.renaoPrintSrc);
      const naturalWidth = (usesPrintSource ? cloneImage.naturalWidth : sourceImage.naturalWidth)
        || cloneImage.naturalWidth
        || sourceImage.naturalWidth
        || Number(sourceImage.getAttribute('width'))
        || 0;
      const naturalHeight = (usesPrintSource ? cloneImage.naturalHeight : sourceImage.naturalHeight)
        || cloneImage.naturalHeight
        || sourceImage.naturalHeight
        || Number(sourceImage.getAttribute('height'))
        || 0;
      if (!frameWidth || !frameHeight || !naturalWidth || !naturalHeight) return;

      const frameRatio = frameWidth / frameHeight;
      const imageRatio = naturalWidth / naturalHeight;
      let coverWidthPercent = 100;
      let coverHeightPercent = 100;

      if (objectFit === 'contain') {
        if (imageRatio > frameRatio) coverHeightPercent = frameRatio / imageRatio * 100;
        else coverWidthPercent = imageRatio / frameRatio * 100;
      } else if (imageRatio > frameRatio) {
        coverWidthPercent = imageRatio / frameRatio * 100;
      } else {
        coverHeightPercent = frameRatio / imageRatio * 100;
      }

      const transform = sourceImage.style.transform || sourceStyle.transform;
      cloneImage.style.position = 'absolute';
      cloneImage.style.left = '50%';
      cloneImage.style.top = '50%';
      cloneImage.style.right = 'auto';
      cloneImage.style.bottom = 'auto';
      cloneImage.style.setProperty('width', `${coverWidthPercent}%`, 'important');
      cloneImage.style.setProperty('height', `${coverHeightPercent}%`, 'important');
      cloneImage.style.setProperty('max-width', 'none', 'important');
      cloneImage.style.setProperty('max-height', 'none', 'important');
      cloneImage.style.setProperty('object-fit', 'fill', 'important');
      cloneImage.style.objectPosition = 'center';
      cloneImage.style.transform = transform && transform !== 'none' ? `translate(-50%, -50%) ${transform}` : 'translate(-50%, -50%)';
      cloneImage.style.transformOrigin = sourceStyle.transformOrigin || 'center';
      cloneImage.style.filter = sourceStyle.filter && sourceStyle.filter !== 'none' ? sourceStyle.filter : '';
      cloneImage.style.opacity = sourceStyle.opacity;
      cloneImage.style.zIndex = sourceStyle.zIndex;
      cloneImage.style.borderRadius = sourceStyle.borderRadius;
      cloneImage.style.mixBlendMode = sourceStyle.mixBlendMode;
    });
  };

  const assertCollagePhotoAspectRatios = (clone) => {
    clone.querySelectorAll('[data-renao-collage-preview-image]').forEach((image, index) => {
      if (!image.naturalWidth || !image.naturalHeight) return;
      const style = window.getComputedStyle(image);
      if (style.objectFit !== 'fill') return;
      const renderedWidth = image.offsetWidth || Number.parseFloat(style.width) || 0;
      const renderedHeight = image.offsetHeight || Number.parseFloat(style.height) || 0;
      if (!renderedWidth || !renderedHeight) throw new Error(`Kolaj fotoğrafı ${index + 1} ölçülemedi.`);
      const naturalRatio = image.naturalWidth / image.naturalHeight;
      const renderedRatio = renderedWidth / renderedHeight;
      const ratioError = Math.abs(renderedRatio / naturalRatio - 1);
      if (ratioError > 0.015) {
        throw new Error(`Kolaj fotoğrafı ${index + 1} PDF'e aktarılırken en-boy oranı bozuldu (${image.naturalWidth}x${image.naturalHeight} -> ${renderedWidth}x${renderedHeight}; stil ${style.width}x${style.height}; çerçeve ${image.parentElement?.offsetWidth || 0}x${image.parentElement?.offsetHeight || 0}).`);
      }
    });
  };

  const normalizeAndAssertMusicCodeAspectRatio = (clone) => {
    const wrap = clone?.querySelector?.('[data-renao-music-code-wrap]');
    if (!wrap || wrap.classList.contains('is-qr')) return;
    const generatedImage = wrap.querySelector('[data-renao-music-code-image]');
    const fallbackImage = wrap.querySelector('[data-renao-music-code-fallback] img');
    const image = generatedImage && !generatedImage.hidden ? generatedImage : fallbackImage;
    const naturalWidth = image?.naturalWidth || Number(image?.getAttribute?.('width')) || 0;
    const naturalHeight = image?.naturalHeight || Number(image?.getAttribute?.('height')) || 0;
    if (!naturalWidth || !naturalHeight) {
      throw new Error('Spotify kodunun baskı ölçüsü doğrulanamadı.');
    }
    image.style.setProperty('height', 'auto', 'important');
    image.style.setProperty('max-height', 'none', 'important');
    image.style.setProperty('aspect-ratio', `${naturalWidth} / ${naturalHeight}`, 'important');
    image.style.setProperty('object-fit', 'contain', 'important');
    const renderedWidth = image.getBoundingClientRect().width || 0;
    const renderedHeight = image.getBoundingClientRect().height || 0;
    if (!renderedWidth || !renderedHeight) throw new Error('Spotify kodunun baskı kutusu ölçülemedi.');
    const naturalRatio = naturalWidth / naturalHeight;
    const renderedRatio = renderedWidth / renderedHeight;
    if (Math.abs(renderedRatio / naturalRatio - 1) > 0.01) {
      throw new Error(`Spotify kodunun en-boy oranı bozuldu (${naturalWidth}x${naturalHeight} -> ${Math.round(renderedWidth)}x${Math.round(renderedHeight)}).`);
    }
  };

  const readExactPhotoCrop = (sourceImage) => {
    if (!sourceImage) return null;
    let positionInput = null;
    if (sourceImage.matches('[data-renao-collage-preview-image]')) {
      const slot = sourceImage.dataset.renaoCollagePreviewImage;
      positionInput = sourceImage.closest('[data-renao-collage-personalizer]')
        ?.querySelector(`[data-renao-collage-position="${slot}"]`)
        || document.querySelector(`[data-renao-collage-position="${slot}"]`);
    } else if (sourceImage.matches('[data-renao-netflix-image-slot]')) {
      const slot = sourceImage.dataset.renaoNetflixImageSlot;
      positionInput = sourceImage.closest('[data-renao-netflix-personalizer]')
        ?.querySelector(`[data-renao-netflix-position="${slot}"]`)
        || document.querySelector(`[data-renao-netflix-position="${slot}"]`);
    } else if (sourceImage.matches('[data-renao-music-photo-preview]')) {
      positionInput = sourceImage.closest('[data-renao-music-personalizer]')
        ?.querySelector('[data-renao-music-photo-position]')
        || document.querySelector('[data-renao-music-photo-position]');
    } else if (sourceImage.matches('[data-renao-iyiki-photo-preview]')) {
      positionInput = sourceImage.closest('[data-renao-iyiki-personalizer]')
        ?.querySelector('[data-renao-iyiki-photo-position]')
        || document.querySelector('[data-renao-iyiki-photo-position]');
    } else if (sourceImage.matches('[data-renao-qr-photo-preview]')) {
      positionInput = sourceImage.closest('[data-renao-qr-personalizer]')
        ?.querySelector('[data-renao-qr-photo-position]')
        || document.querySelector('[data-renao-qr-photo-position]');
    } else if (sourceImage.matches('[data-renao-heart-photo-preview]')) {
      positionInput = sourceImage.closest('[data-renao-heart-photo-personalizer]')
        ?.querySelector('[data-renao-heart-photo-position]')
        || document.querySelector('[data-renao-heart-photo-position]');
    }
    const value = String(positionInput?.value || '');
    if (!value) return null;
    if (value.trim().startsWith('{')) {
      try {
        const crop = JSON.parse(value).crop;
        if (crop && [crop.x, crop.y, crop.width, crop.height].every((entry) => Number.isFinite(Number(entry)))) {
          return { x: Number(crop.x), y: Number(crop.y), width: Number(crop.width), height: Number(crop.height) };
        }
      } catch {
        return null;
      }
    }
    const fromSharedRecipe = globalThis.RenaoCropRecipe?.exactFromText?.(value);
    if (fromSharedRecipe) return fromSharedRecipe;
    const read = (name) => {
      const match = value.match(new RegExp(`(?:^|[,;]\\s*)${name}\\s*:\\s*(-?\\d+(?:\\.\\d+)?)`, 'i'));
      return match ? Number.parseFloat(match[1]) : Number.NaN;
    };
    const crop = { x: read('sx'), y: read('sy'), width: read('sw'), height: read('sh') };
    return Object.values(crop).every(Number.isFinite) ? crop : null;
  };

  const exactCropMatchesFrame = (crop, naturalWidth, naturalHeight, frameRatio) => {
    if (!crop || !naturalWidth || !naturalHeight || !frameRatio) return false;
    const values = [crop.x, crop.y, crop.width, crop.height].map(Number);
    if (!values.every(Number.isFinite)) return false;
    const [x, y, width, height] = values;
    if (x < 0 || y < 0 || width <= 0 || height <= 0 || x + width > 1.001 || y + height > 1.001) return false;
    const cropRatio = (width * naturalWidth) / (height * naturalHeight);
    return Number.isFinite(cropRatio) && Math.abs(cropRatio / frameRatio - 1) <= 0.025;
  };

  const freezeIyikiPhotoForCapture = async (source, clone) => {
    const sourceImage = source?.querySelector?.('[data-renao-iyiki-photo-preview]');
    const cloneImage = clone?.querySelector?.('[data-renao-iyiki-photo-preview]');
    if (sourceImage && !sourceImage.complete) await waitForImages(source);
    let drawableImage = sourceImage;
    const sourceUrl = sourceImage?.currentSrc || sourceImage?.src || '';
    if (sourceImage && sourceUrl && !sourceUrl.startsWith('data:')) {
      // Shopify customer uploads may already be visible in the browser but still
      // taint a canvas when the PDF crop is frozen. Re-load the exact bytes as a
      // data URL first so the crop remains exportable in Chromium and on macOS.
      const response = await fetch(sourceUrl, { credentials: 'omit' });
      if (!response.ok) throw new Error('İyi ki fotoğrafı baskı dosyası için indirilemedi.');
      drawableImage = await loadImage(await readBlobAsDataUrl(await response.blob()));
    }
    const sourceFrameRect = sourceImage?.parentElement?.getBoundingClientRect();
    const cloneFrameRect = cloneImage?.parentElement?.getBoundingClientRect();
    const frameRect = sourceFrameRect?.width && sourceFrameRect?.height ? sourceFrameRect : cloneFrameRect;
    const naturalWidth = drawableImage?.naturalWidth || sourceImage?.naturalWidth || cloneImage?.naturalWidth || 0;
    const naturalHeight = drawableImage?.naturalHeight || sourceImage?.naturalHeight || cloneImage?.naturalHeight || 0;
    if (!sourceImage || !cloneImage || !frameRect?.width || !frameRect?.height || !naturalWidth || !naturalHeight) return;

    const frameRatio = frameRect.width / frameRect.height;
    const imageRatio = naturalWidth / naturalHeight;
    let cropWidth = naturalWidth;
    let cropHeight = naturalHeight;
    if (imageRatio > frameRatio) cropWidth = naturalHeight * frameRatio;
    else cropHeight = naturalWidth / frameRatio;

    const transform = window.getComputedStyle(sourceImage).transform;
    const matrix = transform && transform !== 'none' ? new DOMMatrixReadOnly(transform) : null;
    const scale = matrix ? Math.max(1, Math.hypot(matrix.a, matrix.b)) : 1;
    cropWidth /= scale;
    cropHeight /= scale;

    const translateX = matrix?.e || 0;
    const translateY = matrix?.f || 0;
    const centerX = naturalWidth / 2 - translateX * cropWidth / frameRect.width;
    const centerY = naturalHeight / 2 - translateY * cropHeight / frameRect.height;
    let sourceX = Math.min(Math.max(centerX - cropWidth / 2, 0), Math.max(0, naturalWidth - cropWidth));
    let sourceY = Math.min(Math.max(centerY - cropHeight / 2, 0), Math.max(0, naturalHeight - cropHeight));
    const exactCrop = readExactPhotoCrop(sourceImage);
    if (exactCropMatchesFrame(exactCrop, naturalWidth, naturalHeight, frameRatio)) {
      sourceX = exactCrop.x * naturalWidth;
      sourceY = exactCrop.y * naturalHeight;
      cropWidth = exactCrop.width * naturalWidth;
      cropHeight = exactCrop.height * naturalHeight;
    } else if (exactCrop) {
      throw new Error('Kayitli fotograf kadraji slot oranina uymuyor; baski dosyasi guvenlik icin durduruldu.');
    }
    const outputWidth = Math.min(2400, Math.max(1, Math.round(cropWidth)));
    const outputHeight = Math.max(1, Math.round(outputWidth / frameRatio));
    const canvas = document.createElement('canvas');
    canvas.width = outputWidth;
    canvas.height = outputHeight;
    canvas.getContext('2d')?.drawImage(
      drawableImage,
      sourceX,
      sourceY,
      cropWidth,
      cropHeight,
      0,
      0,
      outputWidth,
      outputHeight,
    );

    cloneImage.src = canvas.toDataURL('image/png');
    cloneImage.setAttribute('width', String(outputWidth));
    cloneImage.setAttribute('height', String(outputHeight));
    cloneImage.style.setProperty('inset', '0', 'important');
    cloneImage.style.setProperty('width', '100%', 'important');
    cloneImage.style.setProperty('height', '100%', 'important');
    cloneImage.style.setProperty('object-fit', 'fill', 'important');
    cloneImage.style.setProperty('transform', 'none', 'important');
    await waitForImages(clone);
  };

  const freezeCustomerPhotoCropsForCapture = async (source, clone) => {
    const sourceHandle = String(
      source?.dataset?.renaoProductHandle
      || source?.querySelector?.('[data-renao-product-handle]')?.dataset?.renaoProductHandle
      || ''
    ).trim().toLowerCase();
    const allowMeasuredBabyCrop = ['bebe4', 'bebe3', 'bebe2', 'bebe'].includes(sourceHandle);
    const selector = [
      '[data-renao-collage-preview-image]',
      '[data-renao-netflix-image-slot]',
      '[data-renao-music-photo-preview]',
      '[data-renao-qr-photo-preview]',
      '[data-renao-heart-photo-preview]',
    ].join(',');
    const sourceImages = Array.from(source?.querySelectorAll?.(selector) || []);
    const cloneImages = Array.from(clone?.querySelectorAll?.(selector) || []);

    for (let index = 0; index < cloneImages.length; index += 1) {
      const sourceImage = sourceImages[index];
      const cloneImage = cloneImages[index];
      const sourceUrl = sourceImage?.currentSrc || sourceImage?.src || '';
      const sourceFrame = sourceImage?.parentElement;
      const cloneFrame = cloneImage?.parentElement;
      const sourceFrameRect = sourceFrame?.getBoundingClientRect();
      const cloneFrameRect = cloneFrame?.getBoundingClientRect();
      // Polaroid collage frames are rotated. clientWidth/clientHeight preserve
      // the actual inner crop ratio; getBoundingClientRect measures the rotated
      // outer bounds and produces a subtly stretched frozen image.
      const frameWidth = sourceFrame?.clientWidth || cloneFrame?.clientWidth || sourceFrameRect?.width || cloneFrameRect?.width || 0;
      const frameHeight = sourceFrame?.clientHeight || cloneFrame?.clientHeight || sourceFrameRect?.height || cloneFrameRect?.height || 0;
      if (!sourceImage || !cloneImage || !sourceUrl || !frameWidth || !frameHeight) continue;

      let drawableImage = sourceImage;
      if (!sourceUrl.startsWith('data:') && !sourceUrl.startsWith('blob:')) {
        const response = await fetch(sourceUrl, { credentials: 'omit' });
        if (!response.ok) throw new Error(`Müşteri fotoğrafı ${index + 1} baskı kadrajı için indirilemedi.`);
        drawableImage = await loadImage(await readBlobAsDataUrl(await response.blob()));
      }

      const naturalWidth = drawableImage.naturalWidth || sourceImage.naturalWidth || 0;
      const naturalHeight = drawableImage.naturalHeight || sourceImage.naturalHeight || 0;
      if (!naturalWidth || !naturalHeight) throw new Error(`Müşteri fotoğrafı ${index + 1} doğal ölçüsü okunamadı.`);

      const frameRatio = frameWidth / frameHeight;
      const imageRatio = naturalWidth / naturalHeight;
      let cropWidth = naturalWidth;
      let cropHeight = naturalHeight;
      if (imageRatio > frameRatio) cropWidth = naturalHeight * frameRatio;
      else cropHeight = naturalWidth / frameRatio;

      const transform = window.getComputedStyle(sourceImage).transform;
      const matrix = transform && transform !== 'none' ? new DOMMatrixReadOnly(transform) : null;
      const scale = matrix ? Math.max(1, Math.hypot(matrix.a, matrix.b)) : 1;
      cropWidth /= scale;
      cropHeight /= scale;

      const translateX = matrix?.e || 0;
      const translateY = matrix?.f || 0;
      const centerX = naturalWidth / 2 - translateX * cropWidth / frameWidth;
      const centerY = naturalHeight / 2 - translateY * cropHeight / frameHeight;
      let sourceX = Math.min(Math.max(centerX - cropWidth / 2, 0), Math.max(0, naturalWidth - cropWidth));
      let sourceY = Math.min(Math.max(centerY - cropHeight / 2, 0), Math.max(0, naturalHeight - cropHeight));
      const exactCrop = readExactPhotoCrop(sourceImage);
      if (exactCropMatchesFrame(exactCrop, naturalWidth, naturalHeight, frameRatio)) {
        sourceX = exactCrop.x * naturalWidth;
        sourceY = exactCrop.y * naturalHeight;
        cropWidth = exactCrop.width * naturalWidth;
        cropHeight = exactCrop.height * naturalHeight;
      } else if (window.RenaoDesignFileRequireExactCrop) {
        throw new Error(`Musteri fotografi ${index + 1} icin birebir kadraj recetesi eksik veya gecersiz; baski dosyasi guvenlik icin durduruldu.`);
      } else if (exactCrop && !window.RenaoDesignFileAllowCropFallback && !allowMeasuredBabyCrop) {
        throw new Error(`Musteri fotografi ${index + 1} kadraji slot oranina uymuyor; baski dosyasi guvenlik icin durduruldu.`);
      }

      // Crop from the uploaded pixels, not from a screen capture. This preserves
      // every available source pixel while making the PDF crop independent of
      // viewport size and browser object-fit rounding.
      const outputWidth = Math.min(6000, Math.max(1, Math.round(cropWidth)));
      const outputHeight = Math.max(1, Math.round(outputWidth / frameRatio));
      const canvas = document.createElement('canvas');
      canvas.width = outputWidth;
      canvas.height = outputHeight;
      const context = canvas.getContext('2d');
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = 'high';
      // Preserve the customer's color/B&W selection in the frozen pixels. A
      // collage photo is converted to a frame background below, so its former
      // CSS filter would otherwise be lost.
      const captureFilter = window.getComputedStyle(sourceImage).filter;
      if (captureFilter && captureFilter !== 'none' && 'filter' in context) context.filter = captureFilter;
      context.drawImage(drawableImage, sourceX, sourceY, cropWidth, cropHeight, 0, 0, outputWidth, outputHeight);
      if ('filter' in context) context.filter = 'none';

      // The Illustrator-derived Zarif frames use a percentage polygon on the
      // rotated frame itself. html2canvas does not reliably honor that clip, so
      // bake the same polygon into the photo alpha before capture. Restrict this
      // to layouts where the photo well exactly fills the clipped frame.
      const polaroidFrame = sourceFrame.closest?.('.renao-collage-frame');
      const frameClip = polaroidFrame ? window.getComputedStyle(polaroidFrame).clipPath : '';
      const polygonMatch = String(frameClip || '').match(/^polygon\((.+)\)$/i);
      const sourceLayout = String(sourceImage.closest?.('.renao-collage-plaque')?.dataset?.renaoSourceProductHandle || '').trim().toLowerCase();
      if (polygonMatch && sourceLayout === 'zarif-yatay-3') {
        const points = polygonMatch[1].split(',').map((pair) => {
          const values = pair.trim().split(/\s+/);
          if (values.length !== 2) return null;
          const coordinate = (value, sourceSize, targetSize) => {
            if (value.endsWith('%')) return Number.parseFloat(value) / 100 * targetSize;
            if (value.endsWith('px')) return Number.parseFloat(value) / sourceSize * targetSize;
            return Number.NaN;
          };
          const x = coordinate(values[0], frameWidth, outputWidth);
          const y = coordinate(values[1], frameHeight, outputHeight);
          return Number.isFinite(x) && Number.isFinite(y) ? [x, y] : null;
        });
        if (points.length >= 3 && points.every(Boolean)) {
          // The polygon is the exact inner photo window from the Illustrator
          // frame. Keep its source coordinates unchanged: shrinking creates an
          // inner gap, while expanding reveals photo pixels past the frame.
          const center = points.reduce(([sumX, sumY], [x, y]) => [sumX + x, sumY + y], [0, 0])
            .map((sum) => sum / points.length);
          const maskedPoints = points.map(([x, y]) => [
            center[0] + (x - center[0]),
            center[1] + (y - center[1]),
          ]);
          context.save();
          context.globalCompositeOperation = 'destination-in';
          context.beginPath();
          context.moveTo(maskedPoints[0][0], maskedPoints[0][1]);
          maskedPoints.slice(1).forEach(([x, y]) => context.lineTo(x, y));
          context.closePath();
          context.fillStyle = '#000';
          context.fill();
          context.restore();
        }
      }

      const maskedPhotoSelector = [
        '[data-renao-music-photo-preview]',
        '[data-renao-qr-photo-preview]',
        '[data-renao-heart-photo-preview]',
      ].join(',');
      if (sourceImage.matches(maskedPhotoSelector)) {
        const frameStyle = window.getComputedStyle(sourceImage.parentElement);
        const maskValue = frameStyle.maskImage || frameStyle.webkitMaskImage || '';
        const maskUrl = maskValue.match(/url\(["']?([^"')]+)["']?\)/)?.[1] || '';
        if (!maskUrl) throw new Error('Fotoğraf baskı maskesi bulunamadı.');
        const maskResponse = await fetch(maskUrl, { credentials: 'omit' });
        if (!maskResponse.ok) throw new Error('Fotoğraf baskı maskesi indirilemedi.');
        const maskImage = await loadImage(await readBlobAsDataUrl(await maskResponse.blob()));
        context.globalCompositeOperation = 'destination-in';
        const maskHeightRatio = sourceImage.matches('[data-renao-heart-photo-preview]') ? 0.94 : 1;
        context.drawImage(maskImage, 0, 0, outputWidth, Math.round(outputHeight * maskHeightRatio));
        context.globalCompositeOperation = 'source-over';
        cloneImage.parentElement.style.setProperty('background', 'transparent', 'important');
        cloneImage.parentElement.style.setProperty('-webkit-mask-image', 'none', 'important');
        cloneImage.parentElement.style.setProperty('mask-image', 'none', 'important');
      }

      cloneImage.removeAttribute('srcset');
      cloneImage.removeAttribute('sizes');
      cloneImage.src = canvas.toDataURL('image/png');
      cloneImage.setAttribute('width', String(outputWidth));
      cloneImage.setAttribute('height', String(outputHeight));
      cloneImage.style.setProperty('inset', '0', 'important');
      cloneImage.style.setProperty('left', '0', 'important');
      cloneImage.style.setProperty('top', '0', 'important');
      cloneImage.style.setProperty('width', '100%', 'important');
      cloneImage.style.setProperty('height', '100%', 'important');
      cloneImage.style.setProperty('object-fit', 'fill', 'important');
      cloneImage.style.setProperty('transform', 'none', 'important');
      // `img.complete` can remain true briefly after replacing an already
      // loaded image. Await this exact source so the aspect-ratio guard reads
      // the frozen crop dimensions instead of the previous customer upload.
      if (cloneImage.decode) {
        await cloneImage.decode().catch(() => {
          throw new Error(`Müşteri fotoğrafı ${index + 1} baskı kadrajı yüklenemedi.`);
        });
      }
      if (cloneImage.naturalWidth !== outputWidth || cloneImage.naturalHeight !== outputHeight) {
        throw new Error(`Müşteri fotoğrafı ${index + 1} baskı kadrajı yanlış kaynaktan yüklendi (${cloneImage.naturalWidth}x${cloneImage.naturalHeight}; beklenen ${outputWidth}x${outputHeight}).`);
      }
      cloneImage.dataset.renaoCropFrozen = 'true';
      if (sourceImage.matches('[data-renao-collage-preview-image]')) {
        // Chromium/html2canvas can promote an <img> inside a rotated Polaroid
        // into a separate compositing layer and then paint it outside the
        // overflow clip. A CSS background is painted intrinsically inside the
        // photo well, eliminating the duplicate unmasked rectangle while the
        // white frame and its rotation remain unchanged.
        const frozenUrl = cloneImage.src;
        cloneFrame.style.setProperty('background-image', `url("${frozenUrl}")`, 'important');
        cloneFrame.style.setProperty('background-position', 'center', 'important');
        cloneFrame.style.setProperty('background-repeat', 'no-repeat', 'important');
        cloneFrame.style.setProperty('background-size', '100% 100%', 'important');
        cloneFrame.style.setProperty('filter', 'none', 'important');
        cloneImage.remove();
      }
    }
    await waitForImages(clone);
    if (sourceImages.length !== cloneImages.length
      || cloneImages.some((image) => image.dataset.renaoCropFrozen !== 'true' || !image.naturalWidth || !image.naturalHeight)) {
      const sourceSummary = sourceImages.map((image) => ({
        src: Boolean(image.currentSrc || image.src),
        width: image.naturalWidth || 0,
        height: image.naturalHeight || 0,
        frameWidth: image.parentElement?.clientWidth || 0,
        frameHeight: image.parentElement?.clientHeight || 0,
      }));
      const cloneSummary = cloneImages.map((image) => ({
        frozen: image.dataset.renaoCropFrozen === 'true',
        width: image.naturalWidth || 0,
        height: image.naturalHeight || 0,
        frameWidth: image.parentElement?.clientWidth || 0,
        frameHeight: image.parentElement?.clientHeight || 0,
      }));
      throw new Error(`Müşteri fotoğrafı kadraj güvenlik kontrolünden geçemedi: ${JSON.stringify({ sourceSummary, cloneSummary })}`);
    }
  };

  const assertMapHeartCapturePosition = (source, clone) => {
    const sourceHeart = source?.querySelector?.('.renao-map-poster__heart');
    const cloneHeart = clone?.querySelector?.('.renao-map-poster__heart');
    if (!sourceHeart && !cloneHeart) return;
    const sourceRect = source?.getBoundingClientRect?.();
    const cloneRect = clone?.getBoundingClientRect?.();
    const sourceHeartRect = sourceHeart?.getBoundingClientRect?.();
    const cloneHeartRect = cloneHeart?.getBoundingClientRect?.();
    if (!sourceRect?.width || !sourceRect?.height || !cloneRect?.width || !cloneRect?.height
      || !sourceHeartRect?.width || !cloneHeartRect?.width) {
      throw new Error('Harita kalbi baskı konumu ölçülemedi.');
    }
    if (clone.classList.contains('renao-map-poster--maptablo')) {
      const sourceMapRect = source.querySelector('.renao-map-poster__map')?.getBoundingClientRect?.();
      const cloneMapRect = clone.querySelector('.renao-map-poster__map')?.getBoundingClientRect?.();
      if (!sourceMapRect?.width || !sourceMapRect?.height || !cloneMapRect?.width || !cloneMapRect?.height) {
        throw new Error('Tablo harita kalbi baskı konumu ölçülemedi.');
      }
      const sourceMapX = (sourceHeartRect.left + sourceHeartRect.width / 2 - sourceMapRect.left) / sourceMapRect.width;
      const sourceMapY = (sourceHeartRect.top + sourceHeartRect.height / 2 - sourceMapRect.top) / sourceMapRect.height;
      const cloneMapX = (cloneHeartRect.left + cloneHeartRect.width / 2 - cloneMapRect.left) / cloneMapRect.width;
      const cloneMapY = (cloneHeartRect.top + cloneHeartRect.height / 2 - cloneMapRect.top) / cloneMapRect.height;
      if (Math.abs(sourceMapX - cloneMapX) > 0.00025 || Math.abs(sourceMapY - cloneMapY) > 0.00025) {
        throw new Error(`Tablo harita kalbi harita içindeki konumundan saptı (${sourceMapX.toFixed(4)},${sourceMapY.toFixed(4)} -> ${cloneMapX.toFixed(4)},${cloneMapY.toFixed(4)}).`);
      }
      return;
    }
    const sourceX = (sourceHeartRect.left + sourceHeartRect.width / 2 - sourceRect.left) / sourceRect.width;
    const sourceY = (sourceHeartRect.top + sourceHeartRect.height / 2 - sourceRect.top) / sourceRect.height;
    const cloneX = (cloneHeartRect.left + cloneHeartRect.width / 2 - cloneRect.left) / cloneRect.width;
    const cloneY = (cloneHeartRect.top + cloneHeartRect.height / 2 - cloneRect.top) / cloneRect.height;
    // 0.025% of the artboard is below 0.05 mm even on the 182 mm plaque.
    // Refuse PDF generation instead of accepting a visually detectable drift.
    if (Math.abs(sourceX - cloneX) > 0.00025 || Math.abs(sourceY - cloneY) > 0.00025) {
      throw new Error(`Harita kalbi önizleme konumundan saptı (${sourceX.toFixed(4)},${sourceY.toFixed(4)} -> ${cloneX.toFixed(4)},${cloneY.toFixed(4)}).`);
    }
  };

  const freezeMapGeometryForCapture = (source, clone) => {
    const sourceMap = source?.querySelector?.('.renao-map-poster__map');
    const cloneMap = clone?.querySelector?.('.renao-map-poster__map');
    if (!sourceMap && !cloneMap) return;
    const sourceRect = source?.getBoundingClientRect?.();
    const sourceMapRect = sourceMap?.getBoundingClientRect?.();
    if (!sourceRect?.width || !sourceRect?.height || !sourceMapRect?.width || !sourceMapRect?.height || !cloneMap) {
      throw new Error('Harita baskı geometrisi önizlemeden kilitlenemedi.');
    }

    // Responsive selectors can evaluate differently inside the isolated PDF
    // shell (notably on mobile maptablo). Freeze the measured proof geometry as
    // percentages of the artboard so editor, proof and PDF share one coordinate
    // system instead of trying to recreate it with media queries.
    cloneMap.style.setProperty('inset', 'auto', 'important');
    const setPercent = (name, value) => cloneMap.style.setProperty(name, `${value * 100}%`, 'important');
    const shapeContext = source.closest('[data-renao-shape], [data-renao-product-handle]');
    const isBorderlessMaptablo = source.dataset.renaoMapScene !== '2' && clone.classList.contains('renao-map-poster--maptablo')
      && shapeContext?.dataset?.renaoShape === 'full';
    if (isBorderlessMaptablo) {
      // Production PDFs must not inherit the decorative storefront frame from
      // an older cached theme asset. The printed A3 map always reaches the top
      // and side paper edges.
      setPercent('left', 0);
      setPercent('top', 0);
      setPercent('width', 1);
      setPercent('height', 0.661);
    } else {
      setPercent('left', (sourceMapRect.left - sourceRect.left) / sourceRect.width);
      setPercent('top', (sourceMapRect.top - sourceRect.top) / sourceRect.height);
      setPercent('width', sourceMapRect.width / sourceRect.width);
      setPercent('height', sourceMapRect.height / sourceRect.height);
    }
    cloneMap.style.setProperty('right', 'auto', 'important');
    cloneMap.style.setProperty('bottom', 'auto', 'important');

    const sourceHeart = sourceMap.querySelector('.renao-map-poster__heart');
    const cloneHeart = cloneMap.querySelector('.renao-map-poster__heart');
    const sourceHeartRect = sourceHeart?.getBoundingClientRect?.();
    if (!sourceHeartRect?.width || !sourceHeartRect?.height || !cloneHeart) return;
    const heartX = (sourceHeartRect.left + sourceHeartRect.width / 2 - sourceMapRect.left) / sourceMapRect.width;
    const heartY = (sourceHeartRect.top + sourceHeartRect.height / 2 - sourceMapRect.top) / sourceMapRect.height;
    cloneHeart.style.setProperty('left', `${heartX * 100}%`, 'important');
    cloneHeart.style.setProperty('top', `${heartY * 100}%`, 'important');
    cloneHeart.style.setProperty('right', 'auto', 'important');
    cloneHeart.style.setProperty('bottom', 'auto', 'important');
  };

  const freezeQrCodeForCapture = async (clone) => {
    const qrImage = clone?.querySelector?.('.renao-qr-code');
    const sourceUrl = qrImage?.currentSrc || qrImage?.src || '';
    if (!qrImage || !sourceUrl) return;

    // Chromium renders the storefront SVG correctly, but the isolated HTML
    // print document can retain only one finder corner. Freeze the exact QR as
    // a dense PNG so Preview, Poppler and print RIPs all receive identical data.
    const response = await fetch(sourceUrl, { credentials: 'omit' });
    if (!response.ok) throw new Error('QR kod baskı dosyası için indirilemedi.');
    const sourceImage = await loadImage(await readBlobAsDataUrl(await response.blob()));
    const canvas = document.createElement('canvas');
    canvas.width = 1560;
    canvas.height = 1560;
    const context = canvas.getContext('2d');
    context.imageSmoothingEnabled = false;
    context.drawImage(sourceImage, 0, 0, canvas.width, canvas.height);
    qrImage.src = canvas.toDataURL('image/png');
    qrImage.removeAttribute('srcset');
    qrImage.setAttribute('width', String(canvas.width));
    qrImage.setAttribute('height', String(canvas.height));
    await waitForImages(clone);
  };

  const neutralizeCaptureNoise = (element) => {
    element.querySelectorAll('script, noscript, template, input, textarea, select').forEach((node) => node.remove());
    element.querySelectorAll('*').forEach((node) => {
      node.style.caretColor = 'transparent';
      node.style.animation = 'none';
      node.style.transition = 'none';
    });
  };

  const timeoutPromise = (milliseconds, message) => new Promise((_, reject) => {
    window.setTimeout(() => reject(new Error(message)), milliseconds);
  });

  const waitForImages = async (element) => {
    const images = Array.from(element.querySelectorAll('img'));
    const ready = Promise.all(images.map((image) => {
      if (image.complete && image.naturalWidth) return Promise.resolve();
      if (image.decode) return image.decode().catch(() => undefined);
      return new Promise((resolve) => {
        image.onload = resolve;
        image.onerror = resolve;
      });
    }));
    await Promise.race([ready, timeoutPromise(8000, 'Tasarım görselleri zamanında hazırlanamadı.')]);
  };

  const readBlobAsDataUrl = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(reader.error || new Error('Görsel PDF için hazırlanamadı.'));
    reader.readAsDataURL(blob);
  });

  const inlineLocalImages = async (element) => {
    const images = Array.from(element.querySelectorAll('img'));
    await Promise.all(images.map(async (image) => {
      const src = image.getAttribute('src') || '';
      if (!src.startsWith('blob:')) return;
      const response = await fetch(src);
      if (!response.ok) throw new Error('Müşteri görseli PDF için okunamadı.');
      image.setAttribute('src', await blobToDataUrl(await response.blob()));
    }));

    Array.from(element.querySelectorAll('canvas')).forEach((canvas) => {
      try {
        const image = document.createElement('img');
        Array.from(canvas.attributes).forEach((attribute) => image.setAttribute(attribute.name, attribute.value));
        image.setAttribute('src', canvas.toDataURL('image/png'));
        image.setAttribute('width', String(canvas.width));
        image.setAttribute('height', String(canvas.height));
        canvas.replaceWith(image);
      } catch (error) {
        console.warn('Renao canvas could not be inlined for browser PDF.', error);
      }
    });
  };

  const stylesheetMarkupForBrowserRender = () => {
    const links = Array.from(document.querySelectorAll('link[rel~="stylesheet"][href]'))
      .filter((link) => /\/assets\/(?:base\.css|renao-[^/?]+\.css)(?:[?#]|$)/i.test(link.href))
      .map((link) => `<link rel="stylesheet" href="${new URL(link.href, document.baseURI).href.replace(/&/g, '&amp;').replace(/"/g, '&quot;')}">`);
    const styles = Array.from(document.querySelectorAll('style'))
      .filter((style) => style !== exportStyleElement)
      .map((style) => `<style>${style.textContent || ''}</style>`);
    return [...links, ...styles].join('\n');
  };

  const buildBrowserRenderHtml = async ({ clone, shell }) => {
    const targetRect = clone.getBoundingClientRect();
    if (!targetRect.width || !targetRect.height) throw new Error('PDF tasarım ölçüsü okunamadı.');

    const snapshot = shell.cloneNode(true);
    snapshot.id = 'renao-browser-render-shell';
    snapshot.setAttribute('aria-hidden', 'true');
    const width = Number(targetRect.width.toFixed(3));
    const height = Number(targetRect.height.toFixed(3));
    const snapshotStage = snapshot.querySelector('.renao-proof-modal__stage');
    const snapshotTarget = snapshot.querySelector('.renao-design-print-target');
    snapshot.style.cssText = `position:absolute;left:0;top:0;width:${width}px;height:${height}px;min-height:0;padding:0;margin:0;background:transparent;overflow:visible;pointer-events:none;z-index:0`;
    if (snapshotStage) {
      snapshotStage.style.cssText = `display:block;position:relative;width:${width}px;height:${height}px;min-height:0;padding:0;margin:0;background:transparent;box-shadow:none;overflow:visible`;
    }
    if (snapshotTarget) {
      snapshotTarget.style.setProperty('width', `${width}px`, 'important');
      snapshotTarget.style.setProperty('height', `${height}px`, 'important');
      snapshotTarget.style.setProperty('max-width', 'none', 'important');
      snapshotTarget.style.setProperty('margin', '0', 'important');
    }
    await inlineLocalImages(snapshot);

    const baseHref = document.baseURI.replace(/&/g, '&amp;').replace(/"/g, '&quot;');
    const html = [
      '<!doctype html><html><head><meta charset="utf-8">',
      `<base href="${baseHref}">`,
      stylesheetMarkupForBrowserRender(),
      '<style>',
      `@page{size:${width}px ${height}px;margin:0}`,
      `html,body{margin:0!important;padding:0!important;width:${width}px!important;height:${height}px!important;min-width:0!important;min-height:0!important;background:transparent!important;overflow:hidden!important}`,
      `#renao-browser-render-shell{position:absolute!important;left:0!important;top:0!important;width:${width}px!important;height:${height}px!important;min-height:0!important;padding:0!important;margin:0!important;z-index:0!important;opacity:1!important;visibility:visible!important;pointer-events:none!important}`,
      '#renao-browser-render-shell *{animation:none!important;transition:none!important;caret-color:transparent!important}',
      '</style></head><body>',
      snapshot.outerHTML,
      '</body></html>',
    ].join('\n');
    return { html, width, height };
  };

  const waitForPaint = (frames = 2) => new Promise((resolve) => {
    const tick = () => {
      frames -= 1;
      if (frames <= 0) resolve();
      else requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  });

  const loadImage = (src) => new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error(`Görsel yüklenemedi: ${src}`));
    image.src = src;
  });

  const applyMapMaskToCanvas = async (canvas, clone, snapshot = null) => {
    const mapElement = clone.querySelector('.renao-map-poster__map');
    if (!mapElement) return;

    const cloneRect = snapshot?.poster || clone.getBoundingClientRect();
    const mapRect = snapshot?.map || mapElement.getBoundingClientRect();
    if (!cloneRect.width || !cloneRect.height || !mapRect.width || !mapRect.height) return;

    const scaleX = canvas.width / cloneRect.width;
    const scaleY = canvas.height / cloneRect.height;
    const mapX = Math.round((mapRect.left - cloneRect.left) * scaleX);
    const mapY = Math.round((mapRect.top - cloneRect.top) * scaleY);
    const mapWidth = Math.round(mapRect.width * scaleX), mapHeight = Math.round(mapRect.height * scaleY);
    // Include the rasterizer's antialias fringe outside the CSS clip rectangle.
    const padding = snapshot ? Math.ceil(Math.max(scaleX,scaleY) * 2) : 0;
    const x = Math.max(0, mapX - padding), y = Math.max(0, mapY - padding);
    const width = Math.min(canvas.width - x, mapWidth + padding * 2);
    const height = Math.min(canvas.height - y, mapHeight + padding * 2);
    if (width <= 0 || height <= 0) return;

    const contextElement = clone.closest('[data-renao-shape], [data-renao-product-handle]');
    const shape = snapshot?.shape || contextElement?.dataset?.renaoShape || '';
    const isMapplaket = clone.classList.contains('renao-map-poster--mapplaket');
    const maskFile = isMapplaket
      ? 'renao-mapplaket-mask.png'
      : shape === 'heart'
        ? 'renao-heart-shape-mask.png'
        : 'renao-map-mask.png';
    const maskCanvas = document.createElement('canvas');
    maskCanvas.width = width;
    maskCanvas.height = height;
    const maskContext = maskCanvas.getContext('2d');
    maskContext.clearRect(0, 0, width, height);
    const maskImage = await loadImage(getAssetUrl(maskFile));
    if (!isMapplaket && shape === 'heart') {
      const maskHeight = Math.round(mapHeight * 0.94);
      maskContext.drawImage(maskImage, mapX-x, mapY-y, mapWidth, maskHeight);
    } else {
      maskContext.drawImage(maskImage, mapX-x, mapY-y, mapWidth, mapHeight);
    }
    const maskData = maskContext.getImageData(0, 0, width, height).data;

    const context = canvas.getContext('2d');
    const imageData = context.getImageData(x, y, width, height);
    const data = imageData.data;

    for (let index = 0; index < data.length; index += 4) {
      const maskAlpha = maskData[index + 3] / 255;
      data[index + 3] = Math.round(data[index + 3] * maskAlpha);
    }

    context.putImageData(imageData, x, y);
  };

  const applyIyikiPhotoMaskToCanvas = async (canvas, clone) => {
    if (!clone?.classList?.contains('renao-iyiki-poster')) return;

    const photoElement = clone.querySelector('.renao-iyiki-poster__photo');
    if (!photoElement) return;

    const cloneRect = clone.getBoundingClientRect();
    const photoRect = photoElement.getBoundingClientRect();
    if (!cloneRect.width || !cloneRect.height || !photoRect.width || !photoRect.height) return;

    const scaleX = canvas.width / cloneRect.width;
    const scaleY = canvas.height / cloneRect.height;
    const x = Math.max(0, Math.round((photoRect.left - cloneRect.left) * scaleX));
    const y = Math.max(0, Math.round((photoRect.top - cloneRect.top) * scaleY));
    const width = Math.min(canvas.width - x, Math.round(photoRect.width * scaleX));
    const height = Math.min(canvas.height - y, Math.round(photoRect.height * scaleY));
    if (width <= 0 || height <= 0) return;

    const maskCanvas = document.createElement('canvas');
    maskCanvas.width = width;
    maskCanvas.height = height;
    const maskContext = maskCanvas.getContext('2d');
    maskContext.clearRect(0, 0, width, height);
    const maskImage = await loadImage(getAssetUrl('renao-map-mask.png'));
    maskContext.drawImage(maskImage, 0, 0, width, height);
    const maskData = maskContext.getImageData(0, 0, width, height).data;

    const context = canvas.getContext('2d');
    const imageData = context.getImageData(x, y, width, height);
    const data = imageData.data;

    for (let index = 0; index < data.length; index += 4) {
      const maskAlpha = maskData[index + 3] / 255;
      data[index + 3] = Math.round(data[index + 3] * maskAlpha);
    }

    context.putImageData(imageData, x, y);
  };

  const isBlackAndWhiteCollage = (clone) => (
    clone?.matches?.('[data-renao-collage-tone="bw"]')
    || Boolean(clone?.querySelector?.('[data-renao-collage-tone="bw"]'))
  );

  const applyBlackAndWhiteCollageToCanvas = (canvas, clone) => {
    if (!isBlackAndWhiteCollage(clone)) return;

    const context = canvas.getContext('2d');
    if (!context || !canvas.width || !canvas.height) return;
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;

    for (let index = 0; index < data.length; index += 4) {
      const luminance = data[index] * 0.2126 + data[index + 1] * 0.7152 + data[index + 2] * 0.0722;
      const value = Math.max(0, Math.min(255, Math.round(luminance * 1.12 - 15)));
      data[index] = value;
      data[index + 1] = value;
      data[index + 2] = value;
    }

    context.putImageData(imageData, 0, 0);
  };

  const convertMusicPanelToBlackAlpha = (canvas, clone) => {
    if (!clone?.querySelector?.('[data-renao-music-code-wrap]')) return;
    const photo = clone.querySelector('.renao-music-poster__photo');
    const cloneRect = clone.getBoundingClientRect();
    const photoRect = photo?.getBoundingClientRect();
    const context = canvas.getContext('2d');
    if (!context || !cloneRect.width || !photoRect?.width) return;

    // Preserve every customer-photo pixel, including white clothing and the
    // feathered mask. Only the right-side monochrome print panel is converted
    // from white-matted artwork into pure black ink plus alpha transparency.
    const panelX = Math.max(0, Math.min(
      canvas.width,
      Math.ceil((photoRect.right - cloneRect.left) / cloneRect.width * canvas.width),
    ));
    const panelWidth = canvas.width - panelX;
    if (!panelWidth) return;
    const imageData = context.getImageData(panelX, 0, panelWidth, canvas.height);
    const data = imageData.data;
    for (let index = 0; index < data.length; index += 4) {
      const sourceAlpha = data[index + 3] / 255;
      const luminance = data[index] * 0.2126 + data[index + 1] * 0.7152 + data[index + 2] * 0.0722;
      const inkAlpha = Math.round(sourceAlpha * (255 - luminance));
      data[index] = 0;
      data[index + 1] = 0;
      data[index + 2] = 0;
      data[index + 3] = inkAlpha;
    }
    context.putImageData(imageData, panelX, 0);
  };

  const postProcessCanvasForPrint = async (canvas, clone) => {
    await applyMapMaskToCanvas(canvas, clone);
    flattenMaptabloCanvasToWhite(canvas, clone);
    await applyIyikiPhotoMaskToCanvas(canvas, clone);
    clearMapplaketEdgeArtifacts(canvas, clone);
    applyBlackAndWhiteCollageToCanvas(canvas, clone);
  };

  const flattenMaptabloCanvasToWhite = (canvas, clone) => {
    if (!clone?.classList?.contains('renao-map-poster--maptablo')) return;
    const context = canvas.getContext('2d');
    if (!context || !canvas.width || !canvas.height) return;
    // The A3 product is printed on white paper. Flatten the torn mask onto
    // print white so PDF soft-mask interpolation cannot create gray seams.
    context.save();
    context.globalCompositeOperation = 'destination-over';
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.restore();
  };

  const clearMapplaketEdgeArtifacts = (canvas, clone) => {
    if (!clone?.classList?.contains('renao-map-poster--mapplaket')) return;

    const mapElement = clone.querySelector('.renao-map-poster__map');
    if (!mapElement) return;

    const cloneRect = clone.getBoundingClientRect();
    const mapRect = mapElement.getBoundingClientRect();
    if (!cloneRect.width || !cloneRect.height || !mapRect.width || !mapRect.height) return;

    const scaleX = canvas.width / cloneRect.width;
    const scaleY = canvas.height / cloneRect.height;
    const edgeX = Math.round((mapRect.right - cloneRect.left) * scaleX);
    const y = Math.max(0, Math.round((mapRect.top - cloneRect.top) * scaleY));
    const height = Math.min(canvas.height - y, Math.round(mapRect.height * scaleY));
    const stripWidth = Math.max(2, Math.ceil(scaleX * 0.9));
    const x = Math.max(0, edgeX - Math.ceil(stripWidth / 2));
    if (height > 0) canvas.getContext('2d')?.clearRect(x, y, stripWidth, height);
  };

  const collageCaptionFontDataPromises = new Map();
  const COLLAGE_CAPTION_FONT_FILES = [
    { family: 'Renao Wanted', file: 'renao-wanted-fraunces.bin', type: 'font/ttf', style: 'normal' },
    { family: 'Renao Qwigley', file: 'renao-qwigley-regular.ttf', type: 'font/ttf', style: 'normal' },
    { family: 'Renao Fraunces', file: 'renao-fraunces-italic-400.bin', type: 'font/ttf', style: 'italic' },
    { family: 'Renao Acardia', file: 'renao-acardia-regular.ttf', type: 'font/ttf', style: 'normal' },
  ];

  const blobToDataUrl = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(reader.error || new Error('Font verisi okunamadı.'));
    reader.readAsDataURL(blob);
  });

  const getCollageCaptionFontData = async (fontFamily) => {
    const normalizedFamily = String(fontFamily || '').toLocaleLowerCase('tr-TR');
    const spec = COLLAGE_CAPTION_FONT_FILES.find((item) => (
      normalizedFamily.includes(item.family.toLocaleLowerCase('tr-TR'))
    ));
    if (!spec) return null;
    if (collageCaptionFontDataPromises.has(spec.file)) return collageCaptionFontDataPromises.get(spec.file);

    const promise = fetch(getAssetUrl(spec.file))
      .then((response) => {
        if (!response.ok) throw new Error(`${spec.file} fontu yüklenemedi.`);
        return response.arrayBuffer();
      })
      .then((buffer) => readBlobAsDataUrl(new Blob([buffer], { type: spec.type })))
      .then((dataUrl) => ({ ...spec, dataUrl }))
      .catch((error) => {
        collageCaptionFontDataPromises.delete(spec.file);
        throw error;
      });
    collageCaptionFontDataPromises.set(spec.file, promise);
    return promise;
  };

  const rasterizeCollageCaptionForCapture = async (clone, exportScale) => {
    const svg = clone?.querySelector?.('.renao-collage-caption__text');
    const text = svg?.querySelector?.('[data-renao-collage-caption-preview]');
    if (!svg || !text) return;

    const rect = svg.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    try {
      const renderedSvg = svg.cloneNode(true);
      const renderedText = renderedSvg.querySelector('[data-renao-collage-caption-preview]');
      const textStyle = window.getComputedStyle(text);
      const svgStyle = window.getComputedStyle(svg);
      const font = await getCollageCaptionFontData(textStyle.fontFamily);
      const fontCss = font
        ? `@font-face{font-family:'${font.family}';src:url('${font.dataUrl}') format('truetype');font-style:${font.style};font-weight:400;}`
        : '';
      const styleElement = document.createElementNS('http://www.w3.org/2000/svg', 'style');
      styleElement.textContent = fontCss;
      renderedSvg.insertBefore(styleElement, renderedSvg.firstChild);
      renderedSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      renderedSvg.setAttribute('width', String(Math.max(1, Math.round(rect.width * exportScale))));
      renderedSvg.setAttribute('height', String(Math.max(1, Math.round(rect.height * exportScale))));
      if (!renderedSvg.getAttribute('viewBox')) {
        renderedSvg.setAttribute('viewBox', `0 0 ${rect.width} ${rect.height}`);
      }
      renderedSvg.style.background = 'transparent';
      renderedSvg.style.overflow = svgStyle.overflow;
      renderedText.style.fontFamily = textStyle.fontFamily;
      renderedText.style.fontSize = textStyle.fontSize;
      renderedText.style.fontStyle = textStyle.fontStyle;
      renderedText.style.fontWeight = textStyle.fontWeight;
      renderedText.style.letterSpacing = textStyle.letterSpacing;
      renderedText.style.fill = textStyle.fill && textStyle.fill !== 'none' ? textStyle.fill : textStyle.color;
      renderedText.style.stroke = 'none';

      const svgBlob = new Blob([
        new XMLSerializer().serializeToString(renderedSvg),
      ], { type: 'image/svg+xml;charset=utf-8' });
      const svgUrl = URL.createObjectURL(svgBlob);
      const image = await loadImage(svgUrl);
      URL.revokeObjectURL(svgUrl);

      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(rect.width * exportScale));
      canvas.height = Math.max(1, Math.round(rect.height * exportScale));
      canvas.getContext('2d')?.drawImage(image, 0, 0, canvas.width, canvas.height);

      const replacement = document.createElement('img');
      replacement.className = svg.getAttribute('class') || 'renao-collage-caption__text';
      replacement.src = canvas.toDataURL('image/png');
      replacement.alt = '';
      replacement.setAttribute('aria-hidden', 'true');
      replacement.style.display = 'block';
      replacement.style.width = `${rect.width}px`;
      replacement.style.height = `${rect.height}px`;
      replacement.style.maxWidth = 'none';
      replacement.style.objectFit = 'fill';
      svg.replaceWith(replacement);
      await waitForImages(replacement.parentElement || clone);
    } catch (error) {
      console.warn('Renao collage caption could not be frozen for PDF capture.', error);
    }
  };

  const createCaptureElement = async (root, target, context = null) => {
    const preview = context || root.querySelector(PREVIEW_SELECTOR) || target.parentElement || root;
    const clone = target.cloneNode(true);
    clone.classList.add('renao-design-print-target');
    clone.removeAttribute('id');
    clone.removeAttribute('aria-hidden');
    clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
    clone.querySelectorAll('[aria-hidden="true"]').forEach((element) => element.removeAttribute('aria-hidden'));
    copyImageSources(target, clone);
    copyCanvasState(target, clone);
    neutralizeCaptureNoise(clone);

    const shell = document.createElement('div');
    copyContextAttributes(context || root, shell);
    shell.classList.add('renao-capture-shell');
    shell.style.cssText = [
      'position: fixed',
      'left: 0',
      'top: 0',
      'z-index: -2147483647',
      'width: 1200px',
      'min-height: 1200px',
      'padding: 40px',
      'background: transparent',
      'pointer-events: none',
      'overflow: visible',
    ].join(';');

    const stage = document.createElement('div');
    copyContextAttributes(preview, stage);
    stage.classList.add('renao-proof-modal__stage');
    stage.style.cssText = [
      'display: grid',
      'place-items: center',
      'width: 960px',
      'min-height: 0',
      'padding: 0',
      'margin: 0',
      'background: transparent',
      'box-shadow: none',
      'overflow: visible',
    ].join(';');

    // The proof modal carries the customer's map-heart coordinates as CSS
    // custom properties. cssText above intentionally normalizes the capture
    // shell, so restore every Renao variable afterwards; otherwise the PDF
    // silently falls back to the default 50% / 40.2% heart position.
    [root, preview, context].forEach((source) => {
      copyRenaoCustomProperties(source, shell);
      copyRenaoCustomProperties(source, stage);
      copyRenaoCustomProperties(source, clone);
    });

    clone.style.margin = '0 auto';
    if (clone.classList.contains('renao-qr-poster')) {
      const targetRect = target.getBoundingClientRect();
      if (targetRect.width && targetRect.height) {
        // QR layouts are responsive two-column artboards. Letting the isolated
        // 960px stage reflow the clone changes the column ratio and moves the
        // photo under the white panel. Lock the exact proof artboard geometry.
        clone.style.setProperty('width', `${targetRect.width}px`, 'important');
        clone.style.setProperty('height', `${targetRect.height}px`, 'important');
        clone.style.setProperty('max-width', 'none', 'important');
        clone.style.setProperty('max-height', 'none', 'important');
        clone.style.setProperty('flex', 'none', 'important');
      }
    }
    if (clone.classList.contains('renao-map-poster')) {
      clone.style.width = clone.classList.contains('renao-map-poster--mapplaket') ? '920px' : '460px';
      clone.style.maxWidth = 'none';
      clone.style.height = 'auto';
    }
    stage.appendChild(clone);
    shell.appendChild(stage);
    document.body.appendChild(shell);
    freezeMapGeometryForCapture(target, clone);

    if (document.fonts?.ready) {
      await Promise.race([
        document.fonts.ready,
        new Promise((resolve) => window.setTimeout(resolve, 1500)),
      ]);
    }
    await waitForImages(clone);
    normalizeObjectFitImagesForCapture(target, clone);
    await freezeIyikiPhotoForCapture(target, clone);
    await freezeCustomerPhotoCropsForCapture(target, clone);
    await freezeQrCodeForCapture(clone);
    await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    assertCollagePhotoAspectRatios(clone);
    normalizeAndAssertMusicCodeAspectRatio(clone);
    assertMapHeartCapturePosition(target, clone);

    return { clone, shell };
  };

  const getModalForRoot = (root) => root.querySelector(PROOF_MODAL_SELECTOR)
    || document.querySelector(PROOF_MODAL_SELECTOR)
    || null;

  const closeProofModal = (modal) => {
    const closeButton = modal?.querySelector(PROOF_CLOSE_SELECTOR);
    if (closeButton) {
      closeButton.click();
      return;
    }
    if (modal) modal.hidden = true;
    document.documentElement.classList.remove('renao-proof-modal-open');
  };

  const getProofTarget = async (root) => {
    const openButton = root.querySelector(PROOF_OPEN_SELECTOR);
    const modalBeforeOpen = getModalForRoot(root);
    if (!openButton || !modalBeforeOpen) return null;

    ensureExportStyle();
    if (!modalBeforeOpen.hidden) {
      lockProofTargetAspect(modalBeforeOpen);
      await waitForPaint(2);
      const proofStage = modalBeforeOpen.querySelector('.renao-proof-modal__stage');
      const visibleTarget = proofStage?.querySelector(PRINT_TARGET_SELECTOR) || proofStage?.firstElementChild || modalBeforeOpen.querySelector(PRINT_TARGET_SELECTOR);
      if (visibleTarget) return createCaptureElement(root, visibleTarget, modalBeforeOpen);
    }
    let modal = modalBeforeOpen;
    try {
      document.documentElement.classList.add('renao-design-exporting');
      openButton.click();
      if (root.renaoProofReady) await root.renaoProofReady;
      await waitForPaint(4);

      modal = modalBeforeOpen.parentElement ? modalBeforeOpen : getModalForRoot(root);
      if (!modal || modal.hidden) return null;

      lockProofTargetAspect(modal);
      await waitForPaint(2);

      const proofStage = modal.querySelector('.renao-proof-modal__stage');
      const target = proofStage?.querySelector(PRINT_TARGET_SELECTOR) || proofStage?.firstElementChild || modal.querySelector(PRINT_TARGET_SELECTOR);
      if (!target) return null;

      return await createCaptureElement(root, target, modal);
    } finally {
      if (modal && !modal.hidden) closeProofModal(modal);
      document.documentElement.classList.remove('renao-design-exporting');
      await waitForPaint(1);
    }
  };

  const canvasToBlob = (canvas, type, quality) => new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error('Tasarım görseli oluşturulamadı.'));
    }, type, quality);
  });

  const textBytes = (value) => new TextEncoder().encode(value);

  const concatBytes = (parts) => {
    const length = parts.reduce((sum, part) => sum + part.length, 0);
    const output = new Uint8Array(length);
    let offset = 0;
    parts.forEach((part) => {
      output.set(part, offset);
      offset += part.length;
    });
    return output;
  };

  const blobToBytes = async (blob) => new Uint8Array(await blob.arrayBuffer());

  const numberForPdf = (value) => Number(value.toFixed(3)).toString();

  const readUint16 = (view, offset) => view.getUint16(offset, false);
  const readInt16 = (view, offset) => view.getInt16(offset, false);
  const readUint32 = (view, offset) => view.getUint32(offset, false);

  const getFontTable = (view, tag) => {
    const tableCount = readUint16(view, 4);
    for (let index = 0; index < tableCount; index += 1) {
      const offset = 12 + index * 16;
      const currentTag = String.fromCharCode(
        view.getUint8(offset),
        view.getUint8(offset + 1),
        view.getUint8(offset + 2),
        view.getUint8(offset + 3)
      );
      if (currentTag === tag) {
        return {
          offset: readUint32(view, offset + 8),
          length: readUint32(view, offset + 12),
        };
      }
    }
    return null;
  };

  const parseFormat4Cmap = (view, offset) => {
    const segCount = readUint16(view, offset + 6) / 2;
    const endOffset = offset + 14;
    const startOffset = endOffset + segCount * 2 + 2;
    const deltaOffset = startOffset + segCount * 2;
    const rangeOffset = deltaOffset + segCount * 2;

    return (code) => {
      for (let index = 0; index < segCount; index += 1) {
        const endCode = readUint16(view, endOffset + index * 2);
        const startCode = readUint16(view, startOffset + index * 2);
        if (code < startCode || code > endCode) continue;

        const delta = readInt16(view, deltaOffset + index * 2);
        const range = readUint16(view, rangeOffset + index * 2);
        if (range === 0) return (code + delta) & 0xffff;

        const glyphOffset = rangeOffset + index * 2 + range + (code - startCode) * 2;
        const glyph = readUint16(view, glyphOffset);
        return glyph ? (glyph + delta) & 0xffff : 0;
      }
      return 0;
    };
  };

  const parseFormat12Cmap = (view, offset) => {
    const groupCount = readUint32(view, offset + 12);
    const groups = [];
    for (let index = 0; index < groupCount; index += 1) {
      const groupOffset = offset + 16 + index * 12;
      groups.push({
        start: readUint32(view, groupOffset),
        end: readUint32(view, groupOffset + 4),
        glyph: readUint32(view, groupOffset + 8),
      });
    }

    return (code) => {
      const group = groups.find((item) => code >= item.start && code <= item.end);
      return group ? group.glyph + (code - group.start) : 0;
    };
  };

  const parseTrueTypeFont = (arrayBuffer) => {
    const bytes = new Uint8Array(arrayBuffer);
    const view = new DataView(arrayBuffer);
    const head = getFontTable(view, 'head');
    const hhea = getFontTable(view, 'hhea');
    const hmtx = getFontTable(view, 'hmtx');
    const maxp = getFontTable(view, 'maxp');
    const cmap = getFontTable(view, 'cmap');
    if (!head || !hhea || !hmtx || !maxp || !cmap) throw new Error('Font tabloları okunamadı.');

    const unitsPerEm = readUint16(view, head.offset + 18) || 1000;
    const ascender = readInt16(view, hhea.offset + 4);
    const descender = readInt16(view, hhea.offset + 6);
    const numHMetrics = readUint16(view, hhea.offset + 34);
    const numGlyphs = readUint16(view, maxp.offset + 4);
    const widths = [];
    let lastWidth = 500;

    for (let glyph = 0; glyph < numGlyphs; glyph += 1) {
      if (glyph < numHMetrics) {
        lastWidth = readUint16(view, hmtx.offset + glyph * 4);
        widths[glyph] = lastWidth;
      } else {
        widths[glyph] = lastWidth;
      }
    }

    const recordCount = readUint16(view, cmap.offset + 2);
    let format12UnicodeOffset = 0;
    let format4WindowsOffset = 0;
    let format4UnicodeOffset = 0;
    let format4SymbolOffset = 0;
    for (let index = 0; index < recordCount; index += 1) {
      const recordOffset = cmap.offset + 4 + index * 8;
      const platformId = readUint16(view, recordOffset);
      const encodingId = readUint16(view, recordOffset + 2);
      const subtableOffset = cmap.offset + readUint32(view, recordOffset + 4);
      const format = readUint16(view, subtableOffset);
      if (format === 12 && platformId === 3 && encodingId === 10) format12UnicodeOffset = subtableOffset;
      if (format === 4 && platformId === 3 && encodingId === 1) format4WindowsOffset = subtableOffset;
      if (!format4UnicodeOffset && format === 4 && platformId === 0) format4UnicodeOffset = subtableOffset;
      if (!format4SymbolOffset && format === 4 && platformId === 3) format4SymbolOffset = subtableOffset;
    }

    const selectedCmapOffset = format12UnicodeOffset || format4WindowsOffset || format4UnicodeOffset || format4SymbolOffset;
    const format = readUint16(view, selectedCmapOffset);
    const glyphForCode = format === 12
      ? parseFormat12Cmap(view, selectedCmapOffset)
      : parseFormat4Cmap(view, selectedCmapOffset);

    return {
      bytes,
      unitsPerEm,
      ascender,
      descender,
      glyphForCode,
      widthForGlyph: (glyph) => Math.round(((widths[glyph] || widths[0] || 500) / unitsPerEm) * 1000),
      widthForCode: (code) => {
        const glyph = glyphForCode(code);
        return Math.round(((widths[glyph] || widths[0] || 500) / unitsPerEm) * 1000);
      },
    };
  };

  const vectorFontCache = new Map();

  const VECTOR_TEXT_SELECTOR = [
    '[data-renao-collage-caption-preview]',
    '[data-renao-anne-zarif-title]',
    '[data-renao-zrfk-note-preview]',
    '[data-renao-preview-date-output]',
    '[data-renao-preview-title]',
    '[data-renao-preview-name]',
    '[data-renao-preview-city]',
    '[data-renao-preview-coords]',
    '[data-renao-nameplate-name-preview]',
    '[data-renao-nameplate-title-preview]',
    '[data-renao-iyiki-date-preview]',
    '[data-renao-iyiki-title-preview]',
    '[data-renao-iyiki-name-preview]',
    '[data-renao-netflix-text-preview]',
    '[data-renao-music-note-preview]',
    '[data-renao-music-note-serif]',
    '[data-renao-music-signature-preview]',
    '[data-renao-music-title-preview]',
    '[data-renao-music-current-preview]',
    '[data-renao-music-duration-preview]',
    '[data-renao-pet-name-preview]',
    '[data-renao-pet-date-preview]',
    '[data-renao-qr-note-preview]',
    '[data-renao-heart-note-preview]',
    '[data-renao-baby-name-preview]',
    '[data-renao-baby-date-preview]',
    '[data-renao-baby-note-preview]',
  ].join(',');

  const VECTOR_FONT_SPECS = [
    { key: 'wanted', family: 'Renao Wanted', file: 'renao-wanted-fraunces.bin', pdfName: 'Fraunces-9ptBlack' },
    { key: 'anonymous', family: 'Renao Anonymous Pro', file: 'renao-anonymous-pro-regular.bin', pdfName: 'AnonymousPro-Regular' },
    { key: 'exotc', family: 'Renao Exotc', file: 'renao-exotc-dmbd.bin', pdfName: 'Exotic350BT-DemiBold' },
    // Shopify serves .ttf theme assets as WOFF2 under the same URL. Editable
    // PDF text needs the original TrueType bytes, kept raw with a .bin suffix.
    { key: 'acardia', family: 'Renao Acardia', file: 'renao-acardia-regular.bin', pdfName: 'Acardia-Regular' },
    { key: 'qwigley', family: 'Renao Qwigley', file: 'renao-qwigley-regular.bin', pdfName: 'Qwigley-Regular' },
    { key: '00619', family: 'Renao 00619', file: 'renao-00619.bin', pdfName: '00619' },
    { key: 'brittany', family: 'Renao Brittany', file: 'renao-brittany-signature.bin', pdfName: 'BrittanySignatureRegular' },
    { key: 'amsterdam', family: 'Amsterdam', file: 'renao-amsterdam.bin', pdfName: 'Amsterdam' },
    { key: 'bisney', family: 'Renao Bisney', file: 'renao-bisney-regular.otf', pdfName: 'BisneyRegular' },
    { key: 'fraunces', family: 'Renao Fraunces', file: 'renao-fraunces-italic-400.bin', pdfName: 'Fraunces-Italic-400' },
    { key: 'editorial-serif-italic', family: 'Renao Editorial Serif', file: 'renao-editorial-serif-italic-static.bin', pdfName: 'LibreBaskerville-Italic', fontStyle: 'italic' },
    { key: 'editorial-serif', family: 'Renao Editorial Serif', file: 'renao-editorial-serif-static.bin', pdfName: 'LibreBaskerville-Regular' },
    { key: 'editorial-bodoni', family: 'Renao Editorial Bodoni', file: 'renao-editorial-bodoni-static.bin', pdfName: 'LibreBodoni-Regular' },
    { key: 'rounded', family: 'Renao Rounded', file: 'renao-rounded-static.bin', pdfName: 'Nunito-Black' },
    { key: 'cinzel-decorative', family: 'Renao Cinzel Decorative', file: 'renao-cinzel-decorative-bold.bin', pdfName: 'CinzelDecorative-Bold' },
    { key: 'cinzel', family: 'Renao Cinzel', file: 'renao-cinzel-decorative-bold.bin', pdfName: 'CinzelDecorative-Bold' },
    { key: 'renao-roboto-bold', family: 'Renao Roboto', file: 'renao-roboto-bold.bin', pdfName: 'Roboto-Bold', minWeight: 650 },
    { key: 'renao-roboto', family: 'Renao Roboto', file: 'renao-roboto-regular.bin', pdfName: 'Roboto-Regular' },
    { key: 'montserrat-bold', family: 'Renao Montserrat', file: 'renao-montserrat-bold.bin', pdfName: 'Montserrat-Bold', minWeight: 650 },
    { key: 'montserrat', family: 'Renao Montserrat', file: 'renao-montserrat-semibold.bin', pdfName: 'Montserrat-SemiBold' },
    // Myriad's CFF font embeds correctly in Acrobat/Poppler but Apple PDFKit
    // ignores its CID-to-glyph map and displays customer text as symbols.
    // Use the metrically close TrueType Roboto face for portable PDF text.
    { key: 'myriad', family: 'Myriad Pro', file: 'renao-roboto-regular.bin', pdfName: 'Roboto-Regular' },
    { key: 'roboto-bold', family: 'Roboto', file: 'renao-roboto-bold.bin', pdfName: 'Roboto-Bold', minWeight: 650 },
    { key: 'roboto', family: 'Roboto', file: 'renao-roboto-regular.bin', pdfName: 'Roboto-Regular' },
    { key: 'arial-black', family: 'Arial Black', file: 'renao-montserrat-bold.bin', pdfName: 'Montserrat-Bold' },
    { key: 'arial', family: 'Arial', file: 'renao-montserrat-semibold.bin', pdfName: 'ArialMT' },
    { key: 'arsenal', family: 'Arsenal', file: 'renao-montserrat-semibold.bin', pdfName: 'Montserrat-SemiBold' },
  ];

  const loadVectorFont = async (spec) => {
    if (!spec?.file) return null;
    if (vectorFontCache.has(spec.key)) return vectorFontCache.get(spec.key);

    const promise = fetch(getAssetUrl(spec.file))
      .then((response) => {
        if (!response.ok) throw new Error(`${spec.file} fontu yüklenemedi.`);
        return response.arrayBuffer();
      })
      .then((buffer) => ({
        ...parseTrueTypeFont(buffer),
        key: spec.key,
        pdfName: spec.pdfName,
        isCff: String.fromCharCode(...new Uint8Array(buffer, 0, 4)) === 'OTTO',
      }));
    vectorFontCache.set(spec.key, promise);
    return promise;
  };

  const textToCodePoints = (value) => Array.from(String(value || ''), (character) => character.codePointAt(0));

  const sanitizeVectorText = (value) => normalizeWhitespace(value)
    .replace(/Â(?=[°º])/g, '')
    .replace(/â€™/g, "'")
    .replace(/â€œ|â€�/g, '"');

  const textToPdfHex = (value) => textToCodePoints(value)
    .map((code) => code.toString(16).toUpperCase().padStart(4, '0'))
    .join('');

  const parseCssColor = (value) => {
    const text = String(value || '').trim();
    const rgba = text.match(/^rgba?\(([^)]+)\)$/i);
    if (rgba) {
      const parts = rgba[1].split(',').map((part) => Number.parseFloat(part.trim()));
      if (parts.length >= 3) {
        return parts.slice(0, 3).map((part) => Math.max(0, Math.min(1, part / 255)));
      }
    }

    const hex = text.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
    if (hex) {
      const raw = hex[1].length === 3
        ? hex[1].split('').map((part) => part + part).join('')
        : hex[1];
      return [0, 2, 4].map((index) => Number.parseInt(raw.slice(index, index + 2), 16) / 255);
    }

    return [0, 0, 0];
  };

  const cssFontWeightNumber = (fontWeight) => {
    if (fontWeight === 'bold') return 700;
    if (fontWeight === 'normal') return 400;
    return Number.parseInt(fontWeight, 10) || 400;
  };

  const resolveVectorFontSpec = (fontFamily = '', fontWeight = '400', fontStyle = 'normal') => {
    const family = String(fontFamily || '').toLocaleLowerCase('tr-TR');
    const primaryFamily = family.split(',')[0].replace(/["']/g, '').trim();
    const weight = cssFontWeightNumber(fontWeight);
    return VECTOR_FONT_SPECS.find((spec) => (
      primaryFamily.includes(spec.family.toLocaleLowerCase('tr-TR')) &&
      (!spec.fontStyle || spec.fontStyle === fontStyle) &&
      (!spec.minWeight || weight >= spec.minWeight)
    )) || VECTOR_FONT_SPECS.find((spec) => primaryFamily.includes(spec.family.toLocaleLowerCase('tr-TR'))) || null;
  };

  const resolveVectorFontSpecByKey = (key) => VECTOR_FONT_SPECS.find((spec) => spec.key === key) || null;

  const vectorFontSupportsText = (font, text) => !font || textToCodePoints(text).every((code) => (
    code === 10 || code === 13 || code === 32 || font.glyphForCode(code) > 0
  ));

  const escapePdfLiteral = (value) => String(value || '')
    .replace(/ğ/g, 'g')
    .replace(/Ğ/g, 'G')
    .replace(/ü/g, 'u')
    .replace(/Ü/g, 'U')
    .replace(/ş/g, 's')
    .replace(/Ş/g, 'S')
    .replace(/ı/g, 'i')
    .replace(/İ/g, 'I')
    .replace(/ö/g, 'o')
    .replace(/Ö/g, 'O')
    .replace(/ç/g, 'c')
    .replace(/Ç/g, 'C')
    .replace(/\\/g, '\\\\')
    .replace(/\(/g, '\\(')
    .replace(/\)/g, '\\)');

  const pdfTextWidth = (font, value, size) => (
    textToCodePoints(value).reduce((sum, code) => sum + font.widthForCode(code), 0) * size / 1000
  );

  const createToUnicodeCmap = (codes) => {
    const entries = codes.map((code) => {
      const hex = code.toString(16).toUpperCase().padStart(4, '0');
      return `<${hex}> <${hex}>`;
    }).join('\n');

    return [
      '/CIDInit /ProcSet findresource begin',
      '12 dict begin',
      'begincmap',
      '/CIDSystemInfo << /Registry (Adobe) /Ordering (UCS) /Supplement 0 >> def',
      '/CMapName /Adobe-Identity-UCS def',
      '/CMapType 2 def',
      '1 begincodespacerange',
      '<0000> <FFFF>',
      'endcodespacerange',
      `${codes.length} beginbfchar`,
      entries,
      'endbfchar',
      'endcmap',
      'CMapName currentdict /CMap defineresource pop',
      'end',
      'end',
      '',
    ].join('\n');
  };

  const unicodeStringToPdfHex = (value) => Array.from(String(value || ''))
    .map((character) => {
      const code = character.codePointAt(0);
      if (code <= 0xffff) return code.toString(16).toUpperCase().padStart(4, '0');
      const adjusted = code - 0x10000;
      const high = 0xd800 + (adjusted >> 10);
      const low = 0xdc00 + (adjusted & 0x3ff);
      return `${high.toString(16).toUpperCase().padStart(4, '0')}${low.toString(16).toUpperCase().padStart(4, '0')}`;
    }).join('');

  const createGlyphToUnicodeCmap = (records) => {
    const entries = records.map((record) => (
      `<${record.cid.toString(16).toUpperCase().padStart(4, '0')}> <${unicodeStringToPdfHex(record.unicode || '\u200B')}>`
    ));
    const chunks = [];
    for (let index = 0; index < entries.length; index += 90) {
      const chunk = entries.slice(index, index + 90);
      chunks.push(`${chunk.length} beginbfchar\n${chunk.join('\n')}\nendbfchar`);
    }
    return [
      '/CIDInit /ProcSet findresource begin',
      '12 dict begin',
      'begincmap',
      '/CIDSystemInfo << /Registry (Adobe) /Ordering (UCS) /Supplement 0 >> def',
      '/CMapName /Adobe-Identity-UCS def',
      '/CMapType 2 def',
      '1 begincodespacerange',
      '<0000> <FFFF>',
      'endcodespacerange',
      chunks.join('\n'),
      'endcmap',
      'CMapName currentdict /CMap defineresource pop',
      'end',
      'end',
      '',
    ].join('\n');
  };

  const getVectorTextElements = (clone) => {
    const matched = Array.from(clone?.querySelectorAll(`${VECTOR_TEXT_SELECTOR}, [data-renao-vector-text-marked]`) || []);
    const expanded = matched.flatMap((element) => {
      if (matched.some((candidate) => candidate !== element && element.contains(candidate))) return [];
      const textualChildren = Array.from(element.children)
        .filter((child) => child.tagName !== 'BR' && sanitizeVectorText(child.textContent || ''));
      const elements = textualChildren.length ? textualChildren : [element];
      // Some previews intentionally wrap every character or line in a span for
      // animation/mixed-font styling. Preserve those per-child styles for visual
      // fidelity, but remember that they belong to one customer-editable field.
      elements.forEach((child) => {
        if (!child.__renaoVectorTextGroup) child.__renaoVectorTextGroup = element;
      });
      return elements;
    });
    return [...new Set(expanded)].filter((element) => {
      const text = sanitizeVectorText(element.textContent || '');
      if (!text) return false;
      const wasMarkedForVectorExport = element.hasAttribute('data-renao-vector-text-marked');
      if (!wasMarkedForVectorExport && element.closest('[hidden]')) return false;
      const style = window.getComputedStyle(element);
      return wasMarkedForVectorExport || (
        style.display !== 'none'
        && style.visibility !== 'hidden'
        && Number.parseFloat(style.opacity || '1') !== 0
      );
    });
  };

  const getNetflixOutlineData = (clone) => {
    const source = clone?.querySelector?.('[data-renao-netflix-outline-data]');
    if (!source?.textContent) return {};
    try {
      return JSON.parse(source.textContent);
    } catch (error) {
      console.warn('Renao Netflix vector outline data could not be parsed.', error);
      return {};
    }
  };

  const getNetflixVectorOutlineElements = (clone) => Array.from(
    clone?.querySelectorAll?.('[data-renao-netflix-vector-outline]') || []
  ).filter((element) => {
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number.parseFloat(style.opacity || '1') !== 0;
  });

  const markNetflixVectorOutlinesForCapture = (clone) => {
    getNetflixVectorOutlineElements(clone).forEach((element) => {
      const style = window.getComputedStyle(element);
      if (!element.__renaoVectorOutlineStyle) {
        element.__renaoVectorOutlineStyle = { color: style.color };
      }
      element.style.setProperty('color', 'transparent', 'important');
      element.style.setProperty('text-shadow', 'none', 'important');
      element.style.setProperty('-webkit-text-fill-color', 'transparent', 'important');
    });
  };

  const markVectorTextForCapture = (clone) => {
    const layoutHandle = String(clone?.dataset?.renaoProductHandle || '').trim().toLowerCase();
    const sourceHandle = String(clone?.dataset?.renaoSourceProductHandle || layoutHandle).trim().toLowerCase();
    if (clone?.classList?.contains('renao-collage-plaque')
      && !sourceHandle.includes('baba')
      && ['zarif-dikey-3', 'zarif-yatay-3'].includes(layoutHandle)) {
      clone.classList.add('renao-capture-vector-frame');
    }
    const measureCanvas = document.createElement('canvas');
    const measureContext = measureCanvas.getContext('2d');
    getVectorTextElements(clone).forEach((element) => {
      const style = window.getComputedStyle(element);
      // The same clone is captured twice (proof and production artwork). On the
      // second pass its text is already transparent, so never overwrite the
      // original color/font snapshot with the hidden capture style.
      if (!element.__renaoVectorTextStyle) {
        element.__renaoVectorTextStyle = {
          color: typeof SVGElement !== 'undefined' && element instanceof SVGElement && style.fill && style.fill !== 'none' ? style.fill : style.color,
          fontFamily: style.fontFamily,
          fontSize: style.fontSize,
          fontWeight: style.fontWeight,
          fontStyle: style.fontStyle,
          direction: style.direction,
          lineHeight: style.lineHeight,
          textAlign: style.textAlign,
          letterSpacing: style.letterSpacing,
        };
      }
      element.setAttribute('data-renao-vector-text-marked', 'true');
      if (measureContext && !element.hasAttribute('data-renao-vector-text-width')) {
        measureContext.font = `${style.fontStyle || 'normal'} ${style.fontWeight || '400'} ${style.fontSize || '16px'} ${style.fontFamily || 'sans-serif'}`;
        const measuredWidth = measureContext.measureText(sanitizeVectorText(element.textContent || '')).width;
        if (Number.isFinite(measuredWidth) && measuredWidth > 0) {
          element.setAttribute('data-renao-vector-text-width', String(measuredWidth));
        }
      }
      element.style.setProperty('color', 'transparent', 'important');
      element.style.setProperty('text-shadow', 'none', 'important');
      element.style.setProperty('-webkit-text-fill-color', 'transparent', 'important');
      if (typeof SVGElement !== 'undefined' && element instanceof SVGElement) {
        element.style.setProperty('fill', 'transparent', 'important');
        element.style.setProperty('stroke', 'transparent', 'important');
      }
    });

    markNetflixVectorOutlinesForCapture(clone);

    const collageHeart = clone?.querySelector?.('.renao-collage-caption__heart');
    if (collageHeart) {
      collageHeart.style.setProperty('visibility', 'hidden', 'important');
      collageHeart.style.setProperty('opacity', '0', 'important');
    }
    const anneZarifHeart = clone?.querySelector?.('.renao-anne-zarif-art--heart');
    if (anneZarifHeart) {
      // This decoration is embedded below as a resolution-independent PDF
      // stroke. Hide the low-resolution sprite crop from the raster layer.
      anneZarifHeart.style.setProperty('visibility', 'hidden', 'important');
      anneZarifHeart.style.setProperty('opacity', '0', 'important');
    }
  };

  const getElementTextLines = (element) => {
    if (typeof document.createRange !== 'function') return [];
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const characters = [];
    let node = walker.nextNode();
    while (node) {
      let offset = 0;
      while (offset < node.data.length) {
        const character = String.fromCodePoint(node.data.codePointAt(offset));
        const nextOffset = offset + character.length;
        const range = document.createRange();
        range.setStart(node, offset);
        range.setEnd(node, nextOffset);
        const rect = Array.from(range.getClientRects()).find((item) => item.width || item.height);
        if (rect) characters.push({ character, rect });
        offset = nextOffset;
      }
      node = walker.nextNode();
    }
    if (!characters.length) return [];

    const lines = [];
    characters.forEach((item) => {
      const tolerance = Math.max(1.5, item.rect.height * 0.2);
      let line = lines[lines.length - 1];
      if (!line || Math.abs(line.top - item.rect.top) > tolerance) {
        line = { items: [], top: item.rect.top };
        lines.push(line);
      }
      line.items.push(item);
    });

    return lines.map((line) => {
      let start = 0;
      let end = line.items.length;
      while (start < end && /\s/.test(line.items[start].character)) start += 1;
      while (end > start && /\s/.test(line.items[end - 1].character)) end -= 1;
      const items = line.items.slice(start, end);
      if (!items.length) return null;
      const left = Math.min(...items.map((item) => item.rect.left));
      const right = Math.max(...items.map((item) => item.rect.right));
      const top = Math.min(...items.map((item) => item.rect.top));
      const bottom = Math.max(...items.map((item) => item.rect.bottom));
      return {
        text: normalizeWhitespace(items.map((item) => item.character).join('')),
        rect: { left, right, top, bottom, width: right - left, height: bottom - top },
      };
    }).filter((line) => line?.text && line.rect.width && line.rect.height);
  };

  const collectTextVectorOverlay = (clone, canvas) => {
    const cloneRect = clone?.getBoundingClientRect();
    if (!cloneRect?.width || !cloneRect?.height) return [];

    const scaleX = canvas.width / cloneRect.width;
    const scaleY = canvas.height / cloneRect.height;
    const pageScale = 72 / EXPORT_DPI;
    const pageHeight = canvas.height * pageScale;
    const textObjectIds = new Map();
    const getTextObjectId = (element) => {
      const group = element.__renaoVectorTextGroup || element;
      if (!textObjectIds.has(group)) textObjectIds.set(group, textObjectIds.size);
      return textObjectIds.get(group);
    };

    return getVectorTextElements(clone).flatMap((element) => {
      const elementRect = element.getBoundingClientRect();
      const style = element.__renaoVectorTextStyle || window.getComputedStyle(element);
      const anneTitleGroup = element.matches?.('[data-renao-anne-zarif-title]')
        ? element
        : element.closest?.('[data-renao-anne-zarif-title]');
      if (anneTitleGroup?.ownerSVGElement) {
        const svg = anneTitleGroup.ownerSVGElement;
        const svgRect = svg.getBoundingClientRect();
        const viewBox = svg.viewBox?.baseVal;
        const viewBoxWidth = viewBox?.width || svgRect.width;
        const viewBoxHeight = viewBox?.height || svgRect.height;
        const svgScaleX = viewBoxWidth ? svgRect.width / viewBoxWidth : 1;
        const svgScaleY = viewBoxHeight ? svgRect.height / viewBoxHeight : 1;
        const cssFontSize = Number.parseFloat(style.fontSize) || 170;
        const anchorUserX = Number.parseFloat(element.getAttribute('x')) || viewBoxWidth / 2;
        const baselineUserY = Number.parseFloat(element.getAttribute('y')) || viewBoxHeight / 2;
        const viewBoxX = viewBox?.x || 0;
        const viewBoxY = viewBox?.y || 0;
        const text = sanitizeVectorText(element.textContent || '');
        if (!text || !svgRect.width || !svgRect.height) return [];
        return [{
          text,
          x: (svgRect.left - cloneRect.left + (anchorUserX - viewBoxX) * svgScaleX) * scaleX * pageScale,
          y: pageHeight - (svgRect.top - cloneRect.top + (baselineUserY - viewBoxY) * svgScaleY) * scaleY * pageScale,
          width: elementRect.width * scaleX * pageScale,
          fontSize: cssFontSize * svgScaleY * scaleY * pageScale,
          fontSpec: resolveVectorFontSpec(style.fontFamily, style.fontWeight, style.fontStyle),
          fontWeight: style.fontWeight,
          direction: style.direction || 'ltr',
          letterSpacing: 0,
          color: parseCssColor(style.color),
          align: 'center',
          role: 'anne-zarif-title',
          textObjectId: getTextObjectId(element),
        }];
      }
      const isCollageCaption = element.hasAttribute('data-renao-collage-caption-preview');
      if (isCollageCaption && element.ownerSVGElement) {
        const svg = element.ownerSVGElement;
        const svgRect = svg.getBoundingClientRect();
        const viewBox = svg.viewBox?.baseVal;
        const viewBoxWidth = viewBox?.width || svgRect.width;
        const viewBoxHeight = viewBox?.height || svgRect.height;
        const svgScaleX = viewBoxWidth ? svgRect.width / viewBoxWidth : 1;
        const svgScaleY = viewBoxHeight ? svgRect.height / viewBoxHeight : 1;
        const cssFontSize = Number.parseFloat(style.fontSize) || 16;
        const anchorUserX = Number.parseFloat(element.getAttribute('x')) || viewBoxWidth / 2;
        const baselineUserY = Number.parseFloat(element.getAttribute('y')) || viewBoxHeight / 2;
        const viewBoxX = viewBox?.x || 0;
        const viewBoxY = viewBox?.y || 0;
        const anchorX = (
          svgRect.left - cloneRect.left + (anchorUserX - viewBoxX) * svgScaleX
        ) * scaleX * pageScale;
        const baselineTop = (
          svgRect.top - cloneRect.top + (baselineUserY - viewBoxY) * svgScaleY
        ) * scaleY * pageScale;
        const textLength = Number.parseFloat(element.getAttribute('textLength'));
        const measuredCssWidth = Number.parseFloat(element.getAttribute('data-renao-vector-text-width'));
        // textLength is only meant to compress captions that overflow. If the
        // fallback font was measured before the real script font loaded, the old
        // value can become wider than the final glyphs and flatten the caption.
        const shouldUseTextLength = Number.isFinite(textLength)
          && textLength > 0
          && (!Number.isFinite(measuredCssWidth) || textLength * svgScaleX <= measuredCssWidth * 1.01);
        const captionScale = 1;
        const measuredWidth = (shouldUseTextLength
          ? textLength * svgScaleX * scaleX * pageScale
          : Number.isFinite(measuredCssWidth) && measuredCssWidth > 0
            ? measuredCssWidth * svgScaleX * scaleX * pageScale
            : elementRect.width * scaleX * pageScale) * captionScale;
        const width = measuredWidth;
        const align = element.getAttribute('text-anchor') === 'end'
          ? 'right'
          : element.getAttribute('text-anchor') === 'middle'
            ? 'center'
            : 'left';
        const text = sanitizeVectorText(element.textContent || '');
        if (!text || !width || !svgRect.width || !svgRect.height) return [];

        return [{
          text,
          x: anchorX,
          y: pageHeight - baselineTop,
          width,
          fontSize: cssFontSize * svgScaleY * scaleY * pageScale * captionScale,
          fontSpec: resolveVectorFontSpec(style.fontFamily, style.fontWeight, style.fontStyle),
          fontWeight: style.fontWeight,
          direction: style.direction || 'ltr',
          letterSpacing: Number.parseFloat(style.letterSpacing) > 0
            ? Number.parseFloat(style.letterSpacing) * svgScaleX * scaleX * pageScale
            : 0,
          // Production collage captions must print at full black. The storefront
          // uses a warm near-black for screen styling, but carrying that RGB
          // value into the editable PDF makes the text look faded in print.
          color: element.closest('[data-renao-product-handle="ark3"]') ? [1, 1, 1] : [0, 0, 0],
          align,
          role: 'collage-caption',
          textObjectId: getTextObjectId(element),
        }];
      }

      const measuredLines = getElementTextLines(element);
      const lines = measuredLines.length ? measuredLines : [{
        text: sanitizeVectorText(element.textContent || ''),
        rect: elementRect,
      }];
      if (!lines[0]?.text || !elementRect.width || !elementRect.height) return [];

      const isSvgText = typeof SVGTextElement !== 'undefined' && element instanceof SVGTextElement;
      const cssFontSize = Number.parseFloat(style.fontSize) || elementRect.height;
      const role = element.hasAttribute('data-renao-preview-name') ? 'map-name'
        : element.hasAttribute('data-renao-nameplate-name-preview') ? 'nameplate-name'
          : element.hasAttribute('data-renao-nameplate-title-preview') ? 'nameplate-title'
        : element.hasAttribute('data-renao-iyiki-date-preview') ? 'iyiki-date'
          : element.hasAttribute('data-renao-iyiki-title-preview') ? 'iyiki-title'
            : element.hasAttribute('data-renao-iyiki-name-preview') ? 'iyiki-name'
              : element.getAttribute('data-renao-netflix-text-preview') === 'description' ? 'netflix-description'
                : '';
      // Iyiki text uses the exact browser metrics. Artificial font/width scaling
      // makes the editable PDF text drift from the proof after opening in Illustrator.
      const iyikiFontScale = role === 'iyiki-title' ? 0.74 : role === 'iyiki-name' ? 0.82 : 1;
      const iyikiWidthScale = role === 'iyiki-title' ? 0.95 : role === 'iyiki-name' ? 0.9 : 1;
      const renderedFontSize = isSvgText ? Math.min(cssFontSize, elementRect.height * 1.18) : cssFontSize;
      const fontSize = renderedFontSize * scaleY * pageScale * iyikiFontScale;
      const align = element.getAttribute('text-anchor') === 'middle' ? 'center' : style.textAlign;
      const explicitFontSpec = resolveVectorFontSpecByKey(element.dataset?.renaoVectorFont || '');
      const spec = explicitFontSpec || resolveVectorFontSpec(style.fontFamily, style.fontWeight, style.fontStyle);

      return lines.map(({ text, rect }) => {
        const width = rect.width * scaleX * pageScale * iyikiWidthScale;
        const height = rect.height * scaleY * pageScale;
        const left = (rect.left - cloneRect.left) * scaleX * pageScale;
        const top = (rect.top - cloneRect.top) * scaleY * pageScale;
        const baseline = pageHeight - top - height + fontSize * 0.22;
        return {
          text,
          x: align === 'center' ? left + width / 2 : align === 'right' || element.getAttribute('text-anchor') === 'end' ? left + width : left,
          y: baseline,
          width,
          fontSize,
          fontSpec: spec,
          fontWeight: style.fontWeight,
          direction: style.direction || 'ltr',
          letterSpacing: Number.parseFloat(style.letterSpacing) > 0 ? Number.parseFloat(style.letterSpacing) * scaleX * pageScale : 0,
          color: parseCssColor(style.color),
          align: align === 'center' || align === 'right' ? align : 'left',
          role,
          textObjectId: getTextObjectId(element),
        };
      });
    });
  };

  const collectCollageHeartOverlay = (clone, canvas) => {
    if (!clone?.classList?.contains('renao-collage-plaque')) return null;

    const heartElement = clone.querySelector('.renao-collage-caption__heart');
    const cloneRect = clone.getBoundingClientRect();
    if (!heartElement || !cloneRect.width || !cloneRect.height) return null;

    const scaleX = canvas.width / cloneRect.width;
    const scaleY = canvas.height / cloneRect.height;
    const pageScale = 72 / EXPORT_DPI;
    const pageHeight = canvas.height * pageScale;

    const heartRect = heartElement.getBoundingClientRect();
    const heartScale = 1;
    const originalHeartWidth = heartRect.width * scaleX * pageScale;
    const originalHeartHeight = heartRect.height * scaleY * pageScale;
    const heartWidth = originalHeartWidth * heartScale;
    const heartHeight = originalHeartHeight * heartScale;
    const originalHeartX = (heartRect.left - cloneRect.left) * scaleX * pageScale;
    const originalHeartY = pageHeight - ((heartRect.top - cloneRect.top) * scaleY * pageScale) - originalHeartHeight;
    const heartX = originalHeartX - (heartWidth - originalHeartWidth) / 2;
    const heartY = originalHeartY - (heartHeight - originalHeartHeight) / 2;

    return heartWidth && heartHeight ? {
      heart: {
        x: heartX,
        y: heartY,
        width: heartWidth,
        height: heartHeight,
      },
    } : null;
  };

  const collectAnneZarifHeartOverlay = (clone, canvas) => {
    const handle = String(clone?.dataset?.renaoProductHandle || '').trim().toLowerCase();
    if (handle !== 'en-guzel-uc-animiz-zarif-model') return null;
    const element = clone.querySelector('.renao-anne-zarif-art--heart');
    const cloneRect = clone.getBoundingClientRect();
    const rect = element?.getBoundingClientRect();
    if (!element || !cloneRect.width || !cloneRect.height || !rect?.width || !rect?.height) return null;
    const scaleX = canvas.width / cloneRect.width;
    const scaleY = canvas.height / cloneRect.height;
    const pageScale = 72 / EXPORT_DPI;
    const pageHeight = canvas.height * pageScale;
    const width = rect.width * scaleX * pageScale;
    const height = rect.height * scaleY * pageScale;
    return {
      x: (rect.left - cloneRect.left) * scaleX * pageScale,
      y: pageHeight - (rect.top - cloneRect.top) * scaleY * pageScale - height,
      width,
      height,
      strokeWidth: Math.max(1.35, width * 0.026),
    };
  };

  const collectNetflixVectorOutlines = (clone, canvas) => {
    const cloneRect = clone?.getBoundingClientRect();
    if (!cloneRect?.width || !cloneRect?.height) return [];
    const outlineData = getNetflixOutlineData(clone);
    const scaleX = canvas.width / cloneRect.width;
    const scaleY = canvas.height / cloneRect.height;
    const pageScale = 72 / EXPORT_DPI;
    const pageHeight = canvas.height * pageScale;

    return getNetflixVectorOutlineElements(clone).map((element) => {
      const outline = outlineData[element.dataset.renaoNetflixVectorOutline];
      const bounds = outline?.layoutBounds || outline?.bounds;
      const rect = element.getBoundingClientRect();
      if (!outline?.commands || !Array.isArray(bounds) || bounds.length !== 4 || !rect.width || !rect.height) return null;
      const width = rect.width * scaleX * pageScale;
      const height = rect.height * scaleY * pageScale;
      const sourceWidth = bounds[2] - bounds[0];
      const sourceHeight = bounds[3] - bounds[1];
      if (!sourceWidth || !sourceHeight) return null;
      const outlineScaleX = width / sourceWidth;
      const outlineScaleY = height / sourceHeight;
      const left = (rect.left - cloneRect.left) * scaleX * pageScale;
      const top = (rect.top - cloneRect.top) * scaleY * pageScale;
      return {
        commands: outline.commands,
        color: parseCssColor(element.__renaoVectorOutlineStyle?.color || window.getComputedStyle(element).color),
        scaleX: outlineScaleX,
        scaleY: outlineScaleY,
        x: left - bounds[0] * outlineScaleX,
        y: pageHeight - top - height - bounds[1] * outlineScaleY,
      };
    }).filter(Boolean);
  };

  const getCssBackgroundUrl = (value) => {
    const match = String(value || '').match(/url\(["']?([^"')]+)["']?\)/i);
    return match?.[1] || '';
  };

  const collectCollageFrameVectorOverlay = async (clone) => {
    if (!clone?.classList?.contains('renao-collage-plaque')) return null;
    if (clone.dataset.renaoStackedFramesRasterized === 'true') return null;
    const layoutHandle = String(clone.dataset.renaoProductHandle || '').trim().toLowerCase();
    const sourceHandle = String(clone.dataset.renaoSourceProductHandle || layoutHandle).trim().toLowerCase();
    // Father's Day variants deliberately retain their already-approved artwork.
    if (sourceHandle.includes('baba') || !['zarif-dikey-3', 'zarif-yatay-3'].includes(layoutHandle)) return null;
    const board = clone.querySelector('.renao-collage-board');
    if (!board) return null;
    const backgroundImage = window.getComputedStyle(board, '::after').backgroundImage;
    const url = clone.classList.contains('renao-direct-jpeg-capture') && layoutHandle === 'zarif-yatay-3'
      ? getAssetUrl('renao-zarif-yatay-3-frame-vector.svg')
      : getCssBackgroundUrl(backgroundImage);
    if (!url || !url.includes('frame-vector')) return null;
    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) return null;
      const svg = new DOMParser().parseFromString(await response.text(), 'image/svg+xml').documentElement;
      const viewBox = String(svg.getAttribute('viewBox') || '').trim().split(/\s+/).map(Number);
      const width = viewBox[2];
      const height = viewBox[3];
      if (!width || !height) return null;
      const paths = Array.from(svg.querySelectorAll('path')).filter((path) => {
        const fill = String(path.getAttribute('fill') || '').replace(/\s+/g, '').toLowerCase();
        return fill === '#fff' || fill === '#ffffff' || fill === 'white' || fill === 'rgb(100%,100%,100%)';
      }).map((path) => path.getAttribute('d')).filter(Boolean);
      return paths.length ? { width, height, paths, layoutHandle } : null;
    } catch (error) {
      console.warn('Renao collage vector frame could not be loaded.', error);
      return null;
    }
  };

  const collectCollagePhotoRasterOverlays = async (clone, canvas) => {
    if (!clone?.classList?.contains('renao-collage-plaque')) return [];
    const cloneRect = clone.getBoundingClientRect();
    if (!cloneRect.width || !cloneRect.height || !canvas?.width || !canvas?.height) return [];
    const scaleX = canvas.width / cloneRect.width;
    const scaleY = canvas.height / cloneRect.height;
    const pageScale = 72 / EXPORT_DPI;
    const sourceHeight = canvas.height * pageScale;
    const overlays = [];

    for (const photo of clone.querySelectorAll('.renao-collage-frame__photo')) {
      const rect = photo.getBoundingClientRect();
      const url = getCssBackgroundUrl(window.getComputedStyle(photo).backgroundImage);
      if (!url || !rect.width || !rect.height) continue;
      const image = await loadImage(url);
      const imageCanvas = document.createElement('canvas');
      imageCanvas.width = image.naturalWidth;
      imageCanvas.height = image.naturalHeight;
      const context = imageCanvas.getContext('2d', { willReadFrequently: true });
      context.drawImage(image, 0, 0);
      const rgba = context.getImageData(0, 0, imageCanvas.width, imageCanvas.height).data;
      const encoded = await runPdfWorker('encode-rgba', {
        rgba: rgba.buffer,
        width: imageCanvas.width,
        height: imageCanvas.height,
      }, [rgba.buffer]);
      overlays.push({
        widthPx: imageCanvas.width,
        heightPx: imageCanvas.height,
        rgbBytes: new Uint8Array(encoded.rgb),
        rgbFilter: encoded.rgbCompressed ? ' /Filter /FlateDecode' : '',
        alphaBytes: encoded.alpha ? new Uint8Array(encoded.alpha) : null,
        alphaFilter: encoded.alphaCompressed ? ' /Filter /FlateDecode' : '',
        x: (rect.left - cloneRect.left) * scaleX * pageScale,
        y: sourceHeight - (rect.bottom - cloneRect.top) * scaleY * pageScale,
        width: rect.width * scaleX * pageScale,
        height: rect.height * scaleY * pageScale,
      });
      imageCanvas.width = 1;
      imageCanvas.height = 1;
    }
    return overlays;
  };

  const parseSourceCropRecipe = (value) => {
    const fields = Object.fromEntries(String(value || '').split(',').map((part) => {
      const separator = part.indexOf(':');
      return separator < 0 ? ['', ''] : [part.slice(0, separator).trim(), part.slice(separator + 1).trim()];
    }));
    const crop = ['sx', 'sy', 'sw', 'sh'].map((key) => Number.parseFloat(fields[key]));
    return crop.every(Number.isFinite) && crop[2] > 0 && crop[3] > 0
      ? { sx: crop[0], sy: crop[1], sw: crop[2], sh: crop[3] }
      : null;
  };

  const jpegDimensions = (bytes) => {
    if (!(bytes instanceof Uint8Array) || bytes.length < 4 || bytes[0] !== 0xff || bytes[1] !== 0xd8) return null;
    let offset = 2;
    while (offset + 8 < bytes.length) {
      if (bytes[offset] !== 0xff) {
        offset += 1;
        continue;
      }
      const marker = bytes[offset + 1];
      if ([0xc0, 0xc1, 0xc2, 0xc3, 0xc5, 0xc6, 0xc7, 0xc9, 0xca, 0xcb, 0xcd, 0xce, 0xcf].includes(marker)) {
        return {
          height: (bytes[offset + 5] << 8) | bytes[offset + 6],
          width: (bytes[offset + 7] << 8) | bytes[offset + 8],
        };
      }
      if (marker === 0xd9 || marker === 0xda) break;
      const length = (bytes[offset + 2] << 8) | bytes[offset + 3];
      if (!length) break;
      offset += length + 2;
    }
    return null;
  };

  const zarifYatayClipPoints = {
    1: [[0.8934, 1], [0, 0.9353], [0.1066, 0], [1, 0.0647]],
    2: [[1, 0.8499], [0.2333, 1], [0, 0.15], [0.7666, 0]],
    3: [[0.8934, 1], [0, 0.9353], [0.1066, 0], [1, 0.0647]],
  };

  const collectZarifYatayDirectJpegOverlays = async (root, clone, canvas) => {
    const cloneRect = clone?.getBoundingClientRect();
    if (!cloneRect?.width || !cloneRect?.height || !canvas?.width || !canvas?.height) return [];
    const scaleX = canvas.width / cloneRect.width;
    const scaleY = canvas.height / cloneRect.height;
    const pageScale = 72 / EXPORT_DPI;
    const sourceHeight = canvas.height * pageScale;
    const overlays = [];

    // Back-to-front stacking: center, left, right.
    for (const slot of [2, 1, 3]) {
      const photo = clone.querySelector(`.renao-collage-frame--${slot} .renao-collage-frame__photo`);
      const slotState = root?.__renaoCollageSlots?.find((item) => Number(item.slot) === slot);
      const sourceImage = root?.querySelector(`[data-renao-collage-preview-image="${slot}"]`);
      const positionInput = root?.querySelector(`[data-renao-collage-position="${slot}"]`) || slotState?.position;
      const crop = parseSourceCropRecipe(positionInput?.value || slotState?.position?.value);
      const rect = photo?.getBoundingClientRect();
      const url = String(sourceImage?.currentSrc || sourceImage?.src || slotState?.objectUrl || slotState?.existingUrl || '').trim();
      if (!rect?.width || !rect?.height || !url || !crop) {
        throw new Error(`zarif-yatay-3: ${slot}. fotoğrafın doğrudan JPEG kırpması hazırlanamadı (kutu=${Boolean(rect?.width && rect?.height)}, url=${Boolean(url)}, kırpma=${Boolean(crop)}).`);
      }

      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`zarif-yatay-3: ${slot}. fotoğraf indirilemedi (${response.status}).`);
      const sourceBytes = new Uint8Array(await response.arrayBuffer());
      const dimensions = jpegDimensions(sourceBytes);
      let widthPx;
      let heightPx;
      let rgbBytes;
      let rgbFilter;
      let alphaBytes = null;
      let alphaFilter = '';

      if (dimensions) {
        ({ width: widthPx, height: heightPx } = dimensions);
        rgbBytes = sourceBytes;
        rgbFilter = ' /Filter /DCTDecode';
      } else {
        const image = await loadImage(url);
        const imageCanvas = document.createElement('canvas');
        imageCanvas.width = image.naturalWidth;
        imageCanvas.height = image.naturalHeight;
        const context = imageCanvas.getContext('2d', { willReadFrequently: true });
        context.drawImage(image, 0, 0);
        const rgba = context.getImageData(0, 0, imageCanvas.width, imageCanvas.height).data;
        const encoded = await runPdfWorker('encode-rgba', {
          rgba: rgba.buffer,
          width: imageCanvas.width,
          height: imageCanvas.height,
        }, [rgba.buffer]);
        widthPx = imageCanvas.width;
        heightPx = imageCanvas.height;
        rgbBytes = new Uint8Array(encoded.rgb);
        rgbFilter = encoded.rgbCompressed ? ' /Filter /FlateDecode' : '';
        alphaBytes = encoded.alpha ? new Uint8Array(encoded.alpha) : null;
        alphaFilter = encoded.alphaCompressed ? ' /Filter /FlateDecode' : '';
        imageCanvas.width = 1;
        imageCanvas.height = 1;
      }

      const frameX = (rect.left - cloneRect.left) * scaleX * pageScale;
      const frameTop = (rect.top - cloneRect.top) * scaleY * pageScale;
      const frameWidth = rect.width * scaleX * pageScale;
      const frameHeight = rect.height * scaleY * pageScale;
      const imageWidth = frameWidth / crop.sw;
      const imageHeight = frameHeight / crop.sh;
      const imageX = frameX - crop.sx * imageWidth;
      const imageTop = frameTop - crop.sy * imageHeight;
      const points = zarifYatayClipPoints[slot].map(([x, y]) => [
        frameX + x * frameWidth,
        sourceHeight - frameTop - y * frameHeight,
      ]);
      const borderPath = points.map(([x, y], index) => `${numberForPdf(x)} ${numberForPdf(y)} ${index ? 'l' : 'm'}`).concat('h').join('\n');

      overlays.push({
        widthPx,
        heightPx,
        rgbBytes,
        rgbFilter,
        alphaBytes,
        alphaFilter,
        x: imageX,
        y: sourceHeight - imageTop - imageHeight,
        width: imageWidth,
        height: imageHeight,
        clipPath: borderPath,
        borderPath,
        points,
      });
    }
    return overlays;
  };

  const collectVectorOverlay = async (clone, canvas) => ({
    texts: collectTextVectorOverlay(clone, canvas),
    outlines: collectNetflixVectorOutlines(clone, canvas),
    heart: collectCollageHeartOverlay(clone, canvas)?.heart || null,
    anneZarifHeart: collectAnneZarifHeartOverlay(clone, canvas),
    frames: await collectCollageFrameVectorOverlay(clone),
  });

  // Exact alpha contour of renao-collage-heart.png, the same artwork shown in
  // the customer proof. Inner contours preserve its hand-painted cutouts.
  const COLLAGE_HEART_SOURCE_WIDTH = 457;
  const COLLAGE_HEART_SOURCE_HEIGHT = 385;
  const COLLAGE_HEART_CONTOURS = '0,130 1,130 2,116 3,116 3,112 4,112 4,108 5,108 5,105 6,105 8,96 9,96 9,94 10,94 10,92 11,92 11,90 12,90 15,82 17,81 17,79 21,75 21,73 25,70 25,68 42,51 44,51 52,43 54,43 56,40 58,40 63,35 67,34 68,32 70,32 70,31 72,31 72,30 74,30 74,29 76,29 76,28 78,28 78,27 80,27 82,25 85,25 85,24 90,23 90,22 93,22 93,21 97,21 97,20 101,20 101,19 106,19 106,18 114,18 114,17 127,17 127,18 134,18 134,19 139,19 139,20 143,20 143,21 149,22 149,23 151,23 151,24 159,27 164,32 166,32 199,65 199,67 204,71 204,73 210,79 211,76 216,71 216,69 220,66 220,64 224,61 224,59 231,53 231,51 240,42 242,42 248,35 250,35 253,31 255,31 257,28 259,28 260,26 262,26 263,24 265,24 269,20 275,18 276,16 278,16 278,15 280,15 280,14 282,14 282,13 284,13 284,12 286,12 286,11 288,11 290,9 293,9 295,7 298,7 298,6 301,6 301,5 304,5 304,4 307,4 307,3 316,2 316,1 324,1 324,0 342,0 342,1 349,1 349,2 355,2 355,3 360,3 360,4 368,5 368,6 371,6 371,7 380,9 382,11 385,11 385,12 387,12 389,14 392,14 392,15 400,18 401,20 405,21 406,23 408,23 409,25 411,25 413,28 415,28 417,31 419,31 435,47 435,49 438,51 438,53 440,54 440,56 444,60 444,62 445,62 445,64 446,64 446,66 448,68 448,71 449,71 449,73 451,75 453,84 454,84 455,94 456,94 456,103 457,103 456,120 455,120 455,125 454,125 454,129 453,129 453,133 452,133 451,139 449,141 449,144 448,144 448,146 447,146 447,148 446,148 446,150 445,150 445,152 444,152 441,160 439,161 438,165 436,166 436,168 434,169 434,171 432,172 432,174 426,180 426,182 413,195 413,197 395,215 393,215 386,223 384,223 374,233 372,233 369,237 367,237 364,241 362,241 360,244 358,244 355,248 353,248 351,251 349,251 343,257 341,257 336,262 334,262 332,265 330,265 325,270 323,270 318,275 316,275 313,279 311,279 305,286 303,286 295,294 295,296 287,303 287,305 278,314 278,316 276,317 276,319 273,321 273,323 271,324 271,326 269,327 269,329 265,333 265,335 264,335 264,337 263,337 263,339 262,339 262,341 260,343 260,348 261,348 261,352 262,352 261,359 259,360 259,362 257,364 254,365 253,371 252,371 252,375 251,375 250,379 248,381 246,381 245,383 242,383 242,384 234,384 234,383 230,382 226,378 226,376 224,375 225,354 223,352 221,352 220,350 218,350 214,346 210,345 209,343 205,342 204,340 198,338 197,336 195,336 195,335 187,332 186,330 184,330 184,329 182,329 182,328 180,328 180,327 172,324 171,322 169,322 169,321 167,321 167,320 165,320 165,319 163,319 163,318 161,318 161,317 159,317 159,316 151,313 150,311 142,308 141,306 137,305 136,303 134,303 133,301 131,301 130,299 128,299 127,297 125,297 123,294 121,294 119,291 117,291 115,288 113,288 104,279 102,279 99,275 97,275 94,271 92,271 89,267 87,267 84,263 82,263 79,259 77,259 75,256 73,256 70,252 68,252 65,248 63,248 57,242 46,244 46,243 42,243 40,240 38,240 38,238 36,236 36,228 37,228 37,226 39,224 35,221 35,219 30,215 30,213 27,211 27,209 24,207 24,205 18,199 18,197 16,196 15,192 13,191 13,189 12,189 12,187 11,187 11,185 10,185 10,183 9,183 9,181 7,179 7,176 5,174 5,171 4,171 4,168 3,168 3,163 2,163 2,158 1,158 1,150 0,150|155,48 155,52 157,52 158,55 160,56 160,64 155,69 156,71 158,71 169,60 161,52 159,52|74,226 77,230 79,230 84,235 86,235 86,233 90,229 88,227 82,226 79,222|144,278 146,281 152,283 152,278 153,278 153,275 154,275 155,271 152,274 150,274 150,275 148,275 147,277|103,247 103,249 105,251 107,251 109,254 112,255 112,251 109,249 108,244 106,244|416,73 417,76 419,76 420,78 423,78 424,79 424,77 423,77 423,75 422,75 422,73 420,72 419,69 418,69 418,71|390,41 391,44 392,44 392,49 396,49 396,48 400,49 400,47 398,47 396,44 394,44 393,42|190,83 190,90 194,90 199,95 199,93 196,91 196,89|110,38 110,39 116,40 118,37|138,42 138,44 139,44 139,43 141,43 143,41 142,40 139,40 139,42|232,324 233,326 236,326 236,323 235,324|380,35 380,37 383,38'.split('|').map((contour) => (
    contour.split(' ').map((point) => point.split(',').map(Number))
  ));

  const buildVectorHeartPath = ({ x, y, width, height }) => {
    const commands = [];
    COLLAGE_HEART_CONTOURS.forEach((contour) => {
      contour.forEach(([sourceX, sourceY], index) => {
        const targetX = x + sourceX / COLLAGE_HEART_SOURCE_WIDTH * width;
        const targetY = y + height - sourceY / COLLAGE_HEART_SOURCE_HEIGHT * height;
        commands.push(`${numberForPdf(targetX)} ${numberForPdf(targetY)} ${index ? 'l' : 'm'}`);
      });
      commands.push('h');
    });
    commands.push('f*');
    return commands.join('\n');
  };

  const buildAnneZarifHeartPath = ({ x, y, width, height }) => {
    const point = (px, py) => `${numberForPdf(x + px * width)} ${numberForPdf(y + (1 - py) * height)}`;
    return [
      `${point(0.56, 0.93)} m`,
      `${point(0.45, 0.83)} ${point(0.13, 0.60)} ${point(0.08, 0.42)} c`,
      `${point(0.03, 0.26)} ${point(0.16, 0.20)} ${point(0.28, 0.24)} c`,
      `${point(0.42, 0.28)} ${point(0.50, 0.39)} ${point(0.55, 0.49)} c`,
      `${point(0.54, 0.31)} ${point(0.54, 0.07)} ${point(0.69, 0.05)} c`,
      `${point(0.87, 0.03)} ${point(0.91, 0.28)} ${point(0.89, 0.47)} c`,
      `${point(0.86, 0.70)} ${point(0.72, 0.83)} ${point(0.56, 0.93)} c`,
      `${point(0.53, 0.83)} m`,
      `${point(0.43, 0.74)} ${point(0.20, 0.55)} ${point(0.16, 0.41)} c`,
      `${point(0.13, 0.33)} ${point(0.20, 0.30)} ${point(0.28, 0.32)} c`,
      `${point(0.42, 0.36)} ${point(0.50, 0.47)} ${point(0.57, 0.57)} c`,
      `${point(0.61, 0.44)} ${point(0.60, 0.16)} ${point(0.69, 0.14)} c`,
      `${point(0.78, 0.12)} ${point(0.83, 0.29)} ${point(0.81, 0.46)} c`,
      `${point(0.79, 0.62)} ${point(0.67, 0.75)} ${point(0.53, 0.83)} c`,
    ].join('\n');
  };

  const deflateBytes = async (bytes) => {
    if (typeof CompressionStream === 'undefined') return { bytes, filter: '' };

    const stream = new Blob([bytes]).stream().pipeThrough(new CompressionStream('deflate'));
    return {
      bytes: new Uint8Array(await new Response(stream).arrayBuffer()),
      filter: ' /Filter /FlateDecode',
    };
  };

  const createPdfObjects = (rootObjectRef, objects) => {
    const parts = [textBytes('%PDF-1.4\n%\xFF\xFF\xFF\xFF\n')];
    const offsets = [0];
    let offset = parts[0].length;

    objects.forEach((object, index) => {
      offsets.push(offset);
      const header = textBytes(`${index + 1} 0 obj\n`);
      const body = typeof object === 'string' ? textBytes(object) : object;
      const footer = textBytes('endobj\n');
      parts.push(header, body, footer);
      offset += header.length + body.length + footer.length;
    });

    const xrefOffset = offset;
    const xrefRows = offsets.map((itemOffset, index) => (
      index === 0 ? '0000000000 65535 f \n' : `${String(itemOffset).padStart(10, '0')} 00000 n \n`
    )).join('');
    parts.push(textBytes(`xref\n0 ${objects.length + 1}\n${xrefRows}trailer\n<< /Size ${objects.length + 1} /Root ${rootObjectRef} 0 R >>\nstartxref\n${xrefOffset}\n%%EOF`));

    return new Blob([concatBytes(parts)], { type: 'application/pdf' });
  };

  const addEmbeddedFontObjects = ({ objects, font, codes, glyphRecords }) => {
    const fontFileObject = objects.length + 1;
    const descriptorObject = objects.length + 2;
    const cidToGidObject = objects.length + 3;
    const toUnicodeObject = objects.length + 4;
    const cidFontObject = objects.length + 5;
    const type0Object = objects.length + 6;
    const shapedRecords = glyphRecords?.size
      ? [...glyphRecords.values()].sort((a, b) => a.cid - b.cid)
      : null;
    const sortedCodes = shapedRecords ? shapedRecords.map((record) => record.cid) : [...codes].sort((a, b) => a - b);
    const widths = (shapedRecords || sortedCodes)
      .map((record) => shapedRecords
        ? `${record.cid} [${font.widthForGlyph(record.glyphId)}]`
        : `${record} [${font.widthForCode(record)}]`)
      .join(' ');
    const toUnicode = shapedRecords ? createGlyphToUnicodeCmap(shapedRecords) : createToUnicodeCmap(sortedCodes);

    objects.push(concatBytes([
      textBytes(font.isCff
        ? `<< /Length ${font.bytes.length} /Subtype /OpenType >>\nstream\n`
        : `<< /Length ${font.bytes.length} /Length1 ${font.bytes.length} >>\nstream\n`),
      font.bytes,
      textBytes('\nendstream\n'),
    ]));
    objects.push([
      `<< /Type /FontDescriptor /FontName /${font.pdfName}`,
      '/Flags 64 /FontBBox [-1200 -500 2200 1600] /ItalicAngle 0 /Ascent',
      String(Math.round(font.ascender / font.unitsPerEm * 1000)),
      '/Descent',
      String(Math.round(font.descender / font.unitsPerEm * 1000)),
      '/CapHeight 700 /StemV 80',
      font.isCff ? `/FontFile3 ${fontFileObject} 0 R >>\n` : `/FontFile2 ${fontFileObject} 0 R >>\n`,
    ].join(' '));

    const maxCode = Math.max(...sortedCodes, 0);
    const cidToGidMap = new Uint8Array((maxCode + 1) * 2);
    sortedCodes.forEach((code, index) => {
      const glyph = shapedRecords ? shapedRecords[index].glyphId : font.glyphForCode(code);
      cidToGidMap[code * 2] = (glyph >> 8) & 0xff;
      cidToGidMap[code * 2 + 1] = glyph & 0xff;
    });
    objects.push(concatBytes([
      textBytes(`<< /Length ${cidToGidMap.length} >>\nstream\n`),
      cidToGidMap,
      textBytes('\nendstream\n'),
    ]));

    objects.push(`<< /Length ${textBytes(toUnicode).length} >>\nstream\n${toUnicode}endstream\n`);
    objects.push([
      `<< /Type /Font /Subtype /${font.isCff ? 'CIDFontType0' : 'CIDFontType2'} /BaseFont /${font.pdfName}`,
      '/CIDSystemInfo << /Registry (Adobe) /Ordering (Identity) /Supplement 0 >>',
      `/FontDescriptor ${descriptorObject} 0 R`,
      `/CIDToGIDMap ${cidToGidObject} 0 R`,
      `/W [${widths}] >>\n`,
    ].filter(Boolean).join(' '));
    objects.push([
      `<< /Type /Font /Subtype /Type0 /BaseFont /${font.pdfName}`,
      '/Encoding /Identity-H',
      `/DescendantFonts [${cidFontObject} 0 R]`,
      `/ToUnicode ${toUnicodeObject} 0 R >>\n`,
    ].join(' '));

    return type0Object;
  };

  const CP1254_TURKISH_BYTES = new Map([
    [0x011e, 0xd0], [0x0130, 0xdd], [0x015e, 0xde],
    [0x011f, 0xf0], [0x0131, 0xfd], [0x015f, 0xfe],
  ]);
  const CP1254_TURKISH_CODES = new Map([...CP1254_TURKISH_BYTES].map(([code, byte]) => [byte, code]));
  const codePointToCp1254Byte = (code) => CP1254_TURKISH_BYTES.get(code) ?? (code <= 0xff ? code : 0x3f);
  const textToCp1254Hex = (value) => textToCodePoints(value)
    .map((code) => codePointToCp1254Byte(code).toString(16).toUpperCase().padStart(2, '0'))
    .join('');
  const createSimpleToUnicodeCmap = () => {
    const entries = [];
    for (let byte = 32; byte <= 255; byte += 1) {
      const unicode = CP1254_TURKISH_CODES.get(byte) ?? byte;
      entries.push(`<${byte.toString(16).toUpperCase().padStart(2, '0')}> <${unicode.toString(16).toUpperCase().padStart(4, '0')}>`);
    }
    const mappings = [];
    for (let index = 0; index < entries.length; index += 100) {
      const chunk = entries.slice(index, index + 100);
      mappings.push(`${chunk.length} beginbfchar\n${chunk.join('\n')}\nendbfchar`);
    }
    return `/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo << /Registry (Adobe) /Ordering (UCS) /Supplement 0 >> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<00> <FF>\nendcodespacerange\n${mappings.join('\n')}\nendcmap\nCMapName currentdict /CMap defineresource pop\nend\nend\n`;
  };

  // Illustrator opens Identity-H CID fonts as outlines in the user's print
  // workflow. Map names use a simple embedded TrueType/Windows-1254 font so
  // the complete customer name remains a live, editable text object.
  const addEditableTrueTypeFontObjects = ({ objects, font }) => {
    const descriptorObject = objects.length + 1;
    const toUnicodeObject = objects.length + 2;
    const trueTypeObject = objects.length + 3;
    const widths = [];
    for (let byte = 32; byte <= 255; byte += 1) {
      widths.push(font.widthForCode(CP1254_TURKISH_CODES.get(byte) ?? byte));
    }
    const toUnicode = createSimpleToUnicodeCmap();

    objects.push([
      `<< /Type /FontDescriptor /FontName /${font.pdfName}`,
      '/Flags 32 /FontBBox [-1200 -500 2200 1600] /ItalicAngle 0 /Ascent',
      String(Math.round(font.ascender / font.unitsPerEm * 1000)),
      '/Descent',
      String(Math.round(font.descender / font.unitsPerEm * 1000)),
      '/CapHeight 700 /StemV 80',
      '>>\n',
    ].join(' '));
    objects.push(`<< /Length ${textBytes(toUnicode).length} >>\nstream\n${toUnicode}endstream\n`);
    objects.push([
      `<< /Type /Font /Subtype /TrueType /BaseFont /${font.pdfName}`,
      '/FirstChar 32 /LastChar 255',
      `/Widths [${widths.join(' ')}]`,
      '/Encoding << /Type /Encoding /BaseEncoding /WinAnsiEncoding /Differences [208 /Gbreve 221 /Idotaccent 222 /Scedilla 240 /gbreve 253 /dotlessi 254 /scedilla] >>',
      `/FontDescriptor ${descriptorObject} 0 R`,
      `/ToUnicode ${toUnicodeObject} 0 R >>\n`,
    ].join(' '));
    return trueTypeObject;
  };

  const loadVectorTextFonts = async (textItems) => {
    const fontEntries = new Map();
    const items = await Promise.all(textItems.map(async (item) => {
      if (!item.fontSpec) return { ...item, fontKey: 'base-helvetica', font: null };
      if (item.fontSpec.file === null) {
        const fontKey = item.fontSpec.key || item.fontSpec.pdfName || 'base-helvetica';
        if (!fontEntries.has(fontKey)) {
          fontEntries.set(fontKey, {
            font: null,
            baseFontName: item.fontSpec.pdfName || 'Helvetica',
            codes: new Set(),
            resourceName: `F${fontEntries.size}`,
          });
        }
        return { ...item, fontKey, font: null };
      }

      try {
        let font = await loadVectorFont(item.fontSpec);
        let fontSpec = item.fontSpec;
        if (font && !vectorFontSupportsText(font, item.text)) {
          const fallbackSpec = resolveVectorFontSpecByKey(cssFontWeightNumber(item.fontWeight) >= 650 ? 'montserrat-bold' : 'montserrat');
          const fallbackFont = fallbackSpec ? await loadVectorFont(fallbackSpec) : null;
          if (fallbackFont && vectorFontSupportsText(fallbackFont, item.text)) {
            font = fallbackFont;
            fontSpec = fallbackSpec;
          }
        }

        const simpleEncoding = item.role === 'map-name' && font && !font.isCff;
        const fontKey = `${font?.key || fontSpec?.key || 'base-helvetica'}${simpleEncoding ? '-editable' : ''}`;
        if (font && !fontEntries.has(fontKey)) {
          fontEntries.set(fontKey, {
            font,
            simpleEncoding,
            codes: new Set(),
            glyphRecords: new Map(),
            glyphRecordKeys: new Map(),
            nextCid: 1,
            resourceName: `F${fontEntries.size}`,
          });
        }
        const fontEntry = fontEntries.get(fontKey);
        textToCodePoints(item.text).forEach((code) => fontEntry?.codes.add(code));

        let shapedGlyphs = null;
        try {
          if (simpleEncoding) throw new Error('Editable map names use direct character encoding.');
          shapedGlyphs = await runPdfWorker('shape-text', {
            fontKey,
            fontUrl: getAssetUrl(fontSpec.file),
            text: item.text,
            direction: item.direction || 'ltr',
            language: document.documentElement.lang || 'tr',
          });
          const clusters = [...new Set(shapedGlyphs.map((glyph) => glyph.cluster))].sort((a, b) => a - b);
          const unicodeByCluster = new Map(clusters.map((cluster, index) => [
            cluster,
            item.text.slice(cluster, clusters[index + 1] ?? item.text.length) || '\u200B',
          ]));
          const usedClusters = new Set();
          shapedGlyphs = shapedGlyphs.map((glyph) => {
            const unicode = usedClusters.has(glyph.cluster) ? '\u200B' : unicodeByCluster.get(glyph.cluster) || '\u200B';
            usedClusters.add(glyph.cluster);
            const recordKey = `${glyph.glyphId}:${unicode}`;
            let cid = fontEntry.glyphRecordKeys.get(recordKey);
            if (!cid) {
              cid = fontEntry.nextCid++;
              fontEntry.glyphRecordKeys.set(recordKey, cid);
              fontEntry.glyphRecords.set(cid, { cid, glyphId: glyph.glyphId, unicode });
            }
            return { ...glyph, cid };
          });
        } catch (error) {
          if (!simpleEncoding) console.warn('Renao HarfBuzz shaping failed; using the legacy text positioning.', error);
        }

        return { ...item, fontKey, font, fontSpec, shapedGlyphs };
      } catch (error) {
        console.warn(`Renao vector text font could not be embedded (${item.fontSpec?.key || 'unknown'} / ${item.fontSpec?.file || 'no-file'}).`, error);
        return { ...item, fontKey: 'base-helvetica', font: null };
      }
    }));

    const legacyFontKeys = new Set(items
      .filter((item) => item.font && (!Array.isArray(item.shapedGlyphs) || !item.shapedGlyphs.length))
      .map((item) => item.fontKey));
    legacyFontKeys.forEach((fontKey) => {
      const entry = fontEntries.get(fontKey);
      entry?.glyphRecords?.clear();
      entry?.glyphRecordKeys?.clear();
      items.forEach((item) => {
        if (item.fontKey === fontKey) item.shapedGlyphs = null;
      });
    });

    if (items.some((item) => item.fontKey === 'base-helvetica')) {
      fontEntries.set('base-helvetica', {
        font: null,
        baseFontName: 'Helvetica',
        codes: new Set(),
        resourceName: `F${fontEntries.size}`,
      });
    }

    return { items, fontEntries };
  };

  const buildTextCommand = ({ item, fontEntry }) => {
    const font = fontEntry.font;
    const letterSpacing = Number(item.letterSpacing) || 0;
    const adjustedAnchorX = item.x;
    const y = item.role === 'iyiki-date'
      ? item.y - item.fontSize * 0.05
      : item.role === 'iyiki-title'
        ? item.y + item.fontSize * 0.12
      : item.role === 'iyiki-name'
        ? item.y + item.fontSize * 0.15
      : item.role === 'nameplate-name'
        ? item.y + item.fontSize
      : item.role === 'map-name' && item.fontSpec?.key === 'acardia'
      ? item.y + item.fontSize * 0.71
      : item.y;
    const [r, g, b] = item.color || [0, 0, 0];

    // Keep every customer-entered field in one PDF text object. HarfBuzz still
    // supplies the correct glyphs/kerning, but Illustrator can select and edit the
    // complete value with a double-click instead of exposing one object per glyph.
    if (font && Array.isArray(item.shapedGlyphs) && item.shapedGlyphs.length) {
      const glyphAdvance = item.shapedGlyphs.reduce((sum, glyph) => sum + glyph.xAdvance * item.fontSize / 1000, 0);
      const nominalWidth = glyphAdvance + Math.max(0, item.shapedGlyphs.length - 1) * letterSpacing;
      const desiredWidth = item.width || nominalWidth;
      const horizontalScale = nominalWidth > 0 && desiredWidth > 0 ? desiredWidth / nominalWidth : 1;
      const drawWidth = nominalWidth * horizontalScale;
      const startX = item.align === 'center'
        ? adjustedAnchorX - drawWidth / 2
        : item.align === 'right'
          ? adjustedAnchorX - drawWidth
          : adjustedAnchorX;
      const textArray = [];
      item.shapedGlyphs.forEach((glyph, index) => {
        textArray.push(`<${glyph.cid.toString(16).toUpperCase().padStart(4, '0')}>`);
        if (index >= item.shapedGlyphs.length - 1) return;
        const naturalAdvance = font.widthForGlyph(glyph.glyphId) * item.fontSize / 1000;
        const desiredAdvance = glyph.xAdvance * item.fontSize / 1000 + letterSpacing;
        const adjustment = (naturalAdvance - desiredAdvance) * 1000 / item.fontSize;
        if (Math.abs(adjustment) > 0.001) textArray.push(numberForPdf(adjustment));
      });
      return [
        'BT',
        `/${fontEntry.resourceName} ${numberForPdf(item.fontSize)} Tf`,
        `${numberForPdf(r)} ${numberForPdf(g)} ${numberForPdf(b)} rg`,
        `${numberForPdf(horizontalScale)} 0 0 1 ${numberForPdf(startX)} ${numberForPdf(y)} Tm`,
        `[${textArray.join(' ')}] TJ`,
        'ET',
      ].join('\n');
    }

    const codePointCount = textToCodePoints(item.text).length;
    const glyphWidth = font
      ? pdfTextWidth(font, item.text, item.fontSize)
      : item.text.length * item.fontSize * 0.52;
    const nominalWidth = glyphWidth + Math.max(0, codePointCount - 1) * letterSpacing;
    const desiredWidth = item.width || nominalWidth;
    const horizontalScale = nominalWidth > 0 && desiredWidth > 0 ? desiredWidth / nominalWidth : 1;
    const drawWidth = nominalWidth * horizontalScale;
    const x = item.align === 'center' ? adjustedAnchorX - drawWidth / 2 : item.align === 'right' ? adjustedAnchorX - drawWidth : adjustedAnchorX;
    const textCommand = font
      ? `<${fontEntry.simpleEncoding ? textToCp1254Hex(item.text) : textToPdfHex(item.text)}> Tj`
      : `(${escapePdfLiteral(item.text)}) Tj`;
    const charSpacing = letterSpacing > 0 ? letterSpacing / horizontalScale : 0;

    return [
      'BT',
      `/${fontEntry.resourceName} ${numberForPdf(item.fontSize)} Tf`,
      `${numberForPdf(r)} ${numberForPdf(g)} ${numberForPdf(b)} rg`,
      charSpacing > 0 ? `${numberForPdf(charSpacing)} Tc` : '',
      `${numberForPdf(horizontalScale)} 0 0 1 ${numberForPdf(x)} ${numberForPdf(y)} Tm`,
      textCommand,
      'ET',
    ].filter(Boolean).join('\n');
  };

  const buildMultilineTextCommand = ({ items, fontEntry }) => {
    if (!items.length) return '';
    const font = fontEntry.font;
    const lineData = items.map((item) => {
      const letterSpacing = Number(item.letterSpacing) || 0;
      let nominalWidth;
      let showCommand;
      if (font && Array.isArray(item.shapedGlyphs) && item.shapedGlyphs.length) {
        const glyphAdvance = item.shapedGlyphs.reduce((sum, glyph) => sum + glyph.xAdvance * item.fontSize / 1000, 0);
        nominalWidth = glyphAdvance + Math.max(0, item.shapedGlyphs.length - 1) * letterSpacing;
        const textArray = [];
        item.shapedGlyphs.forEach((glyph, index) => {
          textArray.push(`<${glyph.cid.toString(16).toUpperCase().padStart(4, '0')}>`);
          if (index >= item.shapedGlyphs.length - 1) return;
          const naturalAdvance = font.widthForGlyph(glyph.glyphId) * item.fontSize / 1000;
          const desiredAdvance = glyph.xAdvance * item.fontSize / 1000 + letterSpacing;
          const adjustment = (naturalAdvance - desiredAdvance) * 1000 / item.fontSize;
          if (Math.abs(adjustment) > 0.001) textArray.push(numberForPdf(adjustment));
        });
        showCommand = `[${textArray.join(' ')}] TJ`;
      } else {
        const codePointCount = textToCodePoints(item.text).length;
        const glyphWidth = font ? pdfTextWidth(font, item.text, item.fontSize) : item.text.length * item.fontSize * 0.52;
        nominalWidth = glyphWidth + Math.max(0, codePointCount - 1) * letterSpacing;
        showCommand = font
          ? `<${fontEntry.simpleEncoding ? textToCp1254Hex(item.text) : textToPdfHex(item.text)}> Tj`
          : `(${escapePdfLiteral(item.text)}) Tj`;
      }
      const horizontalScale = nominalWidth > 0 && item.width > 0 ? item.width / nominalWidth : 1;
      const drawWidth = nominalWidth * horizontalScale;
      const x = item.align === 'center' ? item.x - drawWidth / 2 : item.align === 'right' ? item.x - drawWidth : item.x;
      return { ...item, horizontalScale, showCommand, x };
    });

    const first = lineData[0];
    const [r, g, b] = first.color || [0, 0, 0];
    const commands = [
      'BT',
      `/${fontEntry.resourceName} ${numberForPdf(first.fontSize)} Tf`,
      `${numberForPdf(r)} ${numberForPdf(g)} ${numberForPdf(b)} rg`,
      `1 0 0 1 ${numberForPdf(first.x)} ${numberForPdf(first.y)} Tm`,
      `${numberForPdf(first.horizontalScale * 100)} Tz`,
      first.showCommand,
    ];
    let previous = first;
    lineData.slice(1).forEach((line) => {
      commands.push(`${numberForPdf(line.x - previous.x)} ${numberForPdf(line.y - previous.y)} Td`);
      if (line.fontSize !== previous.fontSize) commands.push(`/${fontEntry.resourceName} ${numberForPdf(line.fontSize)} Tf`);
      commands.push(`${numberForPdf(line.horizontalScale * 100)} Tz`);
      commands.push(line.showCommand);
      previous = line;
    });
    commands.push('ET');
    return commands.join('\n');
  };

  const mergeTextObjectCommands = (commands) => {
    if (commands.length <= 1) return commands[0] || '';
    return [
      'BT',
      ...commands.map((command) => command.replace(/^BT\n/, '').replace(/\nET$/, '')),
      'ET',
    ].join('\n');
  };

  const buildCollageFramePdfPathGroups = (frameOverlay, sourceWidth, sourceHeight) => {
    if (!frameOverlay?.paths?.length || !frameOverlay.width || !frameOverlay.height) return [];
    const scaleX = sourceWidth / frameOverlay.width;
    const scaleY = sourceHeight / frameOverlay.height;
    const numberPattern = /^[-+]?(?:\d*\.?\d+)(?:e[-+]?\d+)?$/i;
    return frameOverlay.paths.map((pathData) => {
      if (frameOverlay.layoutHandle === 'zarif-dikey-3') {
        // Illustrator-safe frame: turn each compound ring into four ordinary
        // filled quadrilaterals. There is no even-odd hole and no clipping mask
        // for Illustrator to reinterpret, while every edge remains true vector.
        const tokens = String(pathData).match(/[MLZmlz]|[-+]?(?:\d*\.?\d+)(?:e[-+]?\d+)?/gi) || [];
        const polygons = [];
        let polygon = [];
        let index = 0;
        while (index < tokens.length) {
          const token = tokens[index++];
          if (/^[Mm]$/.test(token)) {
            if (polygon.length >= 3) polygons.push(polygon);
            polygon = [];
            if (index + 1 < tokens.length) polygon.push([Number(tokens[index++]), Number(tokens[index++])]);
          } else if (/^[Ll]$/.test(token)) {
            if (index + 1 < tokens.length) polygon.push([Number(tokens[index++]), Number(tokens[index++])]);
          } else if (/^[Zz]$/.test(token)) {
            if (polygon.length >= 3) polygons.push(polygon);
            polygon = [];
          }
        }
        if (polygon.length >= 3) polygons.push(polygon);
        const rings = polygons.filter((points) => points.length === 4).slice(0, 2);
        if (rings.length === 2) {
          const area = (points) => Math.abs(points.reduce((sum, point, pointIndex) => {
            const next = points[(pointIndex + 1) % points.length];
            return sum + point[0] * next[1] - next[0] * point[1];
          }, 0) / 2);
          const [inner, outer] = rings.sort((left, right) => area(left) - area(right));
          const sortCorners = (points) => {
            const center = points.reduce(([x, y], point) => [x + point[0], y + point[1]], [0, 0]).map((value) => value / points.length);
            return [...points].sort((left, right) => Math.atan2(left[1] - center[1], left[0] - center[0]) - Math.atan2(right[1] - center[1], right[0] - center[0]));
          };
          const innerCorners = sortCorners(inner);
          const outerCorners = sortCorners(outer);
          return outerCorners.map((outerPoint, cornerIndex) => {
            const next = (cornerIndex + 1) % 4;
            const points = [outerPoint, outerCorners[next], innerCorners[next], innerCorners[cornerIndex]];
            return points.map(([x, y], pointIndex) => `${numberForPdf(x * scaleX)} ${numberForPdf(sourceHeight - y * scaleY)} ${pointIndex ? 'l' : 'm'}`).concat(['h', 'f']).join('\n');
          }).join('\n');
        }
      }
      const output = [];
      const tokens = String(pathData).match(/[MLCZmlcz]|[-+]?(?:\d*\.?\d+)(?:e[-+]?\d+)?/gi) || [];
      let index = 0;
      let command = '';
      while (index < tokens.length) {
        if (!numberPattern.test(tokens[index])) command = tokens[index++];
        const upper = command.toUpperCase();
        if (upper === 'M' || upper === 'L') {
          if (index + 1 >= tokens.length) break;
          const x = Number(tokens[index++]) * scaleX;
          const y = sourceHeight - Number(tokens[index++]) * scaleY;
          output.push(`${numberForPdf(x)} ${numberForPdf(y)} ${upper === 'M' ? 'm' : 'l'}`);
          command = upper === 'M' ? 'L' : command;
        } else if (upper === 'C') {
          if (index + 5 >= tokens.length) break;
          const values = tokens.slice(index, index + 6).map(Number);
          index += 6;
          output.push([
            numberForPdf(values[0] * scaleX), numberForPdf(sourceHeight - values[1] * scaleY),
            numberForPdf(values[2] * scaleX), numberForPdf(sourceHeight - values[3] * scaleY),
            numberForPdf(values[4] * scaleX), numberForPdf(sourceHeight - values[5] * scaleY),
            'c',
          ].join(' '));
        } else if (upper === 'Z') {
          output.push('h');
          command = '';
        } else {
          // The supplied artwork only uses absolute M/L/C/Z commands.
          break;
        }
      }
      output.push('f*');
      return output.join('\n');
    });
  };

  const buildZarifYatayOuterFramePoints = (sourceWidth, sourceHeight) => {
    const sourceArtWidth = 425.197;
    const sourceArtHeight = 283.465;
    const scaleX = sourceWidth / sourceArtWidth;
    const scaleY = sourceHeight / sourceArtHeight;
    return [
      [[132.9, 44.5], [255.8, 16.4], [297.6, 202.4], [174.2, 229.3]],
      [[53.4, 44.4], [175.8, 54.5], [159.6, 244.6], [33.7, 234.2]],
      [[268.3, 44.4], [390.7, 54.5], [374.4, 244.6], [248.6, 234.2]],
    ].map((polygon) => polygon.map(([x, y]) => [
      x * scaleX,
      sourceHeight - y * scaleY,
    ]));
  };

  const buildPdfFromCanvas = async (canvas, vectorOverlay = null, pageSizeCm = null, preserveAlpha = false) => {
    const context = canvas.getContext?.('2d') || null;
    let hasAlpha = false;
    let rgbStream;
    let alphaStream;

    if (canvas.__renaoJpegBytes) {
      rgbStream = {
        bytes: canvas.__renaoJpegBytes,
        filter: ' /Filter /DCTDecode',
      };
    } else if (!pageSizeCm && !preserveAlpha) {
      const jpegBlob = await canvasToBlob(canvas, 'image/jpeg', JPEG_QUALITY);
      rgbStream = {
        bytes: await blobToBytes(jpegBlob),
        filter: ' /Filter /DCTDecode',
      };
    } else try {
      const rgba = context.getImageData(0, 0, canvas.width, canvas.height).data;
      const result = await runPdfWorker('encode-rgba', {
        rgba: rgba.buffer,
        width: canvas.width,
        height: canvas.height,
      }, [rgba.buffer]);
      hasAlpha = result.hasAlpha;
      rgbStream = {
        bytes: new Uint8Array(result.rgb),
        filter: result.rgbCompressed ? ' /Filter /FlateDecode' : '',
      };
      alphaStream = result.alpha ? {
        bytes: new Uint8Array(result.alpha),
        filter: result.alphaCompressed ? ' /Filter /FlateDecode' : '',
      } : null;
    } catch (error) {
      console.warn('Renao PDF worker encoding failed; using the local encoder.', error);
      const imageData = context.getImageData(0, 0, canvas.width, canvas.height).data;
      const pixelCount = canvas.width * canvas.height;
      const rgbBytes = new Uint8Array(pixelCount * 3);
      const alphaBytes = new Uint8Array(pixelCount);
      for (let sourceIndex = 0, pixelIndex = 0, rgbIndex = 0; pixelIndex < pixelCount; sourceIndex += 4, pixelIndex += 1, rgbIndex += 3) {
        rgbBytes[rgbIndex] = imageData[sourceIndex];
        rgbBytes[rgbIndex + 1] = imageData[sourceIndex + 1];
        rgbBytes[rgbIndex + 2] = imageData[sourceIndex + 2];
        alphaBytes[pixelIndex] = imageData[sourceIndex + 3];
        if (imageData[sourceIndex + 3] < 255) hasAlpha = true;
      }
      rgbStream = await deflateBytes(rgbBytes);
      alphaStream = hasAlpha ? await deflateBytes(alphaBytes) : null;
    }
    const sourceWidth = canvas.width * 72 / EXPORT_DPI;
    const sourceHeight = canvas.height * 72 / EXPORT_DPI;
    const pageWidth = pageSizeCm?.width ? pageSizeCm.width * 72 / 2.54 : sourceWidth;
    const pageHeight = pageSizeCm?.height ? pageSizeCm.height * 72 / 2.54 : sourceHeight;
    const contentScale = pageSizeCm?.fit === 'cover'
      ? Math.max(pageWidth / sourceWidth, pageHeight / sourceHeight)
      : Math.min(pageWidth / sourceWidth, pageHeight / sourceHeight);
    const contentWidth = sourceWidth * contentScale;
    const contentHeight = sourceHeight * contentScale;
    const contentX = (pageWidth - contentWidth) / 2;
    const contentY = (pageHeight - contentHeight) / 2;
    const objects = [];

    let alphaObject = null;

    if (hasAlpha && alphaStream) {
      alphaObject = objects.length + 1;
      objects.push(concatBytes([
        textBytes(`<< /Type /XObject /Subtype /Image /Width ${canvas.width} /Height ${canvas.height} /ColorSpace /DeviceGray /BitsPerComponent 8${alphaStream.filter} /Length ${alphaStream.bytes.length} >>\nstream\n`),
        alphaStream.bytes,
        textBytes('\nendstream\n'),
      ]));
    }

    const imageObject = objects.length + 1;
    const imageDictionary = [
      `<< /Type /XObject /Subtype /Image /Width ${canvas.width} /Height ${canvas.height}`,
      '/ColorSpace /DeviceRGB /BitsPerComponent 8',
      rgbStream.filter,
      alphaObject ? ` /SMask ${alphaObject} 0 R` : '',
      ` /Length ${rgbStream.bytes.length} >>\nstream\n`,
    ].join(' ');
    objects.push(concatBytes([
      textBytes(imageDictionary),
      rgbStream.bytes,
      textBytes('\nendstream\n'),
    ]));

    const photoRasterResources = [];
    const photoRasterItems = Array.isArray(vectorOverlay?.photoRasters) ? vectorOverlay.photoRasters : [];
    photoRasterItems.forEach((photo, index) => {
      let photoAlphaObject = null;
      if (photo.alphaBytes?.length) {
        photoAlphaObject = objects.length + 1;
        objects.push(concatBytes([
          textBytes(`<< /Type /XObject /Subtype /Image /Width ${photo.widthPx} /Height ${photo.heightPx} /ColorSpace /DeviceGray /BitsPerComponent 8${photo.alphaFilter || ''} /Length ${photo.alphaBytes.length} >>\nstream\n`),
          photo.alphaBytes,
          textBytes('\nendstream\n'),
        ]));
      }
      const objectRef = objects.length + 1;
      objects.push(concatBytes([
        textBytes(`<< /Type /XObject /Subtype /Image /Width ${photo.widthPx} /Height ${photo.heightPx} /ColorSpace /DeviceRGB /BitsPerComponent 8${photo.rgbFilter || ''}${photoAlphaObject ? ` /SMask ${photoAlphaObject} 0 R` : ''} /Length ${photo.rgbBytes.length} >>\nstream\n`),
        photo.rgbBytes,
        textBytes('\nendstream\n'),
      ]));
      photoRasterResources.push({ ...photo, name: `Photo${index + 1}`, objectRef });
    });

    const textItems = Array.isArray(vectorOverlay?.texts) ? vectorOverlay.texts : [];
    const outlineItems = Array.isArray(vectorOverlay?.outlines) ? vectorOverlay.outlines : [];
    const { items, fontEntries } = await loadVectorTextFonts(textItems);
    const fontResources = [];

    fontEntries.forEach((entry, key) => {
      if (!entry.font) {
        const ref = objects.length + 1;
        objects.push(`<< /Type /Font /Subtype /Type1 /BaseFont /${entry.baseFontName || 'Helvetica'} /Encoding /WinAnsiEncoding >>\n`);
        fontResources.push(`/${entry.resourceName} ${ref} 0 R`);
        return;
      }
      const ref = entry.simpleEncoding
        ? addEditableTrueTypeFontObjects({ objects, font: entry.font })
        : addEmbeddedFontObjects({
          objects,
          font: entry.font,
          codes: Array.from(entry.codes),
          glyphRecords: entry.glyphRecords,
        });
      fontResources.push(`/${entry.resourceName} ${ref} 0 R`);
    });

    // Keep Zarif Yatay's direct-JPEG card stacking and add shadows as separate
    // transparent PDF images. Customer JPEG streams remain untouched.
    const useDirectFrameLayers = vectorOverlay?.zarifYatayDirectShadows === true;
    const cardShadowPadding = 0.085;
    let cardShadowObject = null;
    if (useDirectFrameLayers) {
      const addTransparentBlackImage = async (size, alphaForPixel) => {
        const rgb = new Uint8Array(size * size * 3);
        const alpha = new Uint8Array(size * size);
        for (let row = 0; row < size; row += 1) {
          for (let column = 0; column < size; column += 1) {
            const u = (column + 0.5) / size;
            const v = 1 - ((row + 0.5) / size);
            alpha[row * size + column] = Math.max(0, Math.min(255, Math.round(alphaForPixel(u, v))));
          }
        }
        const [rgbStream, alphaStream] = await Promise.all([deflateBytes(rgb), deflateBytes(alpha)]);
        const alphaObject = objects.length + 1;
        objects.push(concatBytes([
          textBytes(`<< /Type /XObject /Subtype /Image /Width ${size} /Height ${size} /ColorSpace /DeviceGray /BitsPerComponent 8${alphaStream.filter} /Length ${alphaStream.bytes.length} >>\nstream\n`),
          alphaStream.bytes,
          textBytes('\nendstream\n'),
        ]));
        const imageObjectRef = objects.length + 1;
        objects.push(concatBytes([
          textBytes(`<< /Type /XObject /Subtype /Image /Width ${size} /Height ${size} /ColorSpace /DeviceRGB /BitsPerComponent 8${rgbStream.filter} /SMask ${alphaObject} 0 R /Length ${rgbStream.bytes.length} >>\nstream\n`),
          rgbStream.bytes,
          textBytes('\nendstream\n'),
        ]));
        return imageObjectRef;
      };

      const outerPadding = cardShadowPadding;
      const outerSigma = 0.032;
      cardShadowObject = await addTransparentBlackImage(384, (u, v) => {
        const left = outerPadding + 0.003;
        const right = 1 - outerPadding + 0.003;
        const bottom = outerPadding - 0.004;
        const top = 1 - outerPadding - 0.004;
        const dx = u < left ? left - u : (u > right ? u - right : 0);
        const dy = v < bottom ? bottom - v : (v > top ? v - top : 0);
        const distance = Math.hypot(dx, dy);
        return 22 * Math.exp(-(distance * distance) / (2 * outerSigma * outerSigma));
      });
    }

    const framePathGroups = buildCollageFramePdfPathGroups(vectorOverlay?.frames, sourceWidth, sourceHeight);
    const splitLandscapeFrames = vectorOverlay?.frames?.layoutHandle === 'zarif-yatay-3' && framePathGroups.length === 3;
    const lowerFramePathCommands = splitLandscapeFrames ? framePathGroups[0] : '';
    const upperFramePathCommands = splitLandscapeFrames ? framePathGroups.slice(1).join('\n') : framePathGroups.join('\n');
    const contentLines = [];
    // Preserve the generic renderer's existing frame order. The direct-photo
    // collage below instead paints each complete card as one layer.
    if (!useDirectFrameLayers && lowerFramePathCommands) {
      contentLines.push(`q ${numberForPdf(contentScale)} 0 0 ${numberForPdf(contentScale)} ${numberForPdf(contentX)} ${numberForPdf(contentY)} cm\nq\n1 1 1 rg\n${lowerFramePathCommands}\nQ\nQ`);
    }
    contentLines.push(`q ${numberForPdf(contentWidth)} 0 0 ${numberForPdf(contentHeight)} ${numberForPdf(contentX)} ${numberForPdf(contentY)} cm /Im0 Do Q`);
    const hasOverlayContent = photoRasterResources.length || items.length || outlineItems.length || vectorOverlay?.heart || vectorOverlay?.anneZarifHeart || upperFramePathCommands || (useDirectFrameLayers && framePathGroups.length);
    if (hasOverlayContent) {
      contentLines.push(`q ${numberForPdf(contentScale)} 0 0 ${numberForPdf(contentScale)} ${numberForPdf(contentX)} ${numberForPdf(contentY)} cm`);
    }
    const pushPhoto = (photo) => {
      contentLines.push(photo.clipPath
        ? `q\n${photo.clipPath}\nW n\n${numberForPdf(photo.width)} 0 0 ${numberForPdf(photo.height)} ${numberForPdf(photo.x)} ${numberForPdf(photo.y)} cm /${photo.name} Do\nQ`
        : `q ${numberForPdf(photo.width)} 0 0 ${numberForPdf(photo.height)} ${numberForPdf(photo.x)} ${numberForPdf(photo.y)} cm /${photo.name} Do Q`);
    };
    const mappedImageCommand = (name, bottomLeft, bottomRight, topLeft) => {
      const a = bottomRight[0] - bottomLeft[0];
      const b = bottomRight[1] - bottomLeft[1];
      const c = topLeft[0] - bottomLeft[0];
      const d = topLeft[1] - bottomLeft[1];
      return `q ${numberForPdf(a)} ${numberForPdf(b)} ${numberForPdf(c)} ${numberForPdf(d)} ${numberForPdf(bottomLeft[0])} ${numberForPdf(bottomLeft[1])} cm /${name} Do Q`;
    };
    const paddedMappedImageCommand = (name, bottomLeft, bottomRight, topLeft, padding) => {
      const scale = 1 / (1 - (2 * padding));
      const vx = [bottomRight[0] - bottomLeft[0], bottomRight[1] - bottomLeft[1]];
      const vy = [topLeft[0] - bottomLeft[0], topLeft[1] - bottomLeft[1]];
      const origin = [
        bottomLeft[0] - (padding * scale * (vx[0] + vy[0])),
        bottomLeft[1] - (padding * scale * (vx[1] + vy[1])),
      ];
      return mappedImageCommand(name, [origin[0], origin[1]], [origin[0] + scale * vx[0], origin[1] + scale * vx[1]], [origin[0] + scale * vy[0], origin[1] + scale * vy[1]]);
    };
    if (useDirectFrameLayers) {
      const outerFramePoints = buildZarifYatayOuterFramePoints(sourceWidth, sourceHeight);
      photoRasterResources.forEach((photo, index) => {
        const framePath = framePathGroups[index];
        const outerPoints = outerFramePoints[index];
        if (outerPoints && cardShadowObject) {
          // Outer points: top-left, top-right, bottom-right, bottom-left.
          contentLines.push(paddedMappedImageCommand('CardShadow', outerPoints[3], outerPoints[2], outerPoints[0], cardShadowPadding));
        }
        pushPhoto(photo);
        if (framePath) contentLines.push(`q\n1 1 1 rg\n${framePath}\nQ`);
      });
    } else {
      photoRasterResources.forEach(pushPhoto);
      if (upperFramePathCommands) contentLines.push(`q\n1 1 1 rg\n${upperFramePathCommands}\nQ`);
    }
    const textObjectGroups = new Map();
    items.forEach((item, index) => {
      const key = item.textObjectId ?? `single-${index}`;
      if (!textObjectGroups.has(key)) textObjectGroups.set(key, []);
      textObjectGroups.get(key).push(item);
    });
    textObjectGroups.forEach((groupItems) => {
      if (groupItems.length > 1 && groupItems.every((item) => item.role === 'netflix-description')) {
        const fontEntry = fontEntries.get(groupItems[0].fontKey || 'base-helvetica');
        const command = fontEntry ? buildMultilineTextCommand({ items: groupItems, fontEntry }) : '';
        if (command) contentLines.push(command);
        return;
      }
      const commands = groupItems.map((item) => {
        const fontEntry = fontEntries.get(item.fontKey || 'base-helvetica');
        return fontEntry ? buildTextCommand({ item, fontEntry }) : '';
      }).filter(Boolean);
      if (commands.length) contentLines.push(mergeTextObjectCommands(commands));
    });
    outlineItems.forEach((outline) => {
      const [r, g, b] = outline.color || [0, 0, 0];
      contentLines.push([
        'q',
        `${numberForPdf(r)} ${numberForPdf(g)} ${numberForPdf(b)} rg`,
        `${numberForPdf(outline.scaleX)} 0 0 ${numberForPdf(outline.scaleY)} ${numberForPdf(outline.x)} ${numberForPdf(outline.y)} cm`,
        outline.commands,
        'f',
        'Q',
      ].join('\n'));
    });
    if (vectorOverlay?.heart) {
      contentLines.push(`q\n0 0 0 rg\n${buildVectorHeartPath(vectorOverlay.heart)}\nQ`);
    }
    if (vectorOverlay?.anneZarifHeart) {
      const heart = vectorOverlay.anneZarifHeart;
      contentLines.push(`q\n0 0 0 RG\n1 J\n1 j\n${numberForPdf(heart.strokeWidth)} w\n${buildAnneZarifHeartPath(heart)}\nS\nQ`);
    }
    if (hasOverlayContent) contentLines.push('Q');

    const contentStream = `${contentLines.join('\n')}\n`;
    const contentObject = objects.length + 1;
    objects.push(`<< /Length ${textBytes(contentStream).length} >>\nstream\n${contentStream}endstream\n`);

    const pageObject = objects.length + 1;
    const pagesObject = objects.length + 2;
    const catalogObject = objects.length + 3;
    const photoXObjects = photoRasterResources.map((photo) => `/${photo.name} ${photo.objectRef} 0 R`).join(' ');
    const shadowXObjects = [
      cardShadowObject ? `/CardShadow ${cardShadowObject} 0 R` : '',
    ].filter(Boolean).join(' ');
    objects.push(`<< /Type /Page /Parent ${pagesObject} 0 R /MediaBox [0 0 ${numberForPdf(pageWidth)} ${numberForPdf(pageHeight)}] /Resources << /XObject << /Im0 ${imageObject} 0 R${photoXObjects ? ` ${photoXObjects}` : ''}${shadowXObjects ? ` ${shadowXObjects}` : ''} >>${fontResources.length ? ` /Font << ${fontResources.join(' ')} >>` : ''} >> /Contents ${contentObject} 0 R >>\n`);
    objects.push(`<< /Type /Pages /Kids [${pageObject} 0 R] /Count 1 >>\n`);
    objects.push(`<< /Type /Catalog /Pages ${pagesObject} 0 R >>\n`);

    return createPdfObjects(catalogObject, objects);
  };

  const buildPdfFromJpeg = async ({ jpegBlob, width, height }) => {
    const jpegBytes = await blobToBytes(jpegBlob);
    const pageWidth = width * 72 / EXPORT_DPI;
    const pageHeight = height * 72 / EXPORT_DPI;
    const contentStream = `q ${numberForPdf(pageWidth)} 0 0 ${numberForPdf(pageHeight)} 0 0 cm /Im0 Do Q\n`;
    const objects = [
      '<< /Type /Catalog /Pages 2 0 R >>\n',
      '<< /Type /Pages /Kids [3 0 R] /Count 1 >>\n',
      `<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${numberForPdf(pageWidth)} ${numberForPdf(pageHeight)}] /Resources << /XObject << /Im0 4 0 R >> >> /Contents 5 0 R >>\n`,
      concatBytes([
        textBytes(`<< /Type /XObject /Subtype /Image /Width ${width} /Height ${height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${jpegBytes.length} >>\nstream\n`),
        jpegBytes,
        textBytes('\nendstream\n'),
      ]),
      `<< /Length ${textBytes(contentStream).length} >>\nstream\n${contentStream}endstream\n`,
    ];
    const parts = [textBytes('%PDF-1.4\n%\xFF\xFF\xFF\xFF\n')];
    const offsets = [0];
    let offset = parts[0].length;

    objects.forEach((object, index) => {
      offsets.push(offset);
      const header = textBytes(`${index + 1} 0 obj\n`);
      const body = typeof object === 'string' ? textBytes(object) : object;
      const footer = textBytes('endobj\n');
      parts.push(header, body, footer);
      offset += header.length + body.length + footer.length;
    });

    const xrefOffset = offset;
    const xrefRows = offsets.map((itemOffset, index) => (
      index === 0 ? '0000000000 65535 f \n' : `${String(itemOffset).padStart(10, '0')} 00000 n \n`
    )).join('');
    parts.push(textBytes(`xref\n0 ${objects.length + 1}\n${xrefRows}trailer\n<< /Size ${objects.length + 1} /Root 1 0 R >>\nstartxref\n${xrefOffset}\n%%EOF`));

    return new Blob([concatBytes(parts)], { type: 'application/pdf' });
  };

  const renderDesignPdfs = async (root, target) => {
    const debugTiming = window.location.search.includes('renao_local_test=1') ? { started: performance.now() } : null;
    const html2canvas = await loadHtml2Canvas();
    const activeElement = document.activeElement;
    if (activeElement && typeof activeElement.blur === 'function') activeElement.blur();
    const capture = await getProofTarget(root) || (target ? await createCaptureElement(root, target) : null);
    if (debugTiming) debugTiming.capture = performance.now() - debugTiming.started;
    if (!capture) throw new Error('Baskı tasarımı bulunamadı.');
    const { clone, shell } = capture;
    const isNameplate = clone.classList.contains('renao-nameplate');
    const nameplateWidthAtPrintDpi = NAMEPLATE_PRINT_SIZE_CM.width / 2.54 * NAMEPLATE_EXPORT_DPI;
    const productHandle = String(['zarif-arkadas3', 'zarif-ark3', 'zarif-ark2', 'zarif-suc', 'zarif-bizim-olayimiz', 'zarif-yan-yana-magazin'].includes(root?.dataset?.renaoSourceProductHandle) ? root.dataset.renaoSourceProductHandle : (root?.dataset?.renaoProductHandle || '')).trim().toLowerCase();
    const isIyiki = productHandle === 'iyiki' || clone.classList.contains('renao-iyiki-poster');
    const isCollage = clone.classList.contains('renao-collage-plaque');
    const isExactProofCollage = isCollage && productHandle === 'en-guzel-uc-animiz-zarif-model';
    if (isCollage) await prepareStackedLandscapeFramesForCapture(clone);
    const isNetflix = clone.matches('[data-renao-netflix-poster]');
    let collagePageSize = productHandle.startsWith('birlikte-biriktirdiklerimiz-6-li-kolaj')
      ? COLLAGE_PRINT_SIZES_CM['birlikte-biriktirdiklerimiz-6-li-kolaj']
      : COLLAGE_PRINT_SIZES_CM[productHandle] || null;
    if (isCollage && !collagePageSize) throw new Error(`Kolaj baskı ölçüsü tanımlı değil: ${productHandle}`);
    collagePageSize ||= COLLAGE_PRINT_SIZES_CM['zarif-dikey-6'];
    // This layout is intentionally flattened for Illustrator compatibility.
    // Render it at 1200 DPI so its rotated photo/frame edges remain production
    // sharp even though they are no longer separate vector objects.
    const collageExportDpi = productHandle === 'zarif-dikey-3' ? 1200 : COLLAGE_EXPORT_DPI;
    const collageWidthAtPrintDpi = collagePageSize.width / 2.54 * collageExportDpi;
    const exportScale = clone.classList.contains('renao-map-poster')
      ? Math.max(2, Number(window.RenaoDesignFileMapExportScale) || MAP_EXPORT_SCALE)
      : isNameplate
        ? Math.max(EXPORT_SCALE, nameplateWidthAtPrintDpi / Math.max(1, clone.getBoundingClientRect().width))
        : isCollage
          ? Math.max(EXPORT_SCALE, collageWidthAtPrintDpi / Math.max(1, clone.getBoundingClientRect().width))
        : EXPORT_SCALE;
    const mapPageSize = clone.classList.contains('renao-map-poster') ? MAP_PRINT_SIZES_CM[productHandle] || null : null;
    const printPageSize = isNameplate ? NAMEPLATE_PRINT_SIZE_CM : mapPageSize;
    const isMaptablo = productHandle === 'maptablo' && clone.classList.contains('renao-map-poster');
    const hasCustomerPhoto = Boolean(clone.querySelector([
      '[data-renao-collage-preview-image]',
      '[data-renao-netflix-image-slot]',
      '[data-renao-music-photo-preview]',
      '[data-renao-iyiki-photo-preview]',
      '[data-renao-qr-photo-preview]',
      '[data-renao-heart-photo-preview]',
    ].join(',')));
    // Illustrator can reinterpret clipped full-board photos as broken masks.
    // Route this layout through the safe base plus source-photo/vector-frame
    // export, whose photo objects never use PDF clipping operators.
    const requiresIllustratorSafeRaster = isCollage && productHandle === 'zarif-dikey-3';
    const useCanonicalRaster = !isExactProofCollage
      && (window.RenaoDesignFileCanonicalRaster === true || ['bizim-olayimiz', 'yan-yana-magazin', 'zarif-bizim-olayimiz', 'zarif-yan-yana-magazin'].includes(productHandle) || requiresIllustratorSafeRaster)
      && (isIyiki || isCollage || isNetflix || hasCustomerPhoto);

    try {
      if (isCollage && productHandle === 'arkadas') {
        // Capture photos separately so the center is a true unprinted opening.
        // html2canvas does not implement CSS polygon clipping consistently.
        shell.classList.add('renao-capture-shell--design');
        forceTransparentCollageDesignBackground(clone);
        const center = clone.querySelector('.renao-arkadas-center');
        if (!center) throw new Error('Arkadas center missing');
        const boardRect = clone.getBoundingClientRect();
        const centerRect = center.getBoundingClientRect();
        const scale = Math.max(exportScale, 13 / 2.54 * 600 / boardRect.width);
        center.style.setProperty('visibility','hidden','important');
        await waitForPaint(2);
        const canvas = await html2canvas(clone, {backgroundColor:null,scale,useCORS:true,allowTaint:false,imageTimeout:15000,logging:false,removeContainer:false});
        center.style.setProperty('visibility','visible','important');
        const sx=canvas.width/boardRect.width, sy=canvas.height/boardRect.height;
        const x=(centerRect.left-boardRect.left)*sx,y=(centerRect.top-boardRect.top)*sy;
        const ctx=canvas.getContext('2d');
        ctx.setTransform(1,0,0,1,0,0);
        ctx.clearRect(Math.floor(x),Math.floor(y),Math.ceil(centerRect.width*sx)+1,Math.ceil(centerRect.height*sy)+1);
        // Read the live DOM line breaks and glyph positions; canvas text remains
        // at the same 600-DPI scale as the photos, with no white backing layer.
        ctx.save();ctx.scale(sx,sy);ctx.fillStyle='#141414';ctx.textBaseline='alphabetic';
        for(const element of center.querySelectorAll('[data-arkadas-title],[data-arkadas-artist],[data-arkadas-lyrics-preview]')){
          const style=getComputedStyle(element), size=parseFloat(style.fontSize);
          ctx.font=`${style.fontWeight} ${size}px ${style.fontFamily}`;
          const textNode=element.firstChild;if(!textNode || textNode.nodeType!==3)continue;
          for(let i=0;i<textNode.length;i++){
            const char=textNode.textContent[i];if(/\s/.test(char))continue;
            const range=document.createRange();range.setStart(textNode,i);range.setEnd(textNode,i+1);
            const r=range.getBoundingClientRect();
            ctx.fillText(char,r.left-boardRect.left,r.top-boardRect.top+(r.height-size)/2+size*.82);
          }
        }
        ctx.restore();
        for(const element of center.querySelectorAll('img')){
          if(element.hidden || !element.src)continue;
          const response=await fetch(element.src,{credentials:'omit'});
          if(!response.ok)throw new Error('Arkadas album/code image unavailable');
          const image=await loadImage(await readBlobAsDataUrl(await response.blob()));
          const r=element.getBoundingClientRect();
          const layer=document.createElement('canvas');layer.width=Math.max(1,Math.round(r.width*sx));layer.height=Math.max(1,Math.round(r.height*sy));
          const lc=layer.getContext('2d');
          const fit=Math.min(layer.width/image.naturalWidth,layer.height/image.naturalHeight);
          const iw=image.naturalWidth*fit,ih=image.naturalHeight*fit;
          if(element.matches('[data-arkadas-art]')){
            lc.beginPath();lc.roundRect(0,0,layer.width,layer.height,layer.width*.2);lc.clip();
          }
          lc.drawImage(image,0,(layer.height-ih)/2,iw,ih);
          if(element.matches('[data-arkadas-code]')){
            const pixels=lc.getImageData(0,0,layer.width,layer.height);
            for(let i=0;i<pixels.data.length;i+=4){const lum=pixels.data[i]*.2126+pixels.data[i+1]*.7152+pixels.data[i+2]*.0722;pixels.data[i+3]=Math.round(pixels.data[i+3]*(255-lum)/255);pixels.data[i]=pixels.data[i+1]=pixels.data[i+2]=0;}
            lc.putImageData(pixels,0,0);
          }
          ctx.drawImage(layer,(r.left-boardRect.left)*sx,(r.top-boardRect.top)*sy);
          layer.width=1;
        }
        const pdf=await buildPdfFromCanvas(canvas,null,collagePageSize,true);
        canvas.width=1;
        return {previewPdf:pdf,designPdf:pdf};
      }
      if (isCollage && productHandle === 'zarif-yatay-3' && !isBlackAndWhiteCollage(clone)) {
        // Preserve each customer JPEG byte-for-byte. The transparent browser
        // canvas contributes only non-photo artwork; PDF clipping paths place
        // the original JPEG streams inside the three frame windows.
        clone.querySelectorAll('[data-renao-stacked-frame-vector]').forEach((element) => element.remove());
        delete clone.dataset.renaoStackedFramesRasterized;
        clone.classList.add('renao-direct-jpeg-capture');
        shell.classList.add('renao-capture-shell--design');
        forceTransparentCollageDesignBackground(clone);
        markVectorTextForCapture(clone);
        await waitForPaint(2);
        const directCanvas = await html2canvas(clone, {
          backgroundColor: null,
          scale: exportScale,
          useCORS: true,
          allowTaint: false,
          imageTimeout: 8000,
          logging: false,
          removeContainer: false,
        });
        await postProcessCanvasForPrint(directCanvas, clone);
        // Restore measurable frame boxes only after the empty artwork canvas
        // has been captured; the direct JPEG overlay collector needs them.
        clone.classList.remove('renao-direct-jpeg-capture');
        const directOverlay = await collectVectorOverlay(clone, directCanvas);
        directOverlay.photoRasters = await collectZarifYatayDirectJpegOverlays(root, clone, directCanvas);
        directOverlay.zarifYatayDirectShadows = true;
        directCanvas.getContext('2d')?.clearRect(0, 0, directCanvas.width, directCanvas.height);
        const directPdf = await buildPdfFromCanvas(directCanvas, directOverlay, collagePageSize, true);
        directCanvas.width = 1;
        directCanvas.height = 1;
        return { previewPdf: directPdf, designPdf: directPdf };
      }

      if (useCanonicalRaster) {
        // Paid-order production must never reinterpret the approved proof.
        // Customer photos are already frozen to their immutable source-pixel
        // crops before Shopify uploads them. Keep browser-rendered typography,
        // masks and artwork in the same raster layer as those photos so PDF
        // font metrics, fallback fonts and horizontal scaling cannot drift.
        shell.classList.add('renao-capture-shell--design');
        if (isCollage) forceTransparentCollageDesignBackground(clone);
        // The Illustrator-safe hybrid adds the white frame once as ordinary
        // vector strips below. Hide the same SVG from the raster proof first;
        // otherwise Illustrator shows a visible frame-inside-frame duplicate.
        if (requiresIllustratorSafeRaster) clone.classList.add('renao-capture-vector-frame');
        const isMusicCodePlaque = clone.classList.contains('renao-music-poster')
          && Boolean(clone.querySelector('[data-renao-music-code-wrap]'));
        if (isMusicCodePlaque) forceTransparentMusicDesignBackground(clone);
        await waitForPaint(2);
        const canonicalCanvas = await html2canvas(clone, {
          backgroundColor: null,
          scale: exportScale,
          useCORS: true,
          allowTaint: false,
          imageTimeout: 8000,
          logging: false,
          removeContainer: false,
        });
        await postProcessCanvasForPrint(canonicalCanvas, clone);
        if (isMusicCodePlaque) convertMusicPanelToBlackAlpha(canonicalCanvas, clone);
        const canonicalOverlay = requiresIllustratorSafeRaster ? {
          texts: [],
          outlines: [],
          // Photos, their exact crop and the heart stay in one immutable
          // 1200-DPI surface. Only the white frame strips are vector, so there
          // are no photo masks or separately positioned heart for Illustrator
          // to shift while the frame edges remain resolution independent.
          photoRasters: [],
          heart: collectCollageHeartOverlay(clone, canonicalCanvas)?.heart || null,
          frames: await collectCollageFrameVectorOverlay(clone),
        } : null;
        const canonicalPdf = await buildPdfFromCanvas(
          canonicalCanvas,
          canonicalOverlay,
          isCollage ? collagePageSize : null,
          true,
        );
        canonicalCanvas.width = 1;
        canonicalCanvas.height = 1;
        return { previewPdf: canonicalPdf, designPdf: canonicalPdf };
      }

      if (isIyiki) {
        // Keep only the masked photo in the raster layer. Every white area stays
        // transparent, while date/title/names are embedded as three editable PDF
        // text objects (one object per field, never one object per glyph).
        markVectorTextForCapture(clone);
        await waitForPaint(1);
        const exactCanvas = await html2canvas(clone, {
          backgroundColor: null,
          scale: exportScale,
          useCORS: true,
          allowTaint: false,
          imageTimeout: 8000,
          logging: false,
          removeContainer: false,
        });
        await postProcessCanvasForPrint(exactCanvas, clone);
        const exactPdf = await buildPdfFromCanvas(
          exactCanvas,
          await collectVectorOverlay(clone, exactCanvas),
          null,
          true,
        );
        exactCanvas.width = 1;
        exactCanvas.height = 1;
        return { previewPdf: exactPdf, designPdf: exactPdf };
      }

      if (!printPageSize) {
        if (isCollage) {
          if (isExactProofCollage) {
            // Keep the approved white plaque in the customer proof, but remove
            // it from the production artwork. The Polaroid borders, angles,
            // overlap order, artwork and immutable source-pixel crops remain.
            markVectorTextForCapture(clone);
            await waitForPaint(1);
            const previewCanvas = await html2canvas(clone, {
              backgroundColor: null,
              scale: exportScale,
              useCORS: true,
              allowTaint: false,
              imageTimeout: 8000,
              logging: false,
              removeContainer: false,
            });
            await postProcessCanvasForPrint(previewCanvas, clone);
            const previewPdf = await buildPdfFromCanvas(
              previewCanvas,
              await collectVectorOverlay(clone, previewCanvas),
              collagePageSize,
              true,
            );
            previewCanvas.width = 1;
            previewCanvas.height = 1;

            shell.classList.add('renao-capture-shell--design');
            forceTransparentCollageDesignBackground(clone);
            await waitForPaint(1);
            const designCanvas = await html2canvas(clone, {
              backgroundColor: null,
              scale: exportScale,
              useCORS: true,
              allowTaint: false,
              imageTimeout: 8000,
              logging: false,
              removeContainer: false,
            });
            await postProcessCanvasForPrint(designCanvas, clone);
            const designPdf = await buildPdfFromCanvas(
              designCanvas,
              await collectVectorOverlay(clone, designCanvas),
              collagePageSize,
              true,
            );
            designCanvas.width = 1;
            designCanvas.height = 1;
            return { previewPdf, designPdf };
          }

          // Use the same embedded vector text/heart layer in both PDFs. This keeps
          // the customer proof typography pixel-for-pixel aligned with the
          // production design file instead of relying on browser SVG font rasterization.
          shell.classList.add('renao-capture-shell--design');
          forceTransparentCollageDesignBackground(clone);
          markVectorTextForCapture(clone);
          await waitForPaint(1);
          const previewCanvas = await html2canvas(clone, {
            backgroundColor: null,
            scale: exportScale,
            useCORS: true,
            allowTaint: false,
            imageTimeout: 8000,
            logging: false,
            removeContainer: false,
          });
          await postProcessCanvasForPrint(previewCanvas, clone);
          const previewPdf = await buildPdfFromCanvas(
            previewCanvas,
            await collectVectorOverlay(clone, previewCanvas),
            collagePageSize,
            true,
          );
          previewCanvas.width = 1;
          previewCanvas.height = 1;

          shell.classList.add('renao-capture-shell--design');
          forceTransparentCollageDesignBackground(clone);
          await waitForPaint(2);
          const designCanvas = await html2canvas(clone, {
            backgroundColor: null,
            scale: exportScale,
            useCORS: true,
            allowTaint: false,
            imageTimeout: 8000,
            logging: false,
            removeContainer: false,
          });
          await postProcessCanvasForPrint(designCanvas, clone);
          const designPdf = await buildPdfFromCanvas(
            designCanvas,
            await collectVectorOverlay(clone, designCanvas),
            collagePageSize,
            true,
          );
          designCanvas.width = 1;
          designCanvas.height = 1;
          return { previewPdf, designPdf };
        }

        const isMusicCodePlaque = clone.classList.contains('renao-music-poster')
          && Boolean(clone.querySelector('[data-renao-music-code-wrap]'));
        if (isMusicCodePlaque) {
          // The customer proof needs a white acrylic preview, while the production
          // artwork must contain only the masked photo and printed black elements.
          markVectorTextForCapture(clone);
          await waitForPaint(1);
          const previewCanvas = await html2canvas(clone, {
            backgroundColor: '#ffffff',
            scale: exportScale,
            useCORS: true,
            allowTaint: false,
            imageTimeout: 8000,
            logging: false,
            removeContainer: false,
          });
          await postProcessCanvasForPrint(previewCanvas, clone);
          const previewPdf = await buildPdfFromCanvas(
            previewCanvas,
            await collectVectorOverlay(clone, previewCanvas),
            null,
            false,
          );
          previewCanvas.width = 1;
          previewCanvas.height = 1;

          shell.classList.add('renao-capture-shell--design');
          forceTransparentMusicDesignBackground(clone);
          await waitForPaint(2);
          const designCanvas = await html2canvas(clone, {
            backgroundColor: null,
            scale: exportScale,
            useCORS: true,
            allowTaint: false,
            imageTimeout: 8000,
            logging: false,
            removeContainer: false,
          });
          await postProcessCanvasForPrint(designCanvas, clone);
          convertMusicPanelToBlackAlpha(designCanvas, clone);
          const designPdf = await buildPdfFromCanvas(
            designCanvas,
            await collectVectorOverlay(clone, designCanvas),
            null,
            true,
          );
          designCanvas.width = 1;
          designCanvas.height = 1;
          return { previewPdf, designPdf };
        }

        shell.classList.add('renao-capture-shell--design');
        forceTransparentCollageDesignBackground(clone);
        await waitForPaint(2);
        markVectorTextForCapture(clone);
        // Netflix posters use a centered, aspect-ratio constrained inner artboard.
        // Rebuilding that layout inside the isolated iframe shifts the artboard by
        // half a page in Chromium, even though the live proof is correct. Capture
        // Netflix directly from the already measured clone instead.
        const hasGenericCustomerPhoto = Boolean(clone.querySelector([
          '[data-renao-music-photo-preview]',
          '[data-renao-qr-photo-preview]',
          '[data-renao-heart-photo-preview]',
        ].join(',')));
        if (!isNetflix && !hasGenericCustomerPhoto && !isBlackAndWhiteCollage(clone)) {
          try {
            const renderPayload = await buildBrowserRenderHtml(capture);
            const isolated = await renderJpegInClientFrame(renderPayload);
            const encodedCanvas = {
              width: isolated.width,
              height: isolated.height,
              __renaoJpegBytes: new Uint8Array(isolated.jpeg),
            };
            const designPdf = await buildPdfFromCanvas(encodedCanvas, await collectVectorOverlay(clone, encodedCanvas), null);
            if (debugTiming) {
              debugTiming.canvas = performance.now() - debugTiming.started;
              debugTiming.pdf = debugTiming.canvas;
              (window.__renaoPdfTimings ||= []).push(debugTiming);
            }
            return { previewPdf: designPdf, designPdf };
          } catch (error) {
            console.warn('Renao isolated client renderer failed; using the local canvas fallback.', error);
          }
        }
        const designCanvas = await html2canvas(clone, {
          backgroundColor: '#ffffff',
          scale: exportScale,
          useCORS: true,
          allowTaint: false,
          imageTimeout: 8000,
          logging: false,
          removeContainer: false,
        });
        if (debugTiming) debugTiming.canvas = performance.now() - debugTiming.started;
        await postProcessCanvasForPrint(designCanvas, clone);
        const designPdf = await buildPdfFromCanvas(
          designCanvas,
          await collectVectorOverlay(clone, designCanvas),
          null,
          false,
        );
        if (debugTiming) {
          debugTiming.pdf = performance.now() - debugTiming.started;
          (window.__renaoPdfTimings ||= []).push(debugTiming);
        }
        designCanvas.width = 1;
        designCanvas.height = 1;
        return { previewPdf: designPdf, designPdf };
      }

      // Both PDFs are built from the same hidden-text canvas and the same editable
      // vector overlay. This is the single source of truth for every map product:
      // proof, final preview and production artwork cannot drift typographically.
      markVectorTextForCapture(clone);
      await waitForPaint(1);
      const previewCanvas = await html2canvas(clone, {
        backgroundColor: isMaptablo ? '#ffffff' : null,
        scale: exportScale,
        useCORS: true,
        allowTaint: false,
        imageTimeout: 8000,
        logging: false,
        removeContainer: false,
      });
      await postProcessCanvasForPrint(previewCanvas, clone);
      const previewPdf = await buildPdfFromCanvas(
        previewCanvas,
        await collectVectorOverlay(clone, previewCanvas),
        printPageSize,
      );
      previewCanvas.width = 1;
      previewCanvas.height = 1;

      shell.classList.add('renao-capture-shell--design');
      forceTransparentCollageDesignBackground(clone);
      await waitForPaint(2);
      markVectorTextForCapture(clone);
      const designCanvas = await html2canvas(clone, {
        backgroundColor: isMaptablo ? '#ffffff' : null,
        scale: exportScale,
        useCORS: true,
        allowTaint: false,
        imageTimeout: 8000,
        logging: false,
        removeContainer: false,
      });
      await postProcessCanvasForPrint(designCanvas, clone);
      const designPdf = await buildPdfFromCanvas(designCanvas, await collectVectorOverlay(clone, designCanvas), printPageSize);

      return { previewPdf, designPdf };
    } finally {
      shell.remove();
    }
  };

  const renderDesignPdfInBrowser = async (root, target, fileName) => {
    const isMapDesign = root?.matches?.('[data-renao-personalizer]')
      || target?.matches?.('.renao-map-poster')
      || Boolean(target?.closest?.('.renao-map-poster'));
    if (!target || isMapDesign) return null;

    const activeElement = document.activeElement;
    if (activeElement && typeof activeElement.blur === 'function') activeElement.blur();
    const capture = await getProofTarget(root) || await createCaptureElement(root, target);
    if (!capture) throw new Error('Baskı tasarımı bulunamadı.');

    try {
      const renderPayload = await buildBrowserRenderHtml(capture);
      return await requestBrowserRenderedPdf({ ...renderPayload, fileName });
    } finally {
      capture.shell.remove();
    }
  };

  const isMapDesignRoot = (root, target = null) => (
    root?.matches?.('[data-renao-personalizer]')
    || target?.matches?.('.renao-map-poster')
    || Boolean(target?.closest?.('.renao-map-poster'))
  );

  const getPreparationState = (form) => {
    let state = preparationStates.get(form);
    if (!state) {
      state = { revision: 0, generatedRevision: -1, timer: null, idleHandle: null, promise: null, result: null };
      preparationStates.set(form, state);
    }
    return state;
  };

  const generatePreparedPdfs = (form, revision = getPreparationState(form).revision) => {
    const state = getPreparationState(form);
    if (state.promise && state.promise.revision === revision) return state.promise.value;

    const root = form.querySelector(PERSONALIZER_SELECTOR);
    const target = root ? findPrintTarget(root) : null;
    const value = renderDesignPdfs(root, target).then((result) => {
      if (state.revision === revision) {
        state.result = result;
        state.generatedRevision = revision;
      }
      return result;
    }).finally(() => {
      if (state.promise?.revision === revision) state.promise = null;
    });
    state.promise = { revision, value };
    return value;
  };

  const schedulePreparedPdfs = (form, delay = 6000) => {
    if (form?.querySelector?.('[name="properties[_Renao Üretim]"][value="mac-pdf-v1"]')) return;
    const root = form?.querySelector?.(PERSONALIZER_SELECTOR);
    if (!root || isMapDesignRoot(root)) return;
    const state = getPreparationState(form);
    window.clearTimeout(state.timer);
    if (state.idleHandle && 'cancelIdleCallback' in window) window.cancelIdleCallback(state.idleHandle);
    state.timer = window.setTimeout(() => {
      const revision = state.revision;
      const start = () => {
        state.idleHandle = null;
        if (state.revision !== revision || state.generatedRevision === revision) return;
        generatePreparedPdfs(form, revision).catch((error) => {
          console.warn('Renao background PDF preparation failed; it will be retried at add to cart.', error);
        });
      };
      if ('requestIdleCallback' in window) state.idleHandle = window.requestIdleCallback(start, { timeout: 2200 });
      else state.idleHandle = window.setTimeout(start, 250);
    }, delay);
  };

  const initBackgroundPreparation = () => {
    document.addEventListener('input', (event) => {
      const input = event.target;
      if (!(input instanceof Element) || input.matches('[data-renao-design-preview-input], [data-renao-design-file-input], [data-renao-design-preview-link-input], [data-renao-design-file-link-input]')) return;
      const root = input.closest(PERSONALIZER_SELECTOR);
      const form = root?.closest('form');
      if (!form) return;
      if (form.querySelector('[name="properties[_Renao Üretim]"][value="mac-pdf-v1"]')) return;
      const state = getPreparationState(form);
      state.revision += 1;
      state.result = null;
      state.generatedRevision = -1;
      schedulePreparedPdfs(form);
    }, true);
    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof Element) || input.matches('[data-renao-design-preview-input], [data-renao-design-file-input], [data-renao-design-preview-link-input], [data-renao-design-file-link-input]')) return;
      const root = input.closest(PERSONALIZER_SELECTOR);
      const form = root?.closest('form');
      if (!form) return;
      if (form.querySelector('[name="properties[_Renao Üretim]"][value="mac-pdf-v1"]')) return;
      const state = getPreparationState(form);
      state.revision += 1;
      state.result = null;
      state.generatedRevision = -1;
      schedulePreparedPdfs(form);
    }, true);
    document.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest(PROOF_OPEN_SELECTOR) : null;
      const root = button?.closest(PERSONALIZER_SELECTOR);
      const form = root?.closest('form');
      if (form) schedulePreparedPdfs(form, 650);
    }, true);
  };

  const prepareForm = async (form) => {
    if (!form) return false;
    const root = form.querySelector(PERSONALIZER_SELECTOR);
    if (!root) return false;

    const target = findPrintTarget(root);
    const { previewInput, downloadInput } = ensureDesignFileInputs(form);
    const productTitle = document.querySelector('.product__title, h1')?.textContent || document.title || 'tasarim';
    const fileName = `renao-${slugify(productTitle)}-${Date.now()}-son-hali.pdf`;
    const productHandle = String(['zarif-arkadas3', 'zarif-ark3', 'zarif-ark2', 'zarif-suc', 'zarif-bizim-olayimiz', 'zarif-yan-yana-magazin'].includes(root?.dataset?.renaoSourceProductHandle) ? root.dataset.renaoSourceProductHandle : (root?.dataset?.renaoProductHandle || '')).trim().toLowerCase();
    const isIyiki = productHandle === 'iyiki' || target?.classList?.contains('renao-iyiki-poster');
    const localOnly = window.RenaoDesignFileLocalOnly === true;

    if (!isMapDesignRoot(root, target)) {
      try {
        const state = getPreparationState(form);
        const prepared = state.result && state.generatedRevision === state.revision
          ? state.result
          : state.promise?.revision === state.revision
            ? await state.promise.value
            : await generatePreparedPdfs(form, state.revision);
        if (isIyiki && !localOnly) {
          // Store one canonical proof and expose it through two dispositions:
          // preview opens inline in a new tab, design file downloads on demand.
          try {
            const links = await uploadDesignPdf({
              form,
              pdf: prepared.previewPdf,
              fileName: fileName.replace(/\.pdf$/i, '-tasarim.pdf'),
              productTitle,
            });
            if (links && applyDesignLinkProperties(form, links)) return true;
          } catch (error) {
            console.warn('Renao Iyiki exact proof upload failed; using Shopify file properties.', error);
          }
        }

        const previewFile = new File([prepared.previewPdf], fileName.replace(/\.pdf$/i, '-onizleme.pdf'), { type: 'application/pdf' });
        const editableFile = new File([prepared.designPdf], fileName.replace(/\.pdf$/i, '-tasarim-dosyasi.pdf'), { type: 'application/pdf' });
        assignFileToInput(previewInput, previewFile);
        assignFileToInput(downloadInput, editableFile);
        return true;
      } catch (error) {
        if (localOnly) throw error;
        console.warn('Renao local editable PDF writer failed; using the browser render fallback.', error);
        const browserLinks = await renderDesignPdfInBrowser(root, target, fileName.replace(/\.pdf$/i, '-tasarim-dosyasi.pdf'));
        if (browserLinks && applyDesignLinkProperties(form, browserLinks)) return true;
        throw error;
      }
    }

    if (!localOnly) {
      try {
        const browserLinks = await renderDesignPdfInBrowser(root, target, fileName.replace(/\.pdf$/i, '-tasarim-dosyasi.pdf'));
        if (browserLinks && applyDesignLinkProperties(form, browserLinks)) return true;
      } catch (error) {
        console.warn('Renao browser PDF endpoint failed; falling back to the editable local PDF writer.', error);
      }
    }

    const { previewPdf, designPdf } = await renderDesignPdfs(root, target);

    if (!localOnly) {
      try {
        const [previewLinks, designLinks] = await Promise.all([
          uploadDesignPdf({ form, pdf: previewPdf, fileName: fileName.replace(/\.pdf$/i, '-onizleme.pdf'), productTitle }),
          uploadDesignPdf({ form, pdf: designPdf, fileName: fileName.replace(/\.pdf$/i, '-tasarim-dosyasi.pdf'), productTitle }),
        ]);
        if (applySeparateDesignLinkProperties(form, previewLinks, designLinks)) return true;
      } catch (error) {
        console.warn('Renao design file upload endpoint failed; falling back to Shopify file properties.', error);
      }
    }

    const previewFile = new File([previewPdf], fileName.replace(/\.pdf$/i, '-onizleme.pdf'), { type: 'application/pdf' });
    const downloadFile = new File([designPdf], fileName.replace(/\.pdf$/i, '-tasarim-dosyasi.pdf'), { type: 'application/pdf' });
    assignFileToInput(previewInput, previewFile);
    assignFileToInput(downloadInput, downloadFile);
    return true;
  };

  // Capture the actual customer layout once; downstream consumers must not reflow it.
  // Text is stored separately from the immutable map/heart pixels. Both the
  // browser SVG and PDF use these physical point coordinates and font files.
  const mapPrintFontPromises = new Map();
  const loadMapPrintFont = (key) => {
    if (!mapPrintFontPromises.has(key)) mapPrintFontPromises.set(key, (async () => {
      const spec = resolveVectorFontSpecByKey(key);
      if (!spec?.file) throw new Error('Harita baskı yazı tipi bulunamadı: ' + key);
      const response = await fetch(getAssetUrl(spec.file));
      if (!response.ok) throw new Error('Harita baskı yazı tipi yüklenemedi.');
      const bytes = await response.arrayBuffer();
      const hash = Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256', bytes)), b => b.toString(16).padStart(2,'0')).join('');
      const family = 'RenaoMapPrint-' + key;
      const font = await new FontFace(family, bytes).load();
      document.fonts.add(font);
      const dataUrl = await new Promise(resolve => { const r = new FileReader(); r.onload=()=>resolve(r.result); r.readAsDataURL(new Blob([bytes],{type:'font/ttf'})); });
      return {key, file:spec.file, url:getAssetUrl(spec.file), sha256:hash, family, dataUrl};
    })());
    return mapPrintFontPromises.get(key);
  };
  const layoutMapPrintText = async (root, poster) => {
    if (!poster) return [];
    const revision = (poster.__mapTextRevision || 0) + 1;
    poster.__mapTextRevision = revision;
    const size = MAP_PRINT_SIZES_CM[root.dataset.renaoProductHandle];
    if (!size) throw new Error('Harita baskı ölçüsü bulunamadı.');
    const width = size.width * 72 / 2.54, height = size.height * 72 / 2.54;
    const landscape = root.dataset.renaoProductHandle === 'mapplaket';
    const nameKey = ({signature:'acardia',soft:'00619',bold:'montserrat-bold'})[root.dataset.renaoFont] || 'acardia';
    const titleKey = root.dataset.renaoTitleFont === 'decorative' ? 'cinzel-decorative' : 'exotc';
    const selectors = ['date','title','names','city','coords'];
    const keys = ['exotc',titleKey,nameKey,'renao-roboto','exotc'];
    const elements = selectors.map(key => poster.querySelector('.renao-map-poster__'+key));
    const fonts = await Promise.all(keys.map(loadMapPrintFont));
    if (poster.__mapTextRevision !== revision) return null;
    // Approved 182 x 62 mm print layout: same baseline positions and sizes as
    // the original production PDF. Other sizes retain their portrait copy area.
    const center = landscape ? width * 0.7478 : width * .5;
    const maxWidth = width * (landscape ? .434 : .84);
    const isTablo = root.dataset.renaoProductHandle === 'maptablo';
    const tabloShift = isTablo && root.dataset.renaoShape === 'heart' ? -.035 : 0;
    const baselines = landscape ? [.24838,.36664,.55026,.68732,.78477] : isTablo ? [.764,.814,.872,.916,.953].map(n=>n+tabloShift) : [.706,.757,.829,.890,.934];
    const boundaries = landscape ? [[.14,.285],[.29,.40],[.405,.615],[.617,.732],[.735,.825]]
      : isTablo ? [[.737,.774],[.779,.825],[.830,.894],[.899,.925],[.930,.972]].map(pair=>pair.map(n=>n+tabloShift)) : [[.672,.718],[.723,.779],[.784,.858],[.863,.910],[.914,.962]];
    const nominal = landscape
      ? [13.7823, titleKey === 'exotc' ? 15.2783 : 13.03, ({acardia:15.85,'00619':33.0446,'montserrat-bold':19.07})[nameKey],14.2948,11.5208]
      : [19.5, titleKey === 'exotc' ? 27.8 : 22.6, ({acardia:22.8,'00619':47,'montserrat-bold':32.5})[nameKey],21.6,16.8].map(n=>n*width/460);
    const measure = document.createElement('canvas').getContext('2d');
    const texts = [];
    elements.forEach((el,index) => {
      if (!el || el.classList.contains('is-preview-hidden') || el.hidden || !el.textContent.trim()) return;
      const text = el.textContent.trim();
      const font = fonts[index];
      let fontSize = nominal[index];
      measure.font = `${fontSize}px "${font.family}"`;
      let metrics = measure.measureText(text);
      const inkHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
      const availableHeight = height * (boundaries[index][1]-boundaries[index][0]);
      fontSize *= Math.min(1, maxWidth / Math.max(1,metrics.width), availableHeight / Math.max(1,inkHeight));
      measure.font = `${fontSize}px "${font.family}"`;
      metrics = measure.measureText(text);
      let baseline = height * baselines[index];
      baseline = Math.max(height*boundaries[index][0] + metrics.actualBoundingBoxAscent,
        Math.min(baseline,height*boundaries[index][1] - metrics.actualBoundingBoxDescent));
      const color = index === 0 ? parseCssColor(getComputedStyle(el).color) : [0.1,0.1,0.1];
      const {dataUrl,...savedFont} = font;
      texts.push({text,role:selectors[index],x:center,y:height-baseline,width:metrics.width,fontSize,font:savedFont,color,align:'center'});
    });
    const ns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(ns,'svg');
    svg.dataset.renaoMapTextLayer = '5';
    svg.setAttribute('viewBox',`0 0 ${width} ${height}`);
    svg.setAttribute('preserveAspectRatio','none');
    svg.style.cssText='position:absolute;inset:0;width:100%;height:100%;overflow:visible;pointer-events:none;z-index:5';
    const style = document.createElementNS(ns,'style');
    style.textContent = [...new Map(fonts.map(font=>[font.key,font])).values()].map(font=>`@font-face{font-family:'${font.family}';src:url('${font.dataUrl}') format('truetype');font-weight:400;font-style:normal}`).join('');
    svg.appendChild(style);
    texts.forEach(item => {
      const text = document.createElementNS(ns,'text');
      text.textContent = item.text;
      text.setAttribute('x',item.x);text.setAttribute('y',height-item.y);
      text.setAttribute('text-anchor','middle');
      text.setAttribute('font-family',item.font.family);
      text.setAttribute('font-size',item.fontSize);
      text.setAttribute('font-weight','400');
      text.setAttribute('textLength',item.width);
      text.setAttribute('lengthAdjust','spacingAndGlyphs');
      text.setAttribute('fill',`rgb(${item.color.map(n=>Math.round(n*255)).join(',')})`);
      svg.appendChild(text);
    });
    poster.querySelector('[data-renao-map-text-layer]')?.remove();
    poster.querySelector('.renao-map-poster__copy').style.setProperty('visibility','hidden','important');
    poster.appendChild(svg);
    poster.__mapPrintTexts = texts;
    return texts;
  };

  const captureMapArtwork = async (root, poster) => {
    const sizes = {mapplaket:[182,62],ymap:[132,182],bmap:[102,152],maptablo:[297,420]};
    const size = sizes[root.dataset.renaoProductHandle];
    if (!size || !poster) throw new Error('Son tasarım boyutu bulunamadı.');
    await document.fonts.ready;
    await Promise.all(Array.from(poster.querySelectorAll('img')).map(image => {
      image.loading = 'eager';
      return Promise.race([image.decode(),new Promise((_,reject) => setTimeout(() => reject(new Error('Tasarım görseli yüklenemedi. Lütfen tekrar deneyin.')),20000))]);
    }));
    const texts = await layoutMapPrintText(root, poster);
    if (!texts) throw new Error('Yazılar değişti. Lütfen tekrar deneyin.');
    const html2canvas = await loadHtml2Canvas();
    const rect = poster.getBoundingClientRect();
    if (!rect.width || !rect.height) throw new Error('Son tasarım görünür değil.');
    const dpi = root.dataset.renaoProductHandle === 'maptablo' ? 300 : 600;
    let captureGeometry;
    const capture = async (hideText) => {
    const canvas = await html2canvas(poster, {
      scale: Math.min(size[0] / 25.4 * dpi / rect.width, Math.sqrt(14000000 / (rect.width * rect.height))),
      backgroundColor: null, useCORS: true, logging: false,
      onclone: (doc, clonedPoster) => {
        if (hideText) clonedPoster.querySelector('[data-renao-map-text-layer]')?.remove();
        doc.querySelectorAll('.renao-map-poster').forEach(el => {
          el.querySelectorAll(':scope > html2canvaspseudoelement').forEach(node => node.remove());
          el.style.setProperty('box-shadow','none','important');
          el.style.setProperty('border-radius','0','important');
          el.style.setProperty('background','transparent','important');
          el.style.setProperty('border-color','transparent','important');
        });
        doc.querySelectorAll('.renao-map-poster__copy').forEach(el => el.style.setProperty('background','transparent','important'));
        const style = doc.createElement('style');
        style.textContent = '.renao-map-poster::before,.renao-map-poster::after{display:none!important}';
        doc.head.appendChild(style);
        captureGeometry = {poster:clonedPoster.getBoundingClientRect(),map:clonedPoster.querySelector('.renao-map-poster__map').getBoundingClientRect(),shape:root.dataset.renaoShape};
      }
    });
    await applyMapMaskToCanvas(canvas, poster, captureGeometry);
    return canvas;
    };
    const canvas = await capture(false);
    const background = await capture(true);
    return {captureVersion:5,image:canvas.toDataURL('image/png'),pixels:[canvas.width,canvas.height],size,texts,background:{image:background.toDataURL('image/png'),pixels:[background.width,background.height]}};
  };

  let frozenMapRendererPromise;
  const loadFrozenMapRenderer = () => {
    if (window.RenaoFrozenMapV2) return Promise.resolve(window.RenaoFrozenMapV2);
    if (!frozenMapRendererPromise) frozenMapRendererPromise = new Promise((resolve,reject)=>{
      const script=document.createElement('script');script.src=getAssetUrl('renao-frozen-map-v2.js');
      script.onload=()=>resolve(window.RenaoFrozenMapV2);
      script.onerror=()=>{frozenMapRendererPromise=null;reject(new Error('Harita önizlemesi yüklenemedi.'));};
      document.head.appendChild(script);
    });
    return frozenMapRendererPromise;
  };
  const mapAssetPromises = new Map();
  const saveMapAsset = file => {
    if (!mapAssetPromises.has(file)) mapAssetPromises.set(file,(async()=>{
      const url=getAssetUrl(file),response=await fetch(url,{signal:AbortSignal.timeout(20000)});
      if(!response.ok)throw new Error('Harita şekli yüklenemedi.');
      const bytes=await response.arrayBuffer();
      const sha256=Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256',bytes)),n=>n.toString(16).padStart(2,'0')).join('');
      return {file,url,sha256};
    })().catch(error=>{mapAssetPromises.delete(file);throw error;}));
    return mapAssetPromises.get(file);
  };
  const captureDeferredMapArtwork = async (root,poster,scene) => {
    const sizes={mapplaket:[182,62],ymap:[132,182],bmap:[102,152],maptablo:[297,420]};
    const handle=root.dataset.renaoProductHandle,size=sizes[handle];
    if(!size||!poster)throw new Error('Tasarım ölçüsü bulunamadı.');
    const map=poster.querySelector('.renao-map-poster__map');
    const heart=map.querySelector('.renao-map-poster__heart');
    await Promise.all(Array.from(map.querySelectorAll('img')).map(img=>img.decode()));
    const maskFile=handle==='mapplaket'?'renao-mapplaket-mask.png':root.dataset.renaoShape==='heart'?'renao-heart-shape-mask.png':'renao-map-mask.png';
    const [texts,mask,heartAsset]=await Promise.all([layoutMapPrintText(root,poster),saveMapAsset(maskFile),saveMapAsset('renao-heart-transparent.png'),loadFrozenMapRenderer()]);
    if(!texts)throw new Error('Yazılar değişti; son tasarım yeniden kaydedilmeli.');
    const artboardStyle=getComputedStyle(poster.querySelector('[data-renao-map-text-layer]'));
    const p={width:Math.round(parseFloat(artboardStyle.width)*64)/64,height:Math.round(parseFloat(artboardStyle.height)*64)/64},m=map.getBoundingClientRect(),h=heart.getBoundingClientRect();
    if(!p.width||!p.height||!m.width||!m.height||!h.width||!h.height)throw new Error('Tasarım yerleşimi okunamadı.');
    const dpi=handle==='maptablo'?300:600;
    const scale=Math.min(size[0]/25.4*dpi/p.width,Math.sqrt(14000000/(p.width*p.height)));
    return {captureVersion:6,renderer:'frozen-map-v2',revision:crypto.randomUUID(),size,
      pixels:[Math.round(p.width*scale),Math.round(p.height*scale)],viewport:[p.width,p.height],texts,
      layout:{map:['left','top','width','height'].map(key=>parseFloat(map.style[key])/100),
        anchor:[scene.heart.x/100,scene.heart.y/100,parseFloat(heart.style.width)/100],
        heart:[(h.left-m.left)/m.width,(h.top-m.top)/m.height,h.width/m.width,h.height/m.height],
        color:getComputedStyle(map.querySelector('.renao-map-surface') || map).backgroundColor,heartFilter:getComputedStyle(heart).filter,
        maskHeight:handle!=='mapplaket'&&root.dataset.renaoShape==='heart'?.94:1},
      assets:{mask,heart:heartAsset}};
  };
  const showDeferredMapArtwork = async (root,poster,scene) => {
    const art=scene.artwork;poster.__renaoPendingFrozenArt=art;
    const renderer=await loadFrozenMapRenderer();
    const fontKeys={'renao-exotc-dmbd.bin':'exotc','renao-acardia-regular.bin':'acardia','renao-00619.bin':'00619','renao-montserrat-bold.bin':'montserrat-bold','renao-roboto-regular.bin':'renao-roboto','renao-cinzel-decorative-bold.bin':'cinzel-decorative'};
    await Promise.all(art.texts.map(t=>loadMapPrintFont(fontKeys[t.font.file])));
    if(poster.__renaoPendingFrozenArt!==art||!poster.isConnected)return;
    if(!document.getElementById('renao-frozen-map-style')){
      const style=document.createElement('style');style.id='renao-frozen-map-style';
      style.textContent='.renao-map-poster[data-renao-frozen-artwork="6"]>.renao-map-poster__map,.renao-map-poster[data-renao-frozen-artwork="6"]>[data-renao-map-text-layer]{visibility:hidden!important}';document.head.appendChild(style);
    }
    poster.querySelector('[data-renao-artwork-image]')?.remove();
    const overlay=document.createElement('div');overlay.dataset.renaoArtworkImage='true';
    overlay.style.cssText='position:absolute!important;inset:0!important;z-index:20!important;pointer-events:none!important;';
    const inner=document.createElement('div');inner.style.cssText=`position:absolute;left:0;top:0;width:${art.viewport[0]}px;height:${art.viewport[1]}px;transform-origin:0 0`;
    inner.appendChild(renderer.createBackground(art,{map:scene.url||scene.image,mask:art.assets.mask.url,heart:art.assets.heart.url}));
    renderer.addTexts(inner,art);overlay.appendChild(inner);poster.appendChild(overlay);
    const resize=()=>{const r=getComputedStyle(overlay);inner.style.transform=`scale(${(Math.round(parseFloat(r.width)*64)/64)/art.viewport[0]},${(Math.round(parseFloat(r.height)*64)/64)/art.viewport[1]})`;};
    poster.__renaoFrozenResize?.disconnect();poster.__renaoFrozenResize=new ResizeObserver(resize);poster.__renaoFrozenResize.observe(overlay);resize();
    poster.dataset.renaoFrozenArtwork='6';
  };

  window.RenaoDesignFile = {
    captureDeferredMapArtwork,
    showDeferredMapArtwork,
    captureMapArtwork,
    layoutMapPrintText,
    prepareForm,
    scheduleForm: schedulePreparedPdfs,
  };

  window.dispatchEvent(new Event('renao:map-renderer-ready'));
  initProofScrollLock();
  initBackgroundPreparation();
  document.querySelectorAll('[data-renao-personalizer]').forEach(root => {
    loadFrozenMapRenderer().catch(()=>{});
    saveMapAsset('renao-heart-transparent.png').catch(()=>{});
    saveMapAsset(root.dataset.renaoProductHandle==='mapplaket'?'renao-mapplaket-mask.png':root.dataset.renaoShape==='heart'?'renao-heart-shape-mask.png':'renao-map-mask.png').catch(()=>{});
    layoutMapPrintText(root, root.querySelector('.renao-map-poster')).catch(error => console.error('Map text:',error));
  });
  // Cache-bust: canonical paid-order raster and proof aspect lock v15.
})();
